//#region Imports
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//MUI
import { Box } from '@mui/material';
import download from '../../../images/downloads.png';
import mepcologo from '../../../images/mepcoLogo.png';
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
//components
// import StatusBar from '../../../components/statusbar/statusbar';

import {
    applicationName,
    companyName,
    convertDatewithTime,
    dBillAPI,
    divisionName,
    documentValidation,
    handleFileUpload,
    printStamp,
    subdivisionName,
    timeFrameNewConnection
} from "../../../services/Functions";
//scss
// import "./Newconnectiontable.scss";
import "../../../style/common.scss";
//react-toastify
import 'react-toastify/dist/ReactToastify.css';
//Yup
import * as Yup from "yup";
//formik
import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
// authorization
// Services
//jspdf
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
//jsbarcode
import JsBarcode from 'jsbarcode';
import { tableStyle } from '../../../style/common';

//pdfjs
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import BasicTable from '../../../components/basicTable/basicTable';
import { useSelector } from 'react-redux';

//#endregion

const ShiftingToNetMeterTable = () => {

    //#region initial values
    const initialValues = {
        iv_objection_Type: 'No Issue',
        iv_objection_Descripton: '',

        //arrears fields
        iv_property_reference_no: '',

        //arears paid bill document field
        iv_arear_paid_bill_document: '',
        iv_arear_paid_bill_date: '',

        //applied load fields
        iv_applied_load: '',

        //dn fields
        iv_distance: 1,
        iv_estimated_distance: 41,
        iv_sketch_diagram: '',
        iv_coverage_area: '3 Marla',
        iv_existing_meters_ref_nos_array: '',
        iv_tariff_to_allot: '',
        iv_meter_rent: 0,
        iv_service_rent: 0,
        iv_surveyed_by: '',
        iv_survey_date: '',
        iv_batch: '',
        iv_reference_to_allot: '',
        iv_industry_factory_type: '',
        iv_bank_name: '',
        iv_connection_account_no: '',
        iv_grid_sharing_cost: 0,
        iv_feeder_rehab_charges: 0,

        // boq fields
        iv_fieldItemId: '',
        iv_fieldItemQty: '',
        iv_fieldItemRate: '',
        iv_fieldItemUnit: '',
        iv_fieldItemAmount: '',
        iv_items_array: '',

        // payment verification fields
        iv_payment_date: '',
        iv_receipt_image: '',

        //sco fields
        iv_fata_pata: '',
        iv_rural_urban: 'U',
        iv_feeder_no: '',
        iv_sub_batch: '',
        iv_fgovt: '',
        iv_cantonment_board: '',
        iv_pgovt: '',
        iv_local_bodies: '',
        iv_authorized_by_name: '',
        iv_date_of_authorization: '',
        iv_store_requisition_no: '',
        iv_store_requisition_date: '',
        iv_sanctioned_load: '',
        iv_seasonal_flag: 1,
        iv_no_of_acs: 0,
        iv_no_of_meters: 0,
        iv_no_of_meter_sets: 0,
        iv_no_of_sub_sets: 0,
        iv_no_ofsupply_points: 0,
        iv_installed_transformer_capacity: '',
        iv_meter_id: '',
        iv_meter_serial_no: '',
        iv_location_code: '',
        iv_meter_code: '',
        iv_manufacturer_code: '',
        iv_multiplying_factor: 1,
        iv_meter_range: '',
        iv_meter_reading: '',
        iv_date_of_connection: '',
        iv_cp_78_item_no: '',
        iv_tie_up_non_tie_up: 1,
        iv_seal_on_meter: '',
        iv_seal_on_box: '',
        iv_security_slip_or_price_bond_no: '',
        iv_connection_installer_name: '',
        iv_meter_type: 0,
        iv_meter_reading_off_peak_kwh: '',
        iv_meter_reading_peak_kwh: '',
        iv_meter_reading_off_peak_kvarh: '',
        iv_meter_reading_peak_kvarh: '',
        iv_ct: '',
        iv_pt: '',
        iv_mdi: '',
        iv_no_of_mdi_resets: '',

        // master data fields
        iv_govt_dept: 0,
        iv_ed_code: '',
        iv_standard_classification_code: '',
        iv_income_tax: 0,
        iv_authority: ''
    }

    //#endregion

    //#region get item local storage 
    const token = JSON.parse(window.localStorage.getItem('user-token'));
    const showAllApplicationsFlag = JSON.parse(window.localStorage.getItem('show-all-applications-flag'));
    const userRole = JSON.parse(window.localStorage.getItem('user-role'));
    const userName = JSON.parse(window.localStorage.getItem('user-name'));
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const officeCode = parseInt(JSON.parse(window.localStorage.getItem('user-office-code')))
    const userHierarchy = parseInt(JSON.parse(window.localStorage.getItem('user-hierarchy')))
    let userCompany = officeCode.slice(0, 2);
     const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
    //#endregion

    //#region states 
    const [objectionType, setObjectionType] = React.useState('');
    const [areaType, setAreaType] = React.useState('');
    const [allTariffList, setAllTariffList] = useState([]);
    const [allFeedersList, setAllFeedersList] = useState([]);
    const [allMaterialList, setAllMaterialList] = useState([]);
    const [standardClassificationCodes, setStandardClassificationCodes] = useState([]);
    const [referenceNumberToAllot, setReferenceNumberToAllot] = useState('');
    const [sketchDiagram, setSketchDiagram] = React.useState();
    const [sketchDiagramThumbnail, setSketchDiagramThumbnail] = React.useState('');
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [alreadyInstalledRefNos, setAlreadyInstalledRefNos] = useState([])
    const [arrearFlag, setArearFlag] = useState(0);
    const [arrearsDetailsRefno, setArrearsDetailsRefno] = useState({
        arrearsAmount: '',
        meterStatus: '',
        tariffDesc: '',
        meterType: '',
        phase: '',
        consumerName: '',
        consumerNo: "",
        consumerAddress: '',
        consumerEmail: '',
    });
    const [phase, setPhase] = useState();
    const [tariff, setTariff] = useState();
    const [refNoAlreadyAllocatedError, setRefNoAlreadyAllocatedError] = useState('');
    const [arrearsDetailsCNIC, setArrearsDetailsCNIC] = useState({
        arrearsAmount: '',
        meterStatus: '',
        tariffDesc: '',
        meterType: '',
        phase: '',
        consumerName: '',
        consumerNo: "",
        consumerAddress: '',
        consumerEmail: '',
    });

    const [arrearsDetailsRefnoToDisplay, setArrearsDetailsRefnoToDisplay] = useState({
        refNo: '',
        arrearsAmount: '',
        meterStatus: '',
        tariffDesc: '',
        meterType: '',
        phase: '',
        consumerName: '',
        consumerNo: "",
        consumerAddress: '',
        consumerEmail: '',
        paidArearImage: '',
        paidArearDate: ''
    });

    const [dnDetails, setDnDetails] = useState({
        demandNoticeNo: "",
        issueDate: "",
        applicationId: "",
        dueDate: "",
        roOfficeAddress: "",
        consumerAccountNo: "",
        batchNo: "",
        voltage: "",
        tariff: "",
        coverageAreaOfPremises: "",
        bankName: "",
        industryFactoryType: "",
        sketchImage: "",
        isDistance40: "",
        connectionAccountNo: "",
        dnPaymentFlag: "",
        paymentMethod: "",
        dnPaymentVerificationFlag: "",
        meterRent: "",
        serviceRent: "",
        sanctionLoad: "",
        surveyedBy: "",
        surveyedDate: "",
        filledBy: "",
        filledDate: "",
        filledFlag: null,
        approvedBy: "",
        approvedDate: "",
        approvedFlag: null,
        paymentDate: '',
        capitalCostAmount: '',
        securityDepositeAmount: ''
    });

    const [scoDetails, setScoDetails] = useState({
        scoId: '',
        applicationId: '',
        scoCreationDate: '',
        urbanRural: '',
        fataPata: '',
        refNo: '',
        feederNo: '',
        batch: '',
        subBatch: '',
        fGovt: '',
        cantonmentBoard: '',
        pGovt: '',
        localBodies: '',
        scoP1FilledBy: '',
        scoP1FillingDate: '',
        scoP1FillFlag: '',
        authorizedByName: '',
        dateOfAuthorization: '',
        scoP1ApprovedFlag: '',
        storeRequisitionNo: '',
        storeRequisitionDate: '',
        seasonalFlag: '',
        senctionLoad: '',
        noOfACs: '',
        noOfMeters: '',
        noOfMeterSets: '',
        noOfSubSets: '',
        noOfSupplyPoints: '',
        installedTransformerCapacity: '',
        meterId: '',
        meterNo: '',
        locationCode: '',
        meterCode: '',
        manufacturerCode: '',
        multiplyingFactor: '',
        meterRange: '',
        meterReading: '',
        dateOfConnection: '',
        cp78ItemNo: '',
        tieUpNonTieUp: '',
        sealOnMeter: '',
        sealOnBox: '',
        securitySlipOrPriceBondNo: '',
        connectionInstallerName: '',
        scoP2FilledBy: '',
        scoP2FillingDate: '',
        scoP2FillFlag: '',
        scoP2ApprovedBy: '',
        scoP2ApprovalDate: '',
        scoP2ApprovalFlag: '',
        installedMeterImage: '',
        meterType: null,
        threePhasePeak: null,
        threePhaseOffPeak: null,
        mdi: null,
        noOfMDIreset: null,
        cT: "",
        pT: "",
        threePhasePeakKVARH: "",
        threePhaseOffPeakKVARH: "",
        threePhasePeakKWH: "",
        threePhaseOffPeakKWH: ""
    });

    const [masterDataFormDetails, setMasterDataFormDetails] = useState({
        applicationId: '',
        electricityDuty: '',
        governmentDepartment: '',
        standardClassificationCode: '',
        incomeTax: '',
        reason: '',
        authority: '',
        filledBy: '',
        filledByDate: '',
        filledByFlag: '',
        approvedBy: '',
        approvalDate: '',
        approvalFlag: ''
    });

    const [partialValue, setPartialValue] = useState('');
    const [noArrears, setNoArrears] = useState('');
    const [flag_copyOfApplicantCNICFront, setFlag_copyOfApplicantCNICFront] = useState(null)
    const [flag_copyOfApplicantCNICBack, setFlag_copyOfApplicantCNICBack] = useState(null)
    const [flag_premisesDocument, setFlag_premisesDocument] = useState(null)
    const [flag_scannedCopyOfNearByElectricityBill, setFlag_scannedCopyOfNearByElectricityBill] = useState(null)
    const [flag_copyOfOwnerCNICFront, setFlag_copyOfOwnerCNICFront] = useState(null)
    const [flag_copyOfOwnerCNICBack, setFlag_copyOfOwnerCNICBack] = useState(null)
    const [flag_ownerNOC, setFlag_ownerNOC] = useState(null)
    const [flag_resolutionFormDesc, setFlag_resolutionFormDesc] = useState(null)
    const [flag_certFormDesc, setFlag_certFormDesc] = useState(null)
    const [flag_certMemoDesc, setFlag_certMemoDesc] = useState(null)
    const [netMeterApplications, setNetMeterApplications] = useState([]);
    const [netMeterApplicationsToDataGrid, setNetMeterApplicationsToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
    const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] = React.useState(false);
    const [arrearsVerifyPopUpOpen, setArrearsVerifyPopUpOpen] = React.useState(false);
    const [docReVerifyAlert, setDocReVerifyAlert] = React.useState(false);

    const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] = useState(false);
    const [propertyDocVerifyPopUp, setPropertyDocVerifyPopUp] = useState(false);
    const [nearByBillVerifyPopUp, setNearByBillVerifyPopUp] = useState(false);
    const [copyOfOwnerCNICVerifyPopUp, setCopyOfOwnerCNICVerifyPopUp] = useState(false);
    const [ownerNOCVerifyPopUp, setOwnerNOCVerifyPopUp] = useState(false);
    const [resolutionFormDescVerifyPopUp, setResolutionFormDescVerifyPopUp] = useState(false);
    const [certFormDescVerifyPopUp, setCertFormDescVerifyPopUp] = useState(false);
    const [certMemoDescVerifyPopUp, setCertMemoDescVerifyPopUp] = useState(false);

    const [paidDNImagePopUp, setPaidDNImagePopUp] = useState(false);

    const [fieldVerifyAlert, setFieldVerifyAlert] = React.useState(false);
    const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
    const [dnPaymentRejectAlert, setDnPaymentRejectAlert] = React.useState(false);
    const [scoPart1ApproveAlert, setScoPart1ApproveAlert] = React.useState(false);
    const [scoPart2ApproveAlert, setScoPart2ApproveAlert] = React.useState(false);
    const [rejectionRemovalAlert, setRejectionRemovalAlert] = React.useState(false);
    const [fieldRejectionRemovalAlert, setFieldRejectionRemovalAlert] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [itemToAddCode, setItemToAddCode] = React.useState();
    const [itemsArray, setItemsArray] = useState([]);
    const [showDNPayment, setShowDNPayment] = useState(true);
    const [dnReceiptImage, setDnReceiptImage] = useState();
    const [dnReceiptImageThumbnail, setDnReceiptImageThumbnail] = useState();
    const [dnImage, setDnImage] = useState()
    const [dnNumber, setDnNumber] = useState()
    const [dnPaymentDate, setDnPaymentDate] = useState()
    const [bankName, setBankName] = useState()
    const [showBoqForm, setShowBoqForm] = useState(false);
    const [itemsAmount, setItemsAmount] = useState();
    const [storeCharges, setStoreCharges] = useState();
    const [transportationCharges, setTransportationCharges] = useState();
    const [installationCharges, setInstallationCharges] = useState();
    const [totalCharges, setTotalCharges] = useState();
    const [showSCOPart1Form, setShowSCOPart1Form] = useState(false);
    const [showSCOPart2Form, setShowSCOPart2Form] = useState(false);
    const [showMasterForm, setShowMasterForm] = useState(false);
    const [standardClassificationCode, setStandardClassificationCode] = useState({ XCLFM_CODE: "", XCLFM_DESC: '' });
    const [eFileData, setEFileData] = useState([]);
    const [eFilePopUp, setEFilePopUp] = useState(false);
    const [showUpdateAppliedLoad, setShowUpdateAppliedLoad] = useState(false);
    const [sketchDiagramUploaded, setSketchDiagramUploaded] = useState();
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    const [foundInNc, setFoundInNc] = useState();
    const [duration, setDuration] = useState(3);
    const [dateFrom, setDateFrom] = useState()
    const [dateTo, setDateTo] = useState();
    const [gridFlag, setGridFlag] = useState(false);
    const [feederRehabFlag, setFeederRehabFlag] = useState(false);
    const [industryFlag, setIndustryFlag] = useState(true);
    const [arearPaidBillDocument, setArearPaidBillDocument] = useState('');
    const [arearPaidBillDocumentThumbnail, setArearPaidBillDocumentThumbnail] = useState('');
    const [installedMeterImage, setInstalledMeterImage] = useState('');
    const [installedMeterImageError, setInstalledMeterImageError] = useState('');
    const [installedMeterImageThumbnail, setInstalledMeterImageThumbnail] = useState('');
    const [meterInstallmentFileName, setMeterInstallmentFileName,] = useState("");
    const [meterInstallmentError, setMeterInstallmentError] = useState('')

    const [ripeAge, setRipeAge] = useState(0);
    const [unripeAge, setUnripeAge] = useState(0);
    const [error, setError] = useState('')
    const [fieldSurveyError, setFieldSurveyError] = useState('')

    const [newConnectionPopup, setNewConnectionPopup] = useState(false);
    const [scoPopUp, setScoPopUp] = useState(false);
    const [cpPopUp, setCpPopUp] = useState(false);


    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },

        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },
    ]
  const { userId, hierarchy, roleId, roleName, permissions, roleTypeId } = useSelector((state) => state.auth)

    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        }])

    // Sub Popup states
    const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] = useState(false);
    const [applicationSubittedPopUp, setApplicationSubmittedPopUp] = useState(false);

    const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
    const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
    const [referenceNoAllocatedSubPopUp, setReferenceNoAllocatedSubPopUp] = useState(false);
    const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] = useState(false);
    const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] = useState(false);
    const [serviceConnectionOrderedSubPopUp, setServiceConnectionOrderedSubPopUp] = useState(false);
    const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);

    const [cnicFrontNumPages, setCNICFrontNumPages] = useState(null);
    const [cnicFrontImageBase64Strings, setCnicFrontImageBase64Strings] = useState(null);
    // const [errorClose, setErrorClose] = useState(false);


    const [fieldSurveyData, setFieldSurveyData] = useState({
        status: "",
        applicationId: "",
        isLTLWI40Flag: null,
        estDistanceInMeter: null,
        sketchDiagram: "",
        areaMarla: "",
        noOfMeterInstalled: null,
        surveyedBy: "",
        surveyDate: "",
        installedMeterRefNos: [
            {
                installedMeterRefNo: ""
            }
        ]
    })

    const [paidDnImageDetails, setPaidDnImageDetails] = useState({
        id: null,
        applicationId: "",
        demandNoticeNo: "",
        paidDNImage: "",
        uploadedBy: "",
        uploadedAt: "",
        paymentDate: "",
        painDNImageVerification: null
    })

    //#endregion

    //#region constants / variables 
    const navigate = useNavigate();

    const fieldObjections = [
        "No Issue",
        "Unelectrified area / No network.",
        "Meters already installed at applied premises.",
        "Invalid address.",
        "Premises / Property is disputed or sub-judice.",
        "Load at site exceeds than applied.",
        "No load / building at site.",
        "Transformer overloaded"
    ]

    const areaMarla = [
        "3 Marla",
        "5 Marla",
        "7 Marla",
        "10 Marla",
        "1 Canal",

    ]

    let batchArray = [
        '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
        '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
        '21', '22', '23', '24', '25', '26', '27', '28', '29', '30',
        '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
        '41', '42', '43', '44', '45', '46',
    ]

    let subBatchArray = [
        '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
        '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
        '21', '22', '23', '24', '25', '26', '27', '28', '29', '30',
        '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
        '41', '42', '43', '44', '45', '46',
    ]

    var remarksToSave = "";

    const tenantStatus = ['tenant', 'Tenant']

    const areaTypeFlags = [
        {
            key: 1,
            value: 'FATA'
        },
        {
            key: 2,
            value: 'PATA'
        },
        {
            key: 3,
            value: 'Urban'
        },
        {
            key: 4,
            value: 'Rural'
        }
    ]

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    let dateTill = new Date();
    dateTill.setDate(1);
    const monthUpto = currentMonth - duration
    dateTill.setMonth(monthUpto);
    dateTill.setHours(0, 0, 0, 0);

    let NCStatusBarArray = [
        {
            title1: 'DOCUMENT',
            title2: 'SUBMISSION',
        },
        {
            title1: 'DOCUMENT',
            title2: 'VERIFICATION',
        },
        {
            title1: 'ARREAR',
            title2: 'VERIFICATION',
        },
        {
            title1: 'FIELD',
            title2: 'SURVEY',
        },
        {
            title1: 'REF. NO',
            title2: 'ALLOCATION',
        },
        {
            title1: 'DN PAYMENT',
            title2: 'SUBMISSION',
        },
        {
            title1: 'DN PAYMENT',
            title2: 'VERIFICATION',
        },
        {
            title1: 'SERVICE',
            title2: 'CONN. ORDER',
        },
        {
            title1: 'METER',
            title2: 'INSTALLATION',
        },
        {
            title1: 'READY FOR',
            title2: 'BILLING',
        },
    ]

    //#endregion

    //#region api function

    const callTariffList = async () => {

        const myHeaders = new Headers()
        myHeaders.append('Authorization', token)

        var requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: myHeaders
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail", requestOptions)
            .then(response => response.json())
            .then(result => {
                setAllTariffList(result.data)
            })
            .catch(error => console.log('error', error));
    }

    const callFeederList = async (feederCode, regCode, gridCode, sDivCode) => {
        var formdata = new FormData();

        formdata.append("feederCode", feederCode);
        formdata.append("rgnCode", regCode);
        formdata.append("gridCode", gridCode);
        formdata.append("sDivCode", sDivCode);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "demandNotice/getFeeders", requestOptions)
            .then(response => response.json())
            .then(result =>
                setAllFeedersList(result.data)
            )
            .catch(error => console.log('error', error));
    }

    const callMaterials = async () => {

        var formdata = new FormData();


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "demandNotice/getMaterial", requestOptions)
            .then(response => response.json())
            .then(result => {
                setAllMaterialList(result.data)
            })
            .catch(error => console.log('error', error));
    }

    const callStandardClassificaitionCodesAPI = async () => {
        var formdata = new FormData();


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "demandNotice/getClassificationCodes", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    setStandardClassificationCodes(result.data)
                }
            })
            .catch(error => console.log('error', error))
    }

    const referenceApi = async () => {
        if (!arearsFormik.values.iv_property_reference_no || arearsFormik.values.iv_property_reference_no.length !== 14) {
            return;
        } else {
            setViewBackdrop(true)
            let apiResponse = await dBillAPI(token, arearsFormik.values.iv_property_reference_no)
            if (apiResponse.status) {
                setError()
                let basicInfo = apiResponse.basicInfo;
                let arrearDetailsObj = {}
                if (basicInfo.arrear != '' && basicInfo.arrear > 0) {
                    setNoArrears('');
                    arrearDetailsObj.arrearsAmount = numberFormatting(basicInfo.arrear)
                    arrearDetailsObj.meterStatus = basicInfo.meter1Status
                    arrearDetailsObj.tariffDesc = basicInfo.tariffDescription
                    arrearDetailsObj.meterType = basicInfo.meterType
                    arrearDetailsObj.phase = basicInfo.phase
                    arrearDetailsObj.consumerName = basicInfo.consumerName
                    arrearDetailsObj.consumerNo = basicInfo.consumerContactNo
                    arrearDetailsObj.consumerAddress = basicInfo.consumerAddress1 + ' ' + basicInfo.consumerAddress2
                    arrearDetailsObj.consumerEmail = basicInfo.consumerEmail
                    setArrearsDetailsRefno(arrearDetailsObj);
                }
                else {
                    let emptyArearObject = {
                        arrearsAmount: '',
                        meterStatus: '',
                        tariffDesc: '',
                        meterType: '',
                        phase: '',
                        consumerName: '',
                        consumerNo: "",
                        consumerAddress: '',
                        consumerEmail: '',
                    }
                    setArrearsDetailsRefno(emptyArearObject);
                    setNoArrears("No arrear exist's for entered reference number.");
                }
            } else if (apiResponse.status == false) {
                setError('No Data Found against this Reference No.')
            } else {
                setError('Reference Number does not exist.')
            }
            setViewBackdrop(false)
        }
    };

    const callingUpdateDocumentStatusAPI = async () => {
        var formdata = new FormData();
        formdata.append("applicationNo", dialogRowData.applicationId);
        if (flag_ownerNOC === null) {
            formdata.append("ownerNOCFlag", "");
        }
        else {
            formdata.append("ownerNOCFlag", flag_ownerNOC);
        }
        formdata.append("premisesDocumentFlag", flag_premisesDocument);
        formdata.append("copyOfApplicantCNICFrontFlag", flag_copyOfApplicantCNICFront);
        formdata.append("copyOfApplicantCNICBackFlag", flag_copyOfApplicantCNICBack);
        if (flag_scannedCopyOfNearByElectricityBill === null) {
            formdata.append("scannedCopyOfNearByElectricityBillFlag", "");
        }
        else {
            formdata.append("scannedCopyOfNearByElectricityBillFlag", flag_scannedCopyOfNearByElectricityBill);
        }
        if (flag_copyOfOwnerCNICFront === null) {
            formdata.append("copyOfOwnerCNICFrontFlag", "");
        }
        else {
            formdata.append("copyOfOwnerCNICFrontFlag", flag_copyOfOwnerCNICFront);
        }
        if (flag_copyOfOwnerCNICBack === null) {
            formdata.append("copyOfOwnerCNICBackFlag", "");
        }
        else {
            formdata.append("copyOfOwnerCNICBackFlag", flag_copyOfOwnerCNICBack);
        }
        if (flag_resolutionFormDesc === null) {
            formdata.append("resolutionFormDescFlag", "");
        }
        else {
            formdata.append("resolutionFormDescFlag", flag_resolutionFormDesc);
        }
        if (flag_certMemoDesc === null) {
            formdata.append("certMemoDescFlag", "");
        }
        else {
            formdata.append("certMemoDescFlag", flag_certMemoDesc);
        }
        if (flag_certFormDesc === null) {
            formdata.append("certFormDescFlag", "");
        }
        else {
            formdata.append("certFormDescFlag", flag_certFormDesc);
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "electricityNewConnection/updateDocumentFlag", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let remarksToSave = 'Documents Objections in: '
                    if (
                        flag_ownerNOC === -1 ||
                        flag_premisesDocument === -1 ||
                        flag_copyOfApplicantCNICFront === -1 ||
                        flag_copyOfApplicantCNICBack === -1 ||
                        flag_copyOfOwnerCNICFront === -1 ||
                        flag_copyOfOwnerCNICBack === -1 ||
                        flag_resolutionFormDesc === -1 ||
                        flag_certFormDesc === -1
                    ) {

                        if (flag_copyOfApplicantCNICFront == -1) {
                            remarksToSave = remarksToSave + " Applicant CNIC Front, "
                        }
                        if (flag_copyOfApplicantCNICBack == -1) {
                            remarksToSave = remarksToSave + " Applicant CNIC Back, "
                        }
                        if (flag_premisesDocument == -1) {
                            remarksToSave = remarksToSave + "Premises Document, "
                        }
                        if (flag_copyOfOwnerCNICFront == -1) {
                            remarksToSave = remarksToSave + "Owner CNIC Front, "
                        }
                        if (flag_copyOfOwnerCNICBack == -1) {
                            remarksToSave = remarksToSave + "Owner CNIC Back, "
                        }
                        if (flag_ownerNOC == -1) {
                            remarksToSave = remarksToSave + "Owner NOC, "
                        }
                        if (flag_resolutionFormDesc == -1) {
                            remarksToSave = remarksToSave + "BoD Resolution Form, "
                        }
                        if (flag_certFormDesc == -1) {
                            remarksToSave = remarksToSave + "Form 29, "
                        }
                        callChangeObjectionStatus(1, remarksToSave, remarksToSave);

                        let lclStrdNewConApp = JSON.parse(window.localStorage.getItem('new-connection-applications'));
                        const index = lclStrdNewConApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                        lclStrdNewConApp[index].copyOfApplicantCNICFrontFlag = flag_copyOfApplicantCNICFront
                        lclStrdNewConApp[index].copyOfApplicantCNICBackFlag = flag_copyOfApplicantCNICBack
                        lclStrdNewConApp[index].premisesDocumentFlag = flag_premisesDocument
                        lclStrdNewConApp[index].scannedCopyOfNearByElectricityBillFlag = flag_scannedCopyOfNearByElectricityBill
                        lclStrdNewConApp[index].copyOfOwnerCNICFrontFlag = flag_copyOfOwnerCNICFront
                        lclStrdNewConApp[index].copyOfOwnerCNICBackFlag = flag_copyOfOwnerCNICBack
                        lclStrdNewConApp[index].ownerNOCFlag = flag_ownerNOC
                        lclStrdNewConApp[index].resolutionFormDescFlag = flag_resolutionFormDesc
                        lclStrdNewConApp[index].certMemoDescFlag = flag_certMemoDesc
                        lclStrdNewConApp[index].certFormDescFlag = flag_certMemoDesc
                        window.localStorage.setItem('new-connection-applications', JSON.stringify(lclStrdNewConApp));
                        setNetMeterApplications(JSON.parse(window.localStorage.getItem('new-connection-applications')));
                        setFlag_copyOfApplicantCNICFront(null)
                        setFlag_copyOfApplicantCNICBack(null)
                        setFlag_premisesDocument(null)
                        setFlag_scannedCopyOfNearByElectricityBill(null)
                        setFlag_copyOfOwnerCNICFront(null)
                        setFlag_copyOfOwnerCNICBack(null)
                        setFlag_ownerNOC(null)
                        setFlag_resolutionFormDesc(null)
                        setFlag_certMemoDesc(null)
                        setFlag_certFormDesc(null)
                    }
                    else {
                        updateProgressIdToDocumentsVerified()
                    }
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));
    }

    const callChangeProgressIdAPI = async (applicationProgressId, status, remarks, remarksDetails = '-', id = dialogRowData.applicationId) => {
        var formdata = new FormData();

        formdata.append("applicationId", id);
        formdata.append("applicationProgressId", applicationProgressId);
        formdata.append("remarks", remarks);
        formdata.append("remarksDetails", remarksDetails);
        formdata.append("lastModifiedBy", userName);


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "comman/changeProgressId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let lclStrdNewConApp = JSON.parse(window.localStorage.getItem('new-connection-applications'));
                    const index = lclStrdNewConApp.findIndex(item => item.applicationId === id);
                    lclStrdNewConApp[index].applicationProgressId = applicationProgressId
                    window.localStorage.setItem('new-connection-applications', JSON.stringify(lclStrdNewConApp));
                    setNetMeterApplications(JSON.parse(window.localStorage.getItem('new-connection-applications')));
                    handleClose()
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));

        setDocReVerifyAlert(false);
        setArrearsVerifyPopUpOpen(false);
        setFieldVerifyAlert(false);
        setOpen(false);
    }

    const callChangeObjectionStatus = async (objectionStatus, remarks, remarksDetails = '-') => {
        const token = JSON.parse(window.localStorage.getItem('user-token'));
        var formdata = new FormData();
        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("objectionStatus", objectionStatus);
        formdata.append("remarks", remarks);
        formdata.append("remarksDetails", remarksDetails);
        formdata.append("lastModifiedBy", userName);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let lclStrdNewConApp = JSON.parse(window.localStorage.getItem('new-connection-applications'));
                    const index = lclStrdNewConApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                    lclStrdNewConApp[index].objectionStatus = objectionStatus
                    lclStrdNewConApp[index].remarks = remarks
                    window.localStorage.setItem('new-connection-applications', JSON.stringify(lclStrdNewConApp));
                    setNetMeterApplications(JSON.parse(window.localStorage.getItem('new-connection-applications')));
                    setOpen(false);
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));

        setDocReVerifyAlert(false);
        setRejectionRemovalAlert(false);
        setObjectionPopUpOpen(false);
        setFieldRejectionRemovalAlert(false);
    }

    const callResetObjectionStatus = async (applicationId) => {
        const token = JSON.parse(window.localStorage.getItem('user-token'));
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(cfpBaseUrl + "electricityNewConnection/resetObjectionStatus", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let lclStrdNewConApp = JSON.parse(window.localStorage.getItem('new-connection-applications'));
                    const index = lclStrdNewConApp.findIndex(item => item.applicationId === applicationId);
                    lclStrdNewConApp[index].objectionStatus = 2
                    window.localStorage.setItem('new-connection-applications', JSON.stringify(lclStrdNewConApp));
                    setNetMeterApplications(JSON.parse(window.localStorage.getItem('new-connection-applications')));
                    // setDialogRowData(lclStrdNewConApp[index])
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));

    }

    const callSCOCreationAPI = async (applicationId) => {
        if (applicationId) {
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);
            formdata.append("paidDNImageVerifiedBy", userName);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "sco/scoCreation", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        callChangeProgressIdAPI(8, "DN Payment Verified", "DN Payment Verified")
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error => {
                    console.log(error)
                });
        }
    }

    const callSCOApprovePart1API = async (scoId) => {
        var formdata = new FormData();
        formdata.append("scoId", scoId);
        formdata.append("authorizedByName", userName);
        formdata.append("scoP1ApprovedFlag", 1);


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "sco/scoP1Approval", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    // console.log(result.message)
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error =>
                console.log(error)
            );
    }

    const callSCOApprovePart2API = async (scoId) => {
        var formdata = new FormData();
        formdata.append("scoId", scoId);
        formdata.append("scoP2ApprovedBy", userName);
        formdata.append("scoP2ApprovalFlag", 1);


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "sco/scoP2Approval", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    // console.log(result.message)
                    var formdata = new FormData();
                    formdata.append("applicationId", dialogRowData.applicationId);
                    formdata.append("cp136Type", 1);


                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow'
                    };
                    fetch(cfpBaseUrl + "cpForm136/cp136Creation", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.status === "200") {
                                callChangeProgressIdAPI(9, 'Meter Installed', "Meter Installed")
                                // console.log(result.message)
                            }
                            else {
                                console.log(result.message)
                            }
                        })
                        .catch(error => {
                            console.log(error)
                        });
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error =>
                console.log(error)
            );
    }

    const callGetSCOAPI = async (applicationId, phase) => {
        try {
            let scoDets = ''
            if (applicationId) {
                var formdata = new FormData();
                formdata.append("applicationId", applicationId);
                formdata.append("scoId", "");


                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow'
                };

                await fetch(cfpBaseUrl + "sco/scoDetails", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            setScoDetails(
                                result.data[0]
                            )
                            if (result.data[0].scoP1FillFlag === 1) {
                                scoPart1Formik.values.iv_feeder_no = result.data[0].feederNo
                                scoPart1Formik.values.iv_batch = result.data[0].batch
                                scoPart1Formik.values.iv_sub_batch = result.data[0].subBatch
                                scoPart1Formik.values.iv_fata_pata = result.data[0].fataPata
                                scoPart1Formik.values.iv_rural_urban = result.data[0].urbanRural
                                scoPart1Formik.values.iv_fgovt = result.data[0].fGovt
                                scoPart1Formik.values.iv_cantonment_board = result.data[0].cantonmentBoard
                                scoPart1Formik.values.iv_pgovt = result.data[0].pGovt
                                scoPart1Formik.values.iv_local_bodies = result.data[0].localBodies
                            } else {

                            }
                            if (result.data[0].scoP2FillFlag === 1) {
                                scoPart2Formik.values.iv_store_requisition_no = result.data[0].storeRequisitionNo
                                scoPart2Formik.values.iv_store_requisition_date = result.data[0].storeRequisitionDate.slice(0, 10)
                                scoPart2Formik.values.iv_seasonal_flag = result.data[0].seasonalFlag
                                scoPart2Formik.values.iv_no_of_acs = result.data[0].noOfACs
                                scoPart2Formik.values.iv_no_of_meters = result.data[0].noOfMeters
                                scoPart2Formik.values.iv_no_of_meter_sets = result.data[0].noOfMeterSets
                                scoPart2Formik.values.iv_no_of_sub_sets = result.data[0].noOfSubSets
                                scoPart2Formik.values.iv_no_ofsupply_points = result.data[0].noOfSupplyPoints
                                scoPart2Formik.values.iv_installed_transformer_capacity = result.data[0].installedTransformerCapacity
                                scoPart2Formik.values.iv_meter_id = result.data[0].meterId
                                scoPart2Formik.values.iv_meter_serial_no = result.data[0].meterNo
                                scoPart2Formik.values.iv_location_code = result.data[0].locationCode
                                scoPart2Formik.values.iv_meter_code = result.data[0].meterCode
                                scoPart2Formik.values.iv_manufacturer_code = result.data[0].manufacturerCode
                                scoPart2Formik.values.iv_multiplying_factor = result.data[0].multiplyingFactor
                                scoPart2Formik.values.iv_meter_range = result.data[0].meterRange
                                scoPart2Formik.values.iv_meter_reading = result.data[0].meterReading
                                scoPart2Formik.values.iv_date_of_connection = result.data[0].dateOfConnection
                                scoPart2Formik.values.iv_cp_78_item_no = result.data[0].cp78ItemNo
                                scoPart2Formik.values.iv_tie_up_non_tie_up = result.data[0].tieUpNonTieUp
                                scoPart2Formik.values.iv_seal_on_meter = result.data[0].sealOnMeter
                                scoPart2Formik.values.iv_seal_on_box = result.data[0].sealOnBox
                                scoPart2Formik.values.iv_security_slip_or_price_bond_no = result.data[0].securitySlipOrPriceBondNo
                                scoPart2Formik.values.iv_connection_installer_name = result.data[0].connectionInstallerName
                                scoPart2Formik.values.iv_installed_meter_image = result.data[0].installedMeterImage
                                scoPart2Formik.values.iv_meter_type = result.data[0].meterType
                                if (phase == "3 Phase") {
                                    scoPart2Formik.values.iv_meter_reading_peak_kwh = result.data[0].threePhasePeak
                                    scoPart2Formik.values.iv_meter_reading_off_peak_kwh = result.data[0].threePhaseOffPeak
                                } else {
                                    scoPart2Formik.values.iv_meter_reading_peak_kwh = result.data[0].threePhasePeakKWH
                                    scoPart2Formik.values.iv_meter_reading_off_peak_kwh = result.data[0].threePhaseOffPeakKWH
                                }
                                scoPart2Formik.values.iv_mdi = result.data[0].mdi
                                scoPart2Formik.values.iv_no_of_mdi_resets = result.data[0].noOfMDIreset
                                scoPart2Formik.values.iv_ct = result.data[0].cT
                                scoPart2Formik.values.iv_pt = result.data[0].pT
                                scoPart2Formik.values.iv_meter_reading_peak_kvarh = result.data[0].threePhasePeakKVARH
                                scoPart2Formik.values.iv_meter_reading_off_peak_kvarh = result.data[0].threePhaseOffPeakKVARH
                                setInstalledMeterImageThumbnail(result.data[0].installedMeterImage)
                            } else {

                            }
                            scoDets = result.data[0];
                        }
                        else {
                            // console.log("NO SCO")
                        }
                    })
                    .catch(error => console.log('error', error));
            }
            return scoDets
        }
        catch (e) {
            console.log(e, 'Unable to get SCO Details');
        }
    }

    const callGetCP136API = async (applicationId) => {

        try {
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        setMasterDataFormDetails(result.data[0])
                        if (result.data[0].filledByFlag === 1) {
                            masterDataFormik.values.iv_govt_dept = result.data[0].governmentDepartment
                            masterDataFormik.values.iv_ed_code = result.data[0].electricityDuty
                            masterDataFormik.values.iv_standard_classification_code = result.data[0].standardClassificationCode
                            let sc = standardClassificationCodes.find(item => item.XCLFM_CODE === result.data[0].standardClassificationCode)
                            setStandardClassificationCode(sc)
                            masterDataFormik.values.iv_income_tax = result.data[0].incomeTax
                        }
                    }
                })
                .catch(error => console.log('error', error));
        }
        catch (e) {
            console.log(e, 'Unable to get Master Form Data!')
        }
    }

    const callApproveCP136API = async (applicationId) => {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        formdata.append("approvedBy", userName);
        formdata.append("approvalFlag", 1);


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "cpForm136/cpForm136Approval", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    callChangeProgressIdAPI(10, 'Application Completed', 'Application Completed')
                    // console.log(result.message)
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => {
                console.log(error)
            });
    }

    const callEfileAPI = async (applicationId) => {

        let application = netMeterApplications.find((item) => { return item.applicationId === applicationId })
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "electricityNewConnection/getApplicationHist", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    let applicationCurrentState = result.applicationCurrentState[0]
                    let applicationHistory = result.applicationHistory
                    if (applicationHistory === "No History Found") {
                        applicationHistory = []
                    }

                    applicationHistory.push(applicationCurrentState)
                    let sortedApplicationHistory = applicationHistory.sort((a, b) => {
                        const dateA = new Date(a.lastModificationDate)
                        const dateB = new Date(b.lastModificationDate)
                        return dateB - dateA
                    });

                    setEFileData(sortedApplicationHistory)

                    let dataforTable = []


                    sortedApplicationHistory.forEach(item => {
                        if (item.applicationProgressId !== 0 && item.lastModifiedBy && item.lastModificationDate) {
                            let object = {}
                            object.stepName = stepName(item.applicationProgressId)
                            object.processedBy = item.lastModifiedBy ? item.lastModifiedBy : 'Last Modified By Name'
                            object.date = item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'Last Modification Time'
                            object.remarks = item.remarks ? item.remarks : '-'
                            dataforTable.push(object)
                        }
                    })

                    dataforTable.push({
                        date: convertDate(application.creationDate),
                        processedBy: application.applicantName,
                        stepName: "Application Submitted",
                        time: convertDatewithTime(application.creationDate).slice(11, 17),
                        remarks: '-'
                    })

                    setTableDataProcessingSummary(dataforTable);
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => console.log('error', error));
    }

    const callApproveFieldAPI = async (applicationId) => {
        var formdata = new FormData();

        formdata.append("approvedBy", userName);
        formdata.append("approvedFlag", 1);
        formdata.append("applicationNo", applicationId);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'PUT',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "demandNotice/approveFeildVerification", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    callChangeProgressIdAPI(5, "Demand Notice Created", "Demand Notice Created");
                    callSCOApprovePart1API(scoDetails.scoId);
                }
                else {
                    console.log(result.message)
                }
            })
            .catch(error => {
                console.log(error)
            });
    }

    const callAsyncDnDetailsAPI = async (applicationId) => {
        try {

            let dnDets = {}

            var formdata = new FormData();
            formdata.append("applicationNo", applicationId);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "demandNotice/getDemandNoticeData", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        dnDets = result.data[0]
                        setDnDetails(result.data[0])
                    }
                }).catch(error => console.log('error', error));
            return dnDets
        }
        catch (e) {
            console.log(e, 'Unable to get Demand Notice.')
        }
    }

    const callAsyncGetSCOAPI = async (applicationId) => {
        try {
            let scoDets = {}
            if (applicationId) {
                var formdata = new FormData();
                formdata.append("applicationId", applicationId);
                formdata.append("scoId", "");
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);


                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow'
                };

                await fetch(cfpBaseUrl + "sco/scoDetails", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            scoDets = result.data[0]
                            setScoDetails(result.data[0])
                        }
                    })
                    .catch(error => console.log('error', error));
                return scoDets
            }
        }
        catch (e) {
            console.log(e, 'Unable to get SCO Details');
        }
    }

    const callAsyncGetCP136API = async (applicationId) => {
        try {

            let cpDets = {}
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        cpDets = result.data[0]
                    }
                })
                .catch(error => console.log('error', error));

            return cpDets
        }
        catch (e) {
            console.log(e, 'Unable to get Master Form Data!')
        }
    }

    const callAsyncGetDocumentsAPI = async (applicationId) => {
        try {

            let appDocs = {}
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "electricityNewConnection/getDocuments", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        appDocs = result.images[0]
                    }
                })
                .catch(error => console.log('error', error));

            return appDocs
        }
        catch (e) {
            console.log(e, 'Unable to get Master Form Data!')
        }
    }

    const callAsyncGetPaidDnImageAPI = async (applicationId) => {
        try {
            let dnImage = ''
            var formdata = new FormData();

            formdata.append("applicationNo", applicationId);
            formdata.append("demandNoticeNo", '');

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        setPaidDnImageDetails(result.data[0])
                        dnImage = result.data[0].paidDNImage
                    }
                })
                .catch(error => console.log('error', error));
            console.log(dnImage, 'printing in async function.')
            return dnImage
        }
        catch (e) {
            console.log(e, 'Error in calling paid dn image')
        }
    }

    const callAsyncFieldSurveyInformation = async (applicationId) => {
        if (applicationId) {
            var formdata = new FormData();
            formdata.append("applicationId", applicationId);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            fetch(cfpBaseUrl + "demandNotice/getFieldSurvey", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        fieldFormik.values.iv_distance = result.isLTLWI40Flag
                        fieldFormik.values.iv_estimated_distance = result.estDistanceInMeter
                        setSketchDiagramThumbnail(result.sketchDiagram)
                        fieldFormik.values.iv_coverage_area = result.areaMarla
                        fieldFormik.values.iv_no_of_meters_already_installed = result.noOfMeterInstalled
                        let existingReferenceNumbers = result.installedMeterRefNos
                        existingReferenceNumbers.map((item) => (
                            item.actualFlag = null
                        ))
                        setAlreadyInstalledRefNos(existingReferenceNumbers)
                        setFieldSurveyData(result)
                    }
                })
                .catch(error => console.log('error', error));
        }
    }

    const deleteFieldSurvey = async (applicationId = dialogRowData.applicationId) => {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "demandNotice/deleteFeildSurveyAndDNData", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    callDeleteSCOAPI(applicationId)
                    callAsyncResetDocsFlags(applicationId)
                    callChangeProgressIdAPI(1, "Reference Number Allocation Objection", formik.values.iv_objection_Type, formik.values.iv_objection_Type)
                    setDnDetails(!dnDetails.filledFlag)
                }
                else {
                    setError(result.message)
                }
            })
    }

    const callDeleteSCOAPI = async (applicationId) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("applicationId", applicationId);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        await fetch(cfpBaseUrl + "sco/deleteSCO", requestOptions)
            .then((response) => response.json())
            .then((result) => {

            })
            .catch((error) => console.error(error));
    }

    const updateSco1Flag = async (applicationId = dialogRowData.applicationId, scoId = scoDetails.scoId) => {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        formdata.append("scoId", scoId);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "sco/updateSCOPart1Flag", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    callChangeProgressIdAPI(7, "SCO. Part1 Rejected", "SCO. Part1 Rejected")
                    setScoDetails(scoDetails.scoP1FillFlag === null)

                }
                else {
                    setError(result.message)
                }
            })






    }

    const updateCpFlag = async (applicationId = dialogRowData.applicationId) => {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "cpForm136/updateCP136Flag", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    callChangeProgressIdAPI(9, "CP 136 Rejected", "CP 136 Rejection")
                    setMasterDataFormDetails(masterDataFormDetails.filledByFlag === null)

                }
                else {
                    setError(result.message)
                }
            })






    }

    const callAsyncResetDocsFlags = async (applicationId = dialogRowData.applicationId) => {
        var formdata = new FormData();
        formdata.append("applicationNo", applicationId);
        formdata.append("ownerNOCFlag", "");
        formdata.append("premisesDocumentFlag", "");
        formdata.append("copyOfApplicantCNICFrontFlag", "");
        formdata.append("copyOfApplicantCNICBackFlag", "");
        formdata.append("scannedCopyOfNearByElectricityBillFlag", "");
        formdata.append("copyOfOwnerCNICFrontFlag", "");
        formdata.append("copyOfOwnerCNICBackFlag", "");
        formdata.append("resolutionFormDescFlag", "");
        formdata.append("certMemoDescFlag", "");
        formdata.append("certFormDescFlag", "");


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch(cfpBaseUrl + "electricityNewConnection/updateDocumentFlag", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    let allApplications = netMeterApplications
                    let index = netMeterApplications.findIndex((item) => item.applicationId === applicationId)
                    allApplications[index].copyOfApplicantCNICBackFlag = null
                    allApplications[index].copyOfApplicantCNICFrontFlag = null
                    allApplications[index].premisesDocumentFlag = null
                    allApplications[index].scannedCopyOfNearByElectricityBillFlag = null
                    allApplications[index].copyOfOwnerCNICFrontFlag = null
                    allApplications[index].copyOfOwnerCNICBackFlag = null
                    allApplications[index].resolutionFormDescFlag = null
                    allApplications[index].certMemoDescFlag = null
                    allApplications[index].certFormDescFlag = null
                    window.localStorage.setItem('new-connection-applications', JSON.stringify(allApplications))
                    // setNetMeterApplications(allApplications)
                }
                else {
                    console.log('Application Documents flags reset has been failed!')
                }
            })
            .catch(error => console.log('error', error));
    }
    //#endregion

    //#region functions

    const updateDocFlag = (documentName, value) => {
        switch (documentName) {
            case 'copyOfApplicantCNIC':
                setFlag_copyOfApplicantCNICFront(value);
                setFlag_copyOfApplicantCNICBack(value);
                setCopyOfApplicantCNICVerifyPopUp(false);
                break;
            case 'premisesDocument':
                setFlag_premisesDocument(value);
                setPropertyDocVerifyPopUp(false);
                break
            case 'scannedCopyOfNearByElectricityBill':
                setFlag_scannedCopyOfNearByElectricityBill(value);
                setNearByBillVerifyPopUp(false);
                break
            case 'copyOfOwnerCNIC':
                setFlag_copyOfOwnerCNICFront(value);
                setFlag_copyOfOwnerCNICBack(value);
                setCopyOfOwnerCNICVerifyPopUp(false);
                break
            case 'ownerNOC':
                setFlag_ownerNOC(value);
                setOwnerNOCVerifyPopUp(false);
                break
            case 'resolutionFormDesc':
                setFlag_resolutionFormDesc(value);
                setResolutionFormDescVerifyPopUp(false);
                break
            case 'certFormDesc':
                setFlag_certFormDesc(value);
                setCertFormDescVerifyPopUp(false)
                break
            case 'certMemoDesc':
                setFlag_certMemoDesc(value);
                setCertMemoDescVerifyPopUp(false);
                break
            default:
                break
        }
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                    console.warn('Invalid code format:', code);
                }
            }
        },
        minLength: 4, // EAN13
    });

    const SketchDiagram = (event) => {
        fieldFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            // console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "sketchDiagram." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setSketchDiagram(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setSketchDiagramThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const ObjectionType = (event) => {
        formik.values.iv_objection_Type = event.target.value;
        setObjectionType(event.target.value)
    };

    const AreaType = (event) => {
        formik.values.iv_coverage_area = event.target.value;
        setAreaType(event.target.value)
    };

    const handleClose = () => {
        //applied load field
        appliedLoadFormik.resetForm();
        appliedLoadFormik.values.iv_applied_load = '';
        //field verification fields 
        fieldItemFormik.resetForm();
        fieldFormik.resetForm();
        fieldFormik.values.iv_coverage_area = '';
        fieldFormik.values.iv_sanctioned_load = '';
        fieldFormik.values.iv_batch = '';
        fieldFormik.values.iv_reference_to_allot = '';
        fieldFormik.values.iv_meter_rent = 0;
        fieldFormik.values.iv_service_rent = 0;
        arearsFormik.resetForm()
        setArearFlag(0);
        setArearPaidBillDocument('');
        setArearPaidBillDocumentThumbnail('');
        arearBillDocumentFormik.values.iv_arear_paid_bill_document = '';
        arearBillDocumentFormik.values.iv_arear_paid_bill_date = '';
        formik.resetForm();
        setObjectionType('');
        setAreaType('')
        setAlreadyInstalledRefNos([]);
        setGridFlag(false);
        setFeederRehabFlag(false);
        setFeederRehabFlag(false);
        refNoAllocationFormik.resetForm();

        fieldFormik.values.iv_grid_sharing_cost = 0;
        fieldFormik.values.iv_feeder_rehab_charges = 0;
        fieldFormik.values.iv_tariff_to_allot = '';
        fieldFormik.values.iv_survey_date = '';
        fieldFormik.values.iv_surveyed_by = '';
        dnPymentReceiptFormik.resetForm()
        setDnReceiptImage('');
        setDnReceiptImageThumbnail('');
        scoPart1Formik.resetForm();
        scoPart1Formik.values.iv_feeder_no = '';
        scoPart1Formik.values.iv_cantonment_board = '';
        scoPart1Formik.values.iv_fgovt = '';
        scoPart1Formik.values.iv_pgovt = '';
        scoPart1Formik.values.iv_local_bodies = '';
        scoPart1Formik.values.iv_batch = '';
        scoPart1Formik.values.iv_sub_batch = '';
        scoPart2Formik.resetForm();
        scoPart2Formik.values.iv_store_requisition_no = '';
        scoPart2Formik.values.iv_store_requisition_date = '';
        scoPart2Formik.values.iv_sanctioned_load = '';
        scoPart2Formik.values.iv_no_of_meters = 0;
        scoPart2Formik.values.iv_no_of_acs = 0;
        scoPart2Formik.values.iv_no_of_meter_sets = 0;
        scoPart2Formik.values.iv_no_of_sub_sets = 0;
        scoPart2Formik.values.iv_no_ofsupply_points = 0;
        scoPart2Formik.values.iv_installed_transformer_capacity = '';
        scoPart2Formik.values.iv_seasonal_flag = 1;
        scoPart2Formik.values.iv_meter_id = '';
        scoPart2Formik.values.iv_meter_serial_no = '';
        scoPart2Formik.values.iv_location_code = '';
        scoPart2Formik.values.iv_meter_code = '';
        scoPart2Formik.values.iv_manufacturer_code = '';
        scoPart2Formik.values.iv_multiplying_factor = '';
        scoPart2Formik.values.iv_meter_range = '';
        scoPart2Formik.values.iv_meter_reading = '';
        scoPart2Formik.values.iv_seal_on_meter = '';
        scoPart2Formik.values.iv_seal_on_box = '';
        scoPart2Formik.values.iv_connection_installer_name = '';
        scoPart2Formik.values.iv_date_of_connection = '';
        scoPart2Formik.values.iv_cp_78_item_no = '';
        scoPart2Formik.values.iv_security_slip_or_price_bond_no = '';
        scoPart2Formik.values.iv_tie_up_non_tie_up = 0;
        setInstalledMeterImage('')
        setInstalledMeterImageThumbnail('')
        masterDataFormik.resetForm();
        arearsFormik.values.iv_property_reference_no = '';
        masterDataFormik.values.iv_govt_dept = 0;
        masterDataFormik.values.iv_income_tax = 0;
        masterDataFormik.values.iv_standard_classification_code = '';
        setStandardClassificationCode({ XCLFM_CODE: "", XCLFM_DESC: "" })
        setStoreCharges();
        setItemsAmount();
        setSketchDiagram();
        setSketchDiagramUploaded();
        setSketchDiagramThumbnail();
        setInstallationCharges();
        setTransportationCharges();
        setError('')
        setArrearsDetailsRefno({
            arrearsAmount: '',
            meterStatus: '',
            tariffDesc: '',
            meterType: '',
            phase: '',
            consumerName: '',
            consumerNo: "",
            consumerAddress: '',
            consumerEmail: '',
        })

        setArrearsDetailsCNIC({
            arrearsAmount: '',
            meterStatus: '',
            tariffDesc: '',
            meterType: '',
            phase: '',
            consumerName: '',
            consumerNo: "",
            consumerAddress: '',
            consumerEmail: '',
        });

        setArrearsDetailsRefnoToDisplay({
            refNo: '',
            arrearsAmount: '',
            meterStatus: '',
            tariffDesc: '',
            meterType: '',
            phase: '',
            consumerName: '',
            consumerNo: "",
            consumerAddress: '',
            consumerEmail: '',
            paidArearImage: '',
            paidArearDate: ''
        });

        setDnDetails({
            demandNoticeNo: "",
            issueDate: "",
            applicationId: "",
            dueDate: "",
            roOfficeAddress: "",
            consumerAccountNo: "",
            batchNo: "",
            voltage: "",
            tariff: "",
            coverageAreaOfPremises: "",
            bankName: "",
            industryFactoryType: "",
            sketchImage: "",
            isDistance40: "",
            connectionAccountNo: "",
            dnPaymentFlag: "",
            paymentMethod: "",
            dnPaymentVerificationFlag: "",
            meterRent: "",
            serviceRent: "",
            sanctionLoad: "",
            surveyedBy: "",
            surveyedDate: "",
            filledBy: "",
            filledDate: "",
            filledFlag: "",
            approvedBy: "",
            approvedDate: "",
            approvedFlag: "",
            amountOfGridSharing: "",
            amountOfFeederRehab: "",
            paymentDate: '',
            capitalCostAmount: '',
            securityDepositeAmount: ''
        });
        setScoDetails({
            scoId: '',
            applicationId: '',
            scoCreationDate: '',
            urbanRural: '',
            refNo: '',
            fataPata: '',
            feederNo: '',
            batch: '',
            subBatch: '',
            fGovt: '',
            cantonmentBoard: '',
            pGovt: '',
            localBodies: '',
            scoP1FilledBy: '',
            scoP1FillingDate: '',
            scoP1FillFlag: '',
            authorizedByName: '',
            dateOfAuthorization: '',
            scoP1ApprovedFlag: '',
            storeRequisitionNo: '',
            storeRequisitionDate: '',
            seasonalFlag: '',
            senctionLoad: '',
            noOfACs: '',
            noOfMeters: '',
            noOfMeterSets: '',
            noOfSubSets: '',
            noOfSupplyPoints: '',
            installedTransformerCapacity: '',
            meterId: '',
            meterNo: '',
            locationCode: '',
            meterCode: '',
            manufacturerCode: '',
            multiplyingFactor: '',
            meterRange: '',
            meterReading: '',
            dateOfConnection: '',
            cp78ItemNo: '',
            tieUpNonTieUp: '',
            sealOnMeter: '',
            sealOnBox: '',
            securitySlipOrPriceBondNo: '',
            connectionInstallerName: '',
            scoP2FilledBy: '',
            scoP2FillingDate: '',
            scoP2FillFlag: '',
            scoP2ApprovedBy: '',
            scoP2ApprovalDate: '',
            scoP2ApprovalFlag: '',
            installedMeterImage: ''
        });
        setDialogRowData(prevObject => ({
            ...prevObject,
            "copyOfApplicantCNICFront": '',
            "copyOfApplicantCNICBack": '',
            "premisesDocument": '',
            "scannedCopyOfNearByElectricityBill": '',
            "copyOfOwnerCNICFront": '',
            "copyOfOwnerCNICBack": '',
            "ownerNOC": '',
            "resolutionFormDesc": '',
            "certFormDesc": '',
            "certMemoDesc": '',
        }));
        setTotalCharges();
        setReferenceNumberToAllot();
        setItemsArray([]);
        setItemToAddCode();
        setBankName();
        setShowBoqForm(false);
        setShowSCOPart1Form(false);
        setShowSCOPart2Form(false);
        setShowMasterForm(false);
        setShowUpdateAppliedLoad(false);
        setFoundInNc()
        setOpen(false);
        setEFileData([]);
    };

    const showArrearsEntryPopup = () => {
        setArrearsEntryPopUpOpen(true);
    }

    const showObjectionPopup = () => {
        setObjectionPopUpOpen(true);
    };

    const hideObjectionPopup = () => {
        formik.handleReset()
        setObjectionPopUpOpen(false);
    };

    const hideCopyOfApplicantCNICVerifyAlert = (x) => {
        setCopyOfApplicantCNICVerifyPopUp(x);
    }

    const hidePropertyDocVerifyAlert = (x) => {
        setPropertyDocVerifyPopUp(x);
    }

    const hideNearByBillVerifyAlert = (x) => {
        setNearByBillVerifyPopUp(x);
    }

    const hideCopyOfOwnerCNICVerifyAlert = (x) => {
        setCopyOfOwnerCNICVerifyPopUp(x);
    }

    const hideOwnerNocVerifyAlert = (x) => {
        setOwnerNOCVerifyPopUp(x);
    }

    const hideResolutionFormDescVerifyAlert = (x) => {
        setResolutionFormDescVerifyPopUp(x);
    }

    const hideCertFormDescVerifyAlert = (x) => {
        setCertFormDescVerifyPopUp(x);
    }

    const hideCertMemoDescVerifyAlert = (x) => {
        setCertMemoDescVerifyPopUp(x);
    }

    const hidePaidDnImagePopUp = (x) => {
        setPaidDNImagePopUp(x);
    }

    const hideDnPaymentVerifyAlert = () => {
        setDnPaymentVerifyAlert(false);
    }

    const hideDnPaymentRejectAlert = () => {
        setDnPaymentRejectAlert(false);
    }

    const hideSCOPart1ApproveAlert = () => {
        setScoPart1ApproveAlert(false);
    }

    const hideSCOPart2ApproveAlert = () => {
        setScoPart2ApproveAlert(false);
    }

    const showRejectionRemovalAlert = () => {
        setRejectionRemovalAlert(true);
    }

    const showFieldRejectionRemovalAlert = () => {
        setFieldRejectionRemovalAlert(true);
    }

    const hideRejectionRemovalAlert = () => {
        setRejectionRemovalAlert(false);
    }

    const hideFieldRejectionRemovalAlert = () => {
        setFieldRejectionRemovalAlert(false);
    }

    const hideArrearsEntryAlert = () => {
        // setArrearsDetailsRefno({
        //   arrearsAmount: '',
        //   meterStatus: '',
        //   tariffDesc: '',
        //   meterType: '',
        //   phase: '',
        //   consumerName: '',
        //   consumerNo: '',
        //   consumerAddress: '',
        //   consumerEmail: '',
        // })
        // setNoArrears('');
        // arearsFormik.resetForm()
        // arearsFormik.values.iv_property_reference_no = ""
        setArrearsEntryPopUpOpen(false);
    }

    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Completed") {
            return 'completed-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
    }

    const filterNCApp = (applicationId) => {

        const myArray = netMeterApplications

        let itemFound = myArray.find(item => item.applicationId === applicationId)

        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const apiToDataGridConversion = async () => {
        try {
            setViewBackdrop(true)
            let tfNc = await timeFrameNewConnection(token)
            let nmApps = netMeterApplications

            function calculateTimeStatus(newConnectionArray, timeFrameNewConnection) {
                // Iterate through each object in newConnectionArray
                newConnectionArray.forEach(connection => {
                    // Find the relevant time frame object
                    const timeFrame = timeFrameNewConnection.find(frame => {
                        return frame.progressId === connection.applicationProgressId &&
                            connection.appliedLoad >= frame.loadFrom &&
                            connection.appliedLoad <= frame.loadTo;
                    });

                    // If a relevant time frame is found
                    if (timeFrame) {
                        // Calculate the duration between lastModificationDate and current date in days
                        let dateOfComparison = ''

                        if (connection.lastModificationDate) {
                            dateOfComparison = new Date(connection.lastModificationDate);
                        } else {
                            dateOfComparison = new Date(connection.creationDate)
                        }
                        const currentDate = new Date();
                        const durationInDays = Math.ceil((currentDate - dateOfComparison) / (1000 * 60 * 60 * 24));
                        // If the duration exceeds the allowedNoOfDays
                        if (durationInDays > timeFrame.allowedNoOfDays) {
                            // Set inTime to false and calculate exceededDuration
                            connection.inTime = false;
                            connection.exceededDuration = durationInDays - timeFrame.allowedNoOfDays;
                        } else {
                            // Set inTime to true and exceededDuration to 0
                            connection.inTime = true;
                            connection.exceededDuration = 0;
                        }

                    } else {
                        // If no relevant time frame is found, set inTime to undefined and exceededDuration to undefined
                        connection.inTime = undefined;
                        connection.exceededDuration = undefined;
                    }
                });
            }

            calculateTimeStatus(nmApps, tfNc);

            let sortedData = nmApps.sort((a, b) => {
                const dateA = new Date(a.creationDate);
                const dateB = new Date(b.creationDate);
                return dateB - dateA;
            });

            const tempArray = []
            if (sortedData) {
                sortedData.forEach((item) => {
                    let dataGridObject = {}
                    if (item.applicationId) {
                        if (item.objectionStatus === 0 || item.objectionStatus === 2) {
                            dataGridObject = {
                                "applicationId": item.applicationId,
                                "creationDate": convertDate(item.creationDate),
                                "lastModificationDate": convertDate(item.lastModificationDate),
                                "dGInstalledCapacity": item.dGInstalledCapacity,
                                "applicantName": item.applicantName,
                                "applicantCNIC": item.consumerCNIC,
                                "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                                "applicationProgressId": progFunc(item.applicationProgressId),
                                "inTime": item.inTime,
                                "exceededDuration": item.exceededDuration
                            }
                        }
                        else if (item.objectionStatus === 1) {
                            dataGridObject = {
                                "applicationId": item.applicationId,
                                "creationDate": convertDate(item.creationDate),
                                "lastModificationDate": convertDate(item.lastModificationDate),
                                "dGInstalledCapacity": item.dGInstalledCapacity,
                                "applicantName": item.applicantName,
                                "applicantCNIC": item.consumerCNIC,
                                "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                                "applicationProgressId": item.remarks,
                                "inTime": item.inTime,
                                "exceededDuration": item.exceededDuration
                            }
                        }
                        tempArray.push(dataGridObject)
                    }
                })
            }
            else {
                const dataGridObject = {
                    "applicationId": ' ',
                    "dGInstalledCapacity": '',
                    "applicantName": ' ',
                    "applicantCNIC": ' ',
                    "applicationStatusId": statusFunc(' '),
                }
                tempArray.push(dataGridObject)
            }
            setNetMeterApplicationsToDataGrid(tempArray);
            setViewBackdrop(false)
        }
        catch (e) {
            console.log(e)
            console.log("Update Failed!")
        }
    }

    const updateDocumentStatus = () => {

        if (flag_copyOfApplicantCNICFront !== null && flag_copyOfApplicantCNICBack !== null && flag_premisesDocument !== null) {
            if (dialogRowData.applicantStatus !== "Tenant" && dialogRowData.applicantStatus !== "tenant") {
                if (dialogRowData.connectionType !== "Industrial" && dialogRowData.connectionType !== "industrial") {
                    callingUpdateDocumentStatusAPI();
                }
                else {
                    if (flag_resolutionFormDesc !== null && flag_certFormDesc !== null) {
                        callingUpdateDocumentStatusAPI();
                    }
                    else {
                        // console.log("Check all the attached documents before submitting!")
                        setError("Check all the attached documents before submitting!")
                        // setErrorClose(true)
                    }
                }
            }
            else {
                if (flag_ownerNOC !== null && flag_copyOfOwnerCNICFront !== null && flag_copyOfOwnerCNICBack !== null) {
                    if (dialogRowData.connectionType !== "Industrial" && dialogRowData.connectionType !== "industrial") {
                        callingUpdateDocumentStatusAPI();
                    }
                    else {
                        if (flag_resolutionFormDesc !== null && flag_certFormDesc !== null) {
                            callingUpdateDocumentStatusAPI();
                        }
                        else {
                            // console.log("Check all the attached documents before submitting!")
                            setError("Check all the attached documents before submitting!")

                        }
                    }
                }
                else {
                    // console.log("Check all the attached documents before submitting!")
                    setError("Check all the attached documents before submitting!")

                }
            }
        }
        else {
            // console.log("Check all the attached documents before submitting!")
            setError("Check all the attached documents before submitting!")

        }
    }

    const updateProgressIdToDocumentsVerified = () => {
        if (flag_copyOfApplicantCNICFront === 1 && flag_copyOfApplicantCNICBack === 1 && flag_premisesDocument === 1) {
            if (dialogRowData.applicantStatus !== "Tenant" || dialogRowData.applicantStatus !== "tenant") {
                if (dialogRowData.connectionType !== "Industrial" || dialogRowData.connectionType !== "industrial") {
                    if (dialogRowData.objectionStatus === 2) {
                        callResetObjectionStatus(dialogRowData.applicationId)
                    }
                    callChangeProgressIdAPI(2, "Documents Verified", "Documents Verified");
                    setFlag_copyOfApplicantCNICFront(null)
                    setFlag_copyOfApplicantCNICBack(null)
                    setFlag_premisesDocument(null)
                    setFlag_scannedCopyOfNearByElectricityBill(null)
                    setFlag_copyOfOwnerCNICFront(null)
                    setFlag_copyOfOwnerCNICBack(null)
                    setFlag_ownerNOC(null)
                    setFlag_resolutionFormDesc(null)
                    setFlag_certMemoDesc(null)
                    setFlag_certFormDesc(null)
                }
                else {
                    if (flag_resolutionFormDesc === 1 && flag_certFormDesc === 1 && flag_certMemoDesc === 1) {
                        if (dialogRowData.objectionStatus === 2) {
                            callResetObjectionStatus(dialogRowData.applicationId)
                        }
                        callChangeProgressIdAPI(2, "Documents Verified", "Documents Verified");
                        setFlag_copyOfApplicantCNICFront(null)
                        setFlag_copyOfApplicantCNICBack(null)
                        setFlag_premisesDocument(null)
                        setFlag_scannedCopyOfNearByElectricityBill(null)
                        setFlag_copyOfOwnerCNICFront(null)
                        setFlag_copyOfOwnerCNICBack(null)
                        setFlag_ownerNOC(null)
                        setFlag_resolutionFormDesc(null)
                        setFlag_certMemoDesc(null)
                        setFlag_certFormDesc(null)
                    }
                    else {
                        console.log("Failed to change status for owner industrial Case!")
                    }

                }
            }
            else {
                if (flag_ownerNOC === 1 && flag_copyOfOwnerCNICFront === 1 && flag_copyOfOwnerCNICBack === 1) {
                    if (dialogRowData.connectionType !== "Industrial" || dialogRowData.connectionType !== "industrial") {
                        if (dialogRowData.objectionStatus === 2) {
                            callResetObjectionStatus(dialogRowData.applicationId)
                        }
                        callChangeProgressIdAPI(2, "Documents Verified", "Documents Verified");
                        setFlag_copyOfApplicantCNICFront(null)
                        setFlag_copyOfApplicantCNICBack(null)
                        setFlag_premisesDocument(null)
                        setFlag_scannedCopyOfNearByElectricityBill(null)
                        setFlag_copyOfOwnerCNICFront(null)
                        setFlag_copyOfOwnerCNICBack(null)
                        setFlag_ownerNOC(null)
                        setFlag_resolutionFormDesc(null)
                        setFlag_certMemoDesc(null)
                        setFlag_certFormDesc(null)
                    }
                    else {
                        if (flag_resolutionFormDesc === 1 && flag_certFormDesc === 1 && flag_certMemoDesc === "") {
                            if (dialogRowData.objectionStatus === 2) {
                                callResetObjectionStatus(dialogRowData.applicationId)
                            }
                            callChangeProgressIdAPI(2, "Documents Verified", "Documents Verified");
                            setFlag_copyOfApplicantCNICFront(null)
                            setFlag_copyOfApplicantCNICBack(null)
                            setFlag_premisesDocument(null)
                            setFlag_scannedCopyOfNearByElectricityBill(null)
                            setFlag_copyOfOwnerCNICFront(null)
                            setFlag_copyOfOwnerCNICBack(null)
                            setFlag_ownerNOC(null)
                            setFlag_resolutionFormDesc(null)
                            setFlag_certMemoDesc(null)
                            setFlag_certFormDesc(null)
                        }
                        else {
                            console.log("Failed to change status for tenant industrial case!")
                        }
                    }
                }
                console.log("Failed to change status for tenant non-industrial case!")
            }
        }
        else {
            console.log("Failed to change status for owner non-industrial case!")
        }
    }

    const statusFunc = (x, objection) => {
        if (objection === 0 || objection === 2) {
            if (x === 0) {
                return 'Pending'
            }
            else if (x > 0 && x < 5) {
                return 'In Process'
            }
            else if (x >= 5 && x < 10) {
                return 'Approved'
            }
            else {
                return 'Completed'
            }
        }
        else {
            return 'Objection'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        else if (x === 2) {
            return 'Arrear Verification'
        }
        else if (x === 3) {
            return 'Field Survey'
        }
        else if (x === 4) {
            return 'Reference No. Allocation'
        }
        else if (x === 5) {
            return 'Demand Note Payment'
        }
        else if (x === 6) {
            return 'DN Payment Verification'
        }
        else if (x === 7) {
            return 'Service Connection Order'
        }
        else if (x === 8) {
            return 'Meter Installation'
        }
        else if (x === 9) {
            return 'Ready for Billing'
        }
        else if (x === 10) {
            return 'Completed'
        }
    };

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submitted'
        }
        else if (x === 1) {
            return 'Documents Submitted'
        }
        else if (x === 2) {
            return 'Documents Verified'
        }
        else if (x === 3) {
            return 'Arrear Verified'
        }
        else if (x === 4) {
            return 'Field Surveyed'
        }
        else if (x === 5) {
            return 'Reference No. Allocated'
        }
        else if (x === 6) {
            return 'DN Payment Submitted'
        }
        else if (x === 7) {
            return 'DN Payment Verified'
        }
        else if (x === 8) {
            return 'Service Connection Ordered'
        }
        else if (x === 9) {
            return 'Meter Installed'
        }
        else if (x === 10) {
            return 'Billing Effected'
        }
    };

    const numberFormatting = (number) => {
        if (number) {
            let intNumber = number
            if (typeof number === 'string') {
                intNumber = parseInt(number)
            }
            let formattedNumber = intNumber.toLocaleString(
                undefined,
                {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }
            )
            return formattedNumber
        }
    };

    const handleRowClick = async (applicationId, event) => {
        setViewBackdrop(true);
        let demandNoticeDetails = '';
        let dnPayDate = ''
        let scoDets = ''
        if (applicationId) {
            const item = filterNCApp(applicationId);
            if (item) {
                const connectionType = item.connectionType
                const appliedLoad = item.appliedLoad
                const seasonalNonSeasonal = item.seasonalNonSeasonalFlag
                const nearByRefNo = item.nearByReferenceNumber
                let phase = await getTariffAndMeterType(appliedLoad, connectionType, seasonalNonSeasonal, allTariffList)
                console.log(phase, 'printing phase as a result')
                setDialogRowData(item);
                setFlag_copyOfApplicantCNICFront(item.copyOfApplicantCNICFrontFlag);
                setFlag_copyOfApplicantCNICBack(item.copyOfApplicantCNICBackFlag);
                setFlag_scannedCopyOfNearByElectricityBill(item.scannedCopyOfNearByElectricityBillFlag);
                setFlag_premisesDocument(item.premisesDocumentFlag);
                setFlag_copyOfOwnerCNICFront(item.copyOfOwnerCNICFrontFlag);
                setFlag_copyOfOwnerCNICBack(item.copyOfOwnerCNICBackFlag);
                setFlag_ownerNOC(item.ownerNOCFlag);
                setFlag_resolutionFormDesc(item.resolutionFormDescFlag);
                setFlag_certMemoDesc(item.certMemoDescFlag);
                setFlag_certFormDesc(item.certFormDescFlag);
                await callEfileAPI(item.applicationId);

                if (item.applicationProgressId) {
                    var formdata = new FormData();
                    formdata.append("applicationId", item.applicationId);


                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow'
                    };

                    await fetch(cfpBaseUrl + "electricityNewConnection/getDocuments", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            setDialogRowData(prevObject => ({
                                ...prevObject,
                                "copyOfApplicantCNICFront": result.images[0].copyOfApplicantCNICFront,
                                "copyOfApplicantCNICBack": result.images[0].copyOfApplicantCNICBack,
                                "premisesDocument": result.images[0].premisesDocument,
                                "scannedCopyOfNearByElectricityBill": result.images[0].scannedCopyOfNearByElectricityBill,
                                "copyOfOwnerCNICFront": result.images[0].copyOfOwnerCNICFront,
                                "copyOfOwnerCNICBack": result.images[0].copyOfOwnerCNICBack,
                                "ownerNOC": result.images[0].ownerNOC,
                                "resolutionFormDesc": result.images[0].resolutionFormDesc,
                                "certFormDesc": result.images[0].certFormDesc,
                                "certMemoDesc": result.images[0].certMemoDesc,
                            }));

                        })
                        .catch(error => console.log('error', error));
                }

                if (item.applicationProgressId === 2 && item.objectionStatus === 1) {
                    // console.log("Calling Arrears API")
                    var formdata = new FormData();

                    formdata.append("applicationNo", item.applicationId);
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow'
                    };

                    await fetch(cfpBaseUrl + "comman/getArrears", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            console.log(result.data[0], "Getting Arrears result")
                            const arrearsObject = {
                                refNo: result.data[0].refNo,
                                arrearsAmount: result.data[0].arrearAmount,
                                meterStatus: result.data[0].meterStatus,
                                tariffDesc: result.data[0].tariffDesc,
                                meterType: result.data[0].meterType,
                                phase: result.data[0].phase,
                                consumerName: result.data[0].consumerName,
                                consumerNo: result.data[0].consumerPhoneNo,
                                consumerAddress: result.data[0].consumerAddress,
                                consumerEmail: result.data[0].consumerEmail,
                                paidArearImage: result.data[0].paidArearImage,
                                paidArearDate: result.data[0].paidArearDate
                            }
                            arearsFormik.values.iv_property_reference_no = result.data[0].refNo
                            setArrearsDetailsRefnoToDisplay(arrearsObject);
                        })
                        .catch(error => console.log('error', error));
                }

                if (item.applicationProgressId === 2) {
                    var requestOptions = {
                        method: 'GET',
                        redirect: 'follow'
                    };

                    let cnicToTest = '';

                    if (item.applicantStatus === 'Owner') {
                        cnicToTest = item.applicantCNIC;
                    }
                    else if (item.applicantStatus === 'Tenant') {
                        cnicToTest = item.ownerCNIC;
                    }

                    // cnicToTest = '01151715000404'
                    let apiResponse = await dBillAPI(token, cnicToTest + "?company_code=" + item.companyCode)
                    if (apiResponse.status) {
                        let arrearsObj = {
                            arrearsAmount: apiResponse.basicInfo.arrear,
                            meterStatus: apiResponse.metersInfo[0].mtrStatus,
                            tariffDesc: apiResponse.basicInfo.tariffDescription,
                            meterType: apiResponse.basicInfo.meterType,
                            phase: apiResponse.basicInfo.phase,
                            consumerName: apiResponse.basicInfo.consumerName,
                            consumerNo: apiResponse.basicInfo.consumerContactNo,
                            consumerAddress: apiResponse.basicInfo.consumerAddress1 + apiResponse.basicInfo.consumerAddress2,
                            consumerEmail: apiResponse.basicInfo.consumerEmail,
                        }
                        setArrearsDetailsCNIC(arrearsObj)
                    } else {
                        console.log('Unable to get errors for the CNIC. Please try later!')
                    }
                }

                if (item.applicationProgressId >= 3) {

                    await callAsyncFieldSurveyInformation(item.applicationId)

                    if (item.applicationProgressId === 3) {
                        fieldFormik.values.iv_no_of_meters_already_installed = item.noOfMetersAlreadyInstalled

                        if (item.objectionStatus === 1 && item.remarks === "Load at site exceeds than applied.") {
                            appliedLoadFormik.values.iv_applied_load = item.appliedLoad
                        }
                    }

                    if (item.applicationProgressId === 4) {
                        await callFeederList("", "", "", item.subDivisionCode)
                        scoDets = await callGetSCOAPI(item.applicationId, phase)

                        if (nearByRefNo) {
                            let apiResponse = await dBillAPI(token, nearByRefNo)
                            if (apiResponse.status) {
                                refNoAllocationFormik.values.iv_feeder_no = apiResponse.basicInfo.feederCode
                            } else {
                                console.log('Reference No. not found!')
                            }
                        }
                        let hierarchyList = JSON.parse(window.localStorage.getItem('subDivisions'))
                        if (item.appliedLoad < 15) {
                            let subDivisionObject = hierarchyList.find((objs) => objs.subDivisionCode === item.subDivisionCode)
                            if (subDivisionObject) {
                                setBankName(subDivisionObject.subDivBankName)
                            }
                        }
                        else if (item.appliedLoad >= 15 && item.appliedLoad <= 70) {
                            let divisionObject = hierarchyList.find((objs) => objs.divisionCode === item.divisionCode)
                            if (divisionObject) {
                                setBankName(divisionObject.divBankName)
                            }
                        }
                    }

                    var formdata = new FormData();
                    formdata.append("applicationNo", item.applicationId);


                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow'
                    };

                    await fetch(cfpBaseUrl + "demandNotice/getDemandNoticeData", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.data.length > 0) { // if field survey data is already filled
                                setDnDetails(result.data[0])
                                demandNoticeDetails = result.data[0]
                                if (item.applicationProgressId === 3 || item.applicationProgressId === 4) {
                                    refNoAllocationFormik.values.iv_batch = result.data[0].batchNo
                                    setReferenceNumberToAllot(result.data[0].consumerAccountNo)
                                    refNoAllocationFormik.values.iv_reference_to_allot = partialValue + referenceNumberToAllot
                                    refNoAllocationFormik.values.iv_meter_rent = result.data[0].meterRent
                                    refNoAllocationFormik.values.iv_grid_sharing_cost = result.data[0].amountOfGridSharing
                                    refNoAllocationFormik.values.iv_industry_factory_type = result.data[0].industryFactoryType

                                    if (result.data[0].amountOfGridSharing !== 0) {
                                        setGridFlag(true)
                                    } else {
                                        setGridFlag(false)
                                    }
                                    refNoAllocationFormik.values.iv_feeder_rehab_charges = result.data[0].amountOfFeederRehab
                                    if (result.data[0].amountOfFeederRehab !== 0) {
                                        setFeederRehabFlag(true)
                                    } else {
                                        setFeederRehabFlag(false)
                                    }
                                    refNoAllocationFormik.values.iv_service_rent = result.data[0].serviceRent
                                    refNoAllocationFormik.values.iv_tariff_to_allot = result.data[0].tariff
                                    refNoAllocationFormik.values.iv_feeder_no = result.data[0].feederNo
                                    refNoAllocationFormik.values.iv_sub_batch = result.data[0].subBatch
                                    fieldFormik.values.iv_sketch_diagram = result.data[0].surveyedBy
                                    setSketchDiagramUploaded(result.data[0].sketchImage)
                                    setSketchDiagramThumbnail(result.data[0].sketchImage)
                                    let arrayOfBoq = result.BoQitems
                                    let arrayOfItems = []
                                    let materials = allMaterialList
                                    arrayOfBoq.forEach(item => {
                                        let foundItem = materials.find(itm => itm.Id === item.Id)
                                        let itemToBeAdded = {}
                                        if (foundItem) {
                                            itemToBeAdded.itemCode = foundItem.ItemCode
                                            itemToBeAdded.Id = foundItem.Id
                                            itemToBeAdded.name = foundItem.ItemName
                                        }
                                        itemToBeAdded.code = foundItem.ItemCode
                                        itemToBeAdded.qty = item.qty;
                                        itemToBeAdded.rate = foundItem.Rate;
                                        itemToBeAdded.unit = foundItem.Unit;
                                        itemToBeAdded.amount = parseInt(item.qty) * parseInt(foundItem.Rate);
                                        arrayOfItems.push(itemToBeAdded);
                                    })
                                    let totalAmountofItems = calculateTotalAmountOfItems(arrayOfItems)
                                    let store_charges = totalAmountofItems * .12
                                    let transportation_charges = totalAmountofItems * .08
                                    let installation_charges = totalAmountofItems * .26
                                    let total_charges = totalAmountofItems + store_charges + transportation_charges + installation_charges
                                    refNoAllocationFormik.values.iv_items_array = arrayOfItems;
                                    setItemsAmount(totalAmountofItems)
                                    setStoreCharges(store_charges)
                                    setTransportationCharges(transportation_charges)
                                    setInstallationCharges(installation_charges)
                                    setTotalCharges(total_charges)
                                    setItemsArray(arrayOfItems);
                                    fieldFormik.values.iv_sanctioned_load = item.appliedLoad
                                }
                            }
                            else {
                            }
                        })
                        .catch(error => console.log('error', error));
                }

                if (item.applicationProgressId >= 5) {
                    var formdata = new FormData();

                    formdata.append("applicationNo", item.applicationId);
                    formdata.append("demandNoticeNo", '');

                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow'
                    };

                    await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.status === "200") {
                                setDnImage(result.data[0].paidDNImage)
                                setDnNumber(result.data[0].demandNoticeNo)
                                setDnPaymentDate(result.data[0].paymentDate)
                                dnPayDate = result.data[0].paymentDate
                            }
                        })
                        .catch(error => console.log('error', error));
                }

                if (item.applicationProgressId >= 6) {
                    scoPart2Formik.values.iv_sanctioned_load = item.appliedLoad

                    var formdata = new FormData();
                    formdata.append("applicationNo", item.applicationId);


                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);

                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow'
                    };

                    await fetch(cfpBaseUrl + "demandNotice/getDemandNoticeData", requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            setDnDetails(result.data[0])
                            scoPart1Formik.values.iv_batch = result.data[0].batchNo
                            scoPart1Formik.values.iv_feeder_no = result.data[0].feederNo
                            scoPart1Formik.values.iv_sub_batch = result.data[0].subBatch
                            scoPart1Formik.values.iv_refNo = result.data[0].consumerAccountNo

                            if (item.areaType === "Urban" || item.areaType === "Urban") {
                                scoPart1Formik.values.iv_rural_urban = 'U'
                            }
                            else if (item.areaType === "Rural" || item.areaType === "rural") {
                                scoPart1Formik.values.iv_rural_urban = 'R'
                            }
                        })
                        .catch(error => console.log('error', error));

                    await callFeederList("", "", "", item.subDivisionCode)
                }

                if (item.applicationProgressId >= 7) {
                    scoDets = await callGetSCOAPI(item.applicationId, phase)
                }

                if (item.applicationProgressId >= 8 && roleTypeId == 1) {
                    callStandardClassificaitionCodesAPI()
                    callGetCP136API(item.applicationId)
                }

                const getUnripeAge = () => {
                    let ageInDays = '';
                    let crtDate = new Date(item.creationDate);
                    if (item.applicationProgressId < 5) {
                        let currentDate = new Date();
                        const ageInMilliseconds = currentDate - crtDate;
                        ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
                        setUnripeAge(Math.floor(ageInDays));
                    } else {
                        if (demandNoticeDetails) {
                            let dnDate = new Date(demandNoticeDetails.issueDate)
                            const ageInMilliseconds = dnDate - crtDate;
                            ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
                            setUnripeAge(Math.floor(ageInDays));
                        }
                    }
                }

                getUnripeAge()

                const getRipeAge = () => {
                    let ageInDays = '';
                    let DnPaymentDate = new Date(dnPayDate)
                    if (item.applicationProgressId < 8) {
                        let currentDate = new Date();
                        const ageInMilliseconds = currentDate - DnPaymentDate;
                        ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
                        setRipeAge(Math.floor(ageInDays));
                    }
                    else {
                        if (scoDets.dateOfConnection) {
                            let MeterInstallationDate = new Date(scoDets.dateOfConnection)
                            const ageInMilliseconds = MeterInstallationDate - DnPaymentDate;
                            ageInDays = ageInMilliseconds / (1000 * 60 * 60 * 24);
                            setRipeAge(Math.floor(ageInDays));
                        }
                        else {

                            setRipeAge('-');
                        }
                    }
                }
                getRipeAge()
                setViewBackdrop(false);
                setOpen(true);
            }
        }
    };

    const referenceNumberHandleChange = (event) => {
        setReferenceNumberToAllot(event.target.value)
    };

    const getDocumentBackGroundColor = (flagValue) => {
        switch (flagValue) {
            case null:
                return 'white'
            case -1:
                return '#FFCAC9'
            case 0:
                return '#F3F6FB'
            case 1:
                return '#D6F6D5'
            default:
                return 'white'
        }
    }

    const DnReceiptImage = (event) => {
        dnPymentReceiptFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "dnReceiptImage." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setDnReceiptImage(renamedFile);
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    // Set the thumbnail image as the data URL
                    const base64Image = reader.result
                    setDnReceiptImageThumbnail(base64Image);
                };
            }
            else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            };
        }
    }

    const calculateTotalAmountOfItems = (array) => {
        let amount = 0;
        for (let i = 0; i < array.length; i++) {
            amount += array[i].amount
        }
        return amount
    }

    const deleteItem = (code) => {
        let itemsInArray = itemsArray
        // console.log(itemsInArray, 'items in array')
        const index = itemsInArray.findIndex(item => item.code === code);
        // console.log(index, 'index of item');
        const itemtodelete = itemsInArray.find(item => item.code === code);
        // console.log(itemtodelete, 'item to delete');
        if (index !== -1) {
            itemsInArray.splice(index, 1);
            let totalAmountofItems = calculateTotalAmountOfItems(itemsInArray)
            let store_charges = totalAmountofItems * .12
            let transportation_charges = totalAmountofItems * .08
            let installation_charges = totalAmountofItems * .26
            let total_charges = totalAmountofItems + store_charges + transportation_charges + installation_charges
            fieldItemFormik.values.iv_items_array = itemsInArray;
            setItemsAmount(totalAmountofItems)
            setStoreCharges(store_charges)
            setTransportationCharges(transportation_charges)
            setInstallationCharges(installation_charges)
            setTotalCharges(total_charges)
            setItemsArray(itemsInArray)
        }
    }

    const getMeterType = (code) => {
        switch (code) {
            case 0:
                return 'Normal'
            case '0':
                return 'Normal'
            case 1:
                return 'Smart'
            case '1':
                return 'Smart'
            default:
                return '-'
        }
    }

    const FataPata = (event) => {
        scoPart1Formik.handleChange(event);
        scoPart1Formik.values.iv_fata_pata = event.target.value;
    }

    const RuralUrban = (event) => {
        scoPart1Formik.handleChange(event);
        scoPart1Formik.values.iv_rural_urban = event.target.value;
    }

    const SeasonalNonSeasonal = (event) => {
        scoPart2Formik.handleChange(event);
        scoPart2Formik.values.iv_seasonal_flag = event.target.value;
    };

    const GovtDept = (event) => {
        masterDataFormik.handleChange(event);
        masterDataFormik.values.iv_govt_dept = event.target.value;
    }

    const MeterType = (event) => {
        scoPart2Formik.handleChange(event);
        scoPart2Formik.values.iv_meter_type = event.target.value;
    }

    const IncomeTax = (event) => {
        masterDataFormik.handleChange(event);
        masterDataFormik.values.iv_income_tax = event.target.value;
    }

    const MeterLine = (event) => {
        fieldFormik.handleChange(event)
        fieldFormik.values.iv_distance = event.target.value
    }

    const eFileIcon = () => {
        return (
            <img src={eFileIcon} alt="Efile Icon" height="20" width="25" />
        )
    }

    const downloadApplicationPDF = async (applicationId) => {
        setViewBackdrop(true)
        try {

            let application = netMeterApplications.find(item => item.applicationId === applicationId)
            let applicationDocs;

            await callAsyncGetDocumentsAPI(applicationId)
                .then(response => {
                    applicationDocs = response;
                })

            //#region text
            const copyOfApplicantCNICFront = applicationDocs.copyOfApplicantCNICFront ? applicationDocs.copyOfApplicantCNICFront : ''
            const copyOfApplicantCNICBack = applicationDocs.copyOfApplicantCNICBack ? applicationDocs.copyOfApplicantCNICBack : ''
            const premisesDocument = applicationDocs.premisesDocument ? applicationDocs.premisesDocument : ''
            const scannedCopyOfNearByElectricityBill = applicationDocs.scannedCopyOfNearByElectricityBill ? applicationDocs.scannedCopyOfNearByElectricityBill : ''
            const copyOfOwnerCNICFront = applicationDocs.copyOfOwnerCNICFront ? applicationDocs.copyOfOwnerCNICFront : ''
            const copyOfOwnerCNICBack = applicationDocs.copyOfOwnerCNICBack ? applicationDocs.copyOfOwnerCNICBack : ''
            const ownerNOC = applicationDocs.ownerNOC ? applicationDocs.ownerNOC : ''
            const resolutionFormDesc = applicationDocs.resolutionFormDesc ? applicationDocs.resolutionFormDesc : ''
            const certMemoDesc = applicationDocs.certMemoDesc ? applicationDocs.certMemoDesc : ''
            const certFormDesc = applicationDocs.certFormDesc ? applicationDocs.certFormDesc : ''

            const doc = new jsPDF({ compressPdf: true });


            const addPdfasImage = async (pdfInBase64, document) => {
                let docPageNumbers = null
                let base64ImagesArray = []

                GlobalWorkerOptions.workerSrc = '../../../services/pdf.worker.mjs';

                const pdfData = atob(pdfInBase64.split(',')[1]);

                // Find the number of pages in the PDF
                const regex = /\/Count\s+(\d+)/;
                const match = pdfData.match(regex);
                const pageCount = match ? parseInt(match[1], 10) : 0;

                docPageNumbers = pageCount;

                const renderPageToBase64 = async (pageNumber) => {
                    try {
                        // Load the PDF page
                        const pdf = await getDocument({ data: pdfData }).promise;
                        const pdfPage = await pdf.getPage(pageNumber);

                        // Render the PDF page to a canvas
                        const scale = 1.5; // Adjust as needed
                        const viewport = pdfPage.getViewport({ scale });
                        const canvas = document.createElement('canvas');
                        const canvasContext = canvas.getContext('2d');
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;
                        await pdfPage.render({ canvasContext, viewport }).promise;

                        // Convert the canvas to a base64-encoded image
                        const imageDataUrl = canvas.toDataURL('image/png');
                        return imageDataUrl;
                    } catch (error) {
                        console.error('Error rendering PDF page:', error);
                    }
                };

                for (let i = 1; i <= docPageNumbers; i++) {
                    const imageDataUrl = await renderPageToBase64(i);
                    base64ImagesArray.push(imageDataUrl);
                }

                base64ImagesArray.forEach((imageDataUrl, index) => {
                    doc.addImage(imageDataUrl, 'png', 10, 10, 100, 100); // Adjust the coordinates and dimensions as needed
                    if (index !== base64ImagesArray.length - 1) {
                        doc.addPage();
                    }
                });

            }

            var pageWidth = doc.internal.pageSize.getWidth();
            var pageHeight = doc.internal.pageSize.getHeight();

            // Generate the barcode image using JsBarcode
            const barcodeCanvas = document.createElement('canvas');
            JsBarcode(barcodeCanvas, applicationId);

            // Convert the barcode image to data URL
            const barcodeDataURL = barcodeCanvas.toDataURL('image/png');
            var height = 10;
            var padding = 10;

            // Add the barcode image to the PDF document
            doc.addImage(barcodeDataURL, 'PNG', 85, 260, 40, 20); // Adjust the position and size of the barcode image
            doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image


            var increment = 15;
            height = height + increment
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 8;
            height = height + increment;
            doc.setFontSize(18);
            doc.text('E-Document', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            height = height + increment;
            doc.setFontSize(12);
            doc.setFont('helvetica', 'normal');
            var increment = 8;
            var height = height + increment
            var leftMargin = 50
            doc.text('Document Type: ', padding, height);
            doc.text('New Connection', padding + leftMargin, height);
            doc.text('Tracking Id:', padding + leftMargin + leftMargin, height);
            doc.text(applicationId, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Application Status: ', padding, height);
            doc.text(statusFunc(application.applicationProgressId, application.objectionStatus), padding + leftMargin, height);
            doc.text('Application Date:', padding + leftMargin + leftMargin, height);
            doc.text(convertDate(application.creationDate), padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Sub-Division: ', padding, height);
            doc.text(subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions), padding + leftMargin, height);
            doc.text('Connection Type:', padding + leftMargin + leftMargin, height);
            doc.text(application.connectionType, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Phase / Load: ', padding, height);
            doc.text(application.appliedLoad.toString(), padding + leftMargin, height);
            doc.text('Connection Date:', padding + leftMargin + leftMargin, height);
            doc.text('-', padding + leftMargin + leftMargin + leftMargin, height);

            increment = 20;
            height = height + increment
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 10; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            doc.setFillColor(200, 200, 200);
            // Draw the rectangle
            doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');

            doc.setFont('helvetica', 'bold');
            doc.text('Applicant Particulars', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 6;
            var height = height + increment
            // Get the page width and height

            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 30; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            // Draw the rectangle
            doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

            doc.setFont('helvetica', 'normal');
            increment = 8;
            var height = height + increment
            var leftMargin = 70
            var extraPadding = 5
            doc.text('Applicant Name:', padding + extraPadding, height);
            doc.text(application.applicantName, padding + leftMargin, height);

            increment = 6;
            var height = height + increment
            var leftMargin = 70
            doc.text('CNIC:', padding + extraPadding, height);
            doc.text(application.applicantCNIC, padding + leftMargin, height);

            var height = height + increment
            var leftMargin = 70
            doc.text('Present Address:', padding + extraPadding, height);
            doc.text(application.premisesAddress, padding + leftMargin, height);

            increment = 20;
            height = height + increment
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 10; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            doc.setFillColor(199, 199, 199);
            // Draw the rectangle
            doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
            doc.setFont('helvetica', 'bold');
            doc.text('Premises Details', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });


            doc.setFontSize(12)
            increment = 3.5;
            var height = height + increment
            // Get the page width and height
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 18; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            // Draw the rectangle
            doc.rect(rectX, height, rectWidth, rectHeight);

            doc.setFont('helvetica', 'normal');
            increment = 8;
            var height = height + increment
            var leftMargin = 70
            doc.text('No. of meter(s) already installed:', padding + extraPadding, height);
            doc.text(application.noOfMetersAlreadyInstalled.toString(), padding + leftMargin, height);

            increment = 6;
            var height = height + increment
            var leftMargin = 70
            doc.text('Present Address:', padding + extraPadding, height);
            doc.text(application.premisesAddress, padding + leftMargin, height);


            if (copyOfApplicantCNICFront != '' || copyOfApplicantCNICBack != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment
                let copyOfApplicantCNICFrontfileType = copyOfApplicantCNICFront.slice(0, 6)
                let copyOfApplicantCNICBackfileType = copyOfApplicantCNICBack.slice(0, 6)

                let frontExtension = ''
                let backExtension = ''

                if (copyOfApplicantCNICFrontfileType == "data:i") {
                    frontExtension = copyOfApplicantCNICFront.slice(11, 15)
                }
                else if (copyOfApplicantCNICFrontfileType == "data:a") {
                    frontExtension = copyOfApplicantCNICFront.slice(17, 19)
                }
                if (copyOfApplicantCNICBackfileType == "data:i") {
                    backExtension = copyOfApplicantCNICBack.slice(11, 15)
                }
                else if (copyOfApplicantCNICBackfileType == "data:a") {
                    backExtension = copyOfApplicantCNICBack.slice(17, 19)
                }


                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                increment = 10;
                height = height + increment
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Applicant CNIC Image', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 200; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 120
                let cardHeight = 80
                var xPos = (pageWidth - cardWidth) / 2;
                if (frontExtension.startsWith('jp')) {
                    doc.addImage(copyOfApplicantCNICFront, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pn')) {
                    doc.addImage(copyOfApplicantCNICFront, 'png', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pd')) {
                    addPdfasImage(copyOfApplicantCNICFront, doc)
                    // doc.addImage(copyOfApplicantCNICFront, 'pdf', xPos, height, cardWidth, cardHeight);
                }

                height = height + 100

                if (backExtension.startsWith('jp')) {
                    doc.addImage(copyOfApplicantCNICBack, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (backExtension.startsWith('pn')) {
                    doc.addImage(copyOfApplicantCNICBack, 'png', xPos, height, cardWidth, cardHeight);
                }
                else if (backExtension.startsWith('pd')) {
                    // doc.addImage(copyOfApplicantCNICBack, 'pdf', xPos, height, cardWidth, cardHeight);
                }
            }

            if (premisesDocument != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = premisesDocument.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Property Document', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(premisesDocument, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(premisesDocument, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (scannedCopyOfNearByElectricityBill != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = scannedCopyOfNearByElectricityBill.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Near By Bill', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(scannedCopyOfNearByElectricityBill, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(scannedCopyOfNearByElectricityBill, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (copyOfOwnerCNICFront != '' || copyOfOwnerCNICBack != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let frontExtension = copyOfOwnerCNICFront.slice(11, 15)
                let backExtension = copyOfOwnerCNICBack.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Copy of Owner's CNIC`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 120
                let cardHeight = 80
                var xPos = (pageWidth - cardWidth) / 2;
                if (frontExtension.startsWith('jp')) {
                    doc.addImage(copyOfOwnerCNICFront, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pn')) {
                    doc.addImage(copyOfOwnerCNICFront, 'png', xPos, height, cardWidth, cardHeight);
                }

                height = height + 100

                if (backExtension.startsWith('jp')) {
                    doc.addImage(copyOfOwnerCNICBack, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (frontExtension.startsWith('pn')) {
                    doc.addImage(copyOfOwnerCNICBack, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (ownerNOC != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = ownerNOC.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('NOC from Owner', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(ownerNOC, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(ownerNOC, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (resolutionFormDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = resolutionFormDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`BODs' Resolution Form`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(resolutionFormDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(resolutionFormDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (certMemoDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = certMemoDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Memorandum of Association`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(certMemoDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(certMemoDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (certFormDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = certFormDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Certified Form 29`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(certFormDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(certFormDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            const totalPages = doc.internal.getNumberOfPages();

            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.addImage(getWaterMarkLogo(userCompany), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
            }
            doc.setFontSize(8);

            // Loop through each page
            for (var i = 1; i <= totalPages; i++) {
                // Set the current page
                doc.setPage(i);

                // Get the page width and height
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();

                // Set the position for the page number
                var pageNumberX = pageWidth - 20; // X-coordinate of the page number
                var pageNumberY = pageHeight - 10; // Y-coordinate of the page number

                // Add the page number
                doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() / 2, pageNumberY, {
                    align: 'center',
                });
            }
            const pdfBlob = doc.output('blob');
            const pdfDataUrl = URL.createObjectURL(pdfBlob);

            // Open the PDF in a new tab
            window.open(pdfDataUrl, '_blank');

            // Optionally revoke the Object URL after opening the new tab
            URL.revokeObjectURL(pdfDataUrl);
        }
        catch (e) {
            console.log("Unable to generate Application PDF! ".concat(e))
            console.log(e)
        }
        setViewBackdrop(false)
    }

    const downloadDNPDF = async (applicationId) => {
        setViewBackdrop(true)
        try {
            let dnDets
            await callAsyncDnDetailsAPI(applicationId)
                .then(response => {
                    dnDets = response
                });

            let application = netMeterApplications.find(item => item.applicationId === applicationId)

            const fontSize = 8
            //#region text
            const doc = new jsPDF({ compressPdf: true });

            //#region Line 1 
            var padding = 10
            var line2Height = 10
            var lineHeightIncreament = 5
            doc.setFontSize(fontSize);
            doc.text('DUE Date: ' + convertDate(dnDets.dueDate), padding, line2Height, {
            });
            doc.text(companyName(applicationId.slice(0, 2)).concat(application.appliedLoad < 15 ? '(' + applicationId.slice(0, 5) + "-" + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + ')' : '(' + applicationId.slice(0, 4) + '-' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ')'), doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 2
            var line2Height = line2Height + lineHeightIncreament
            doc.text('(Department of Electricity)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 3
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 12
            var text1 = 'Demand Notice Serial No.: '
            var text2 = dnDets.demandNoticeNo
            var text3 = 'Application Id: '
            var text4 = applicationId
            var text5 = 'Date: '
            var text6 = convertDate(dnDets.creationDate)

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
            //#endregion

            //#region Line 4
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 3.35
            var text1 = 'Demand Notice Issuance Date: '
            var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
            var text3 = 'Application Type: '
            var text4 = application.applicationType ? applicationName(application.applicationType) : '-'
            var text5 = 'New Connection, Reconnection etc.: '
            var text6 = application.applicationType ? applicationName(application.applicationType) : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
            //#endregion

            //#region Line 5
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 6.6
            var text1 = 'Account No. for acquisition connection: '
            var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
            var text3 = 'User Mobile No.: '
            var text4 = dnDets.applicantMobile ? dnDets.applicantMobile : '-'
            var text5 = 'Connection type: '
            var text6 = dnDets.connectionType ? dnDets.connectionType : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
            //#endregion

            //#region Line 6
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 7
            var text1 = '(under which the funds are to be deposited in the bank with the concerned officer of the institution)'
            var text2 = 'Industry / Factory:'
            var text3 = dnDets.industryFactoryType ? dnDets.industryFactoryType : '-'

            doc.setFontSize(6)
            doc.text(text1, padding, line2Height);
            doc.setFontSize(fontSize)
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + padding + (lineSpace), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + padding + (lineSpace * 2)) + (doc.getTextWidth(text3) + (lineSpace * 2)), line2Height + 1);

            //#endregion

            //#region Line 7
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 22.25
            var text1 = `Department's approved Bank name: `
            var text2 = dnDets.bankName ? dnDets.bankName : '-'
            var text3 = 'Applied Load(kW): '
            var text4 = application.appliedLoad ? application.appliedLoad.toString() : '|'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 8
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 22
            var text1 = `Department's Relevant Officer: `
            var text2 = application.appliedLoad ? application.appliedLoad < 15 ? subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) : divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) : '|'
            var text3 = 'Required Voltage: '
            var text4 = dnDets.voltage ? dnDets.voltage.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 9
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 16
            var text1 = `Coverage Area: `
            var text2 = dnDets.coverageAreaOfPremises ? dnDets.coverageAreaOfPremises : '|'
            var text3 = 'Alloted Tariff : '
            var text4 = dnDets.tariff ? dnDets.tariff : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 10
            var line2Height = line2Height + lineHeightIncreament

            doc.text('DEMAND NOTICE', doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 11
            var line2Height = line2Height + lineHeightIncreament

            doc.text('(Notification of Approval Application and Demand Under Guarantee)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 12
            var line2Height = line2Height + lineHeightIncreament

            doc.text(`Applicant's part`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 13
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 16
            var text1 = `Mr. / Mrs.`
            var text2 = application.applicantName ? application.applicantName.concat(' | ').concat(application.premisesAddress) : '|'
            var text3 = ``

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.setFontSize(6)
            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            //#endregion

            //#region Line 14
            lineHeightIncreament = 4
            var line2Height = line2Height + lineHeightIncreament
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the institution.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                doc.text(lines[i], padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 15
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfDays = '30'
            var text1 = `1. You should deposit the following amounts in the approved bank of the institution or with the concerned officer of the institution itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of their payment.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                var lineText = lines[i].replace("[word1]", noOfDays);
                doc.text(lineText, padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 16
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfDays = '30'
            var text1 = `A. Expenditure service connection as per approved estimate [capitalCost] and Security [securityCost] PKR. (this amount is to be deposited with the concerned officer of the institution). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                var lineText = lines[i].replace("[capitalCost]", numberFormatting(dnDets.capitalCostAmount));
                lineText = lineText.replace("[securityCost]", numberFormatting(dnDets.securityDepositeAmount));
                doc.text(lineText, padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 17
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfDays = '30'
            var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                doc.text(lines[i], padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 18
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfDays = '30'
            var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                doc.text(lines[i], padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 19
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfDays = '30'
            var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                var lineText = lines[i].replace("[noOfDays]", noOfDays);
                doc.text(lineText, padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 20
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var amount = '_____'
            var text1 = `3. Since you have not provided your purchased meter to the institution for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                var lineText = lines[i].replace("[amount]", amount);
                doc.text(lineText, padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 21
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var amount = '_____'
            var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                var lineText = lines[i].replace("[amount]", amount);
                doc.text(lineText, padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 22
            doc.text(`(Irrelevant should be cut down)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 23
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfMonth = '1'
            var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
                doc.text(lineText, padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 24
            doc.setFontSize(fontSize)
            var text1 = `Regards`
            var spaceLeft = 100
            doc.text(text1, padding + spaceLeft, line2Height);
            //#endregion

            //#region Line 25
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var text1 = application.appliedLoad < 15 ? "Sub-Division Office " + applicationId.slice(0, 5) + '-' + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + 'SDO Wapda' : "Division Office " + applicationId.slice(0, 4) + ' - ' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ' XEN Wapda'
            doc.text(text1, padding + spaceLeft, line2Height);
            //#endregion

            //#region Line 26
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var text1 = 'Signature Bank Officer: '
            var text2 = application.appliedLoad < 15 ? 'Line Superintendent Office' + '(' + applicationId.slice(0, 5) + ' - ' + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + ') SDO Wapda' : 'Line Superintendent Office' + '(' + applicationId.slice(0, 4) + ' - ' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ') XEN Wapda'
            doc.text(text1, padding, line2Height);
            doc.text(text2, padding + spaceLeft, line2Height);
            //#endregion

            //#region Line 27
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            spaceLeft = 10
            var text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------'
            doc.text(text1, padding + spaceLeft, line2Height);
            //#endregion

            //#region Line 28
            lineHeightIncreament = 5
            var line2Height = line2Height + lineHeightIncreament
            doc.text('DUE Date: ' + convertDate(dnDets.dueDate), padding, line2Height, {
            });
            doc.text('For Bank Use Only', doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 29
            var line2Height = line2Height + lineHeightIncreament
            doc.text('(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 30
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 16
            var spaceLeft = 50

            var text1 = `1. Applicant's Name and Complete address `
            var text2 = application.applicantName ? application.applicantName.concat(' | ').concat(application.premisesAddress) : '|'
            var text3 = `Details of paid amount`

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.setFontSize(6)
            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2) + spaceLeft), line2Height);
            //#endregion

            //#region Line 31
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 6.6
            var text1 = '2. Application Id: '
            var text2 = application.applicationId ? application.applicationId : '-'
            var text3 = 'Date: '
            var text4 = application.creationDate ? convertDate(application.creationDate) : '-'
            var text5 = '1. Service Connection:'
            var text6 = dnDets.capitalCostAmount ? numberFormatting(dnDets.capitalCostAmount) : '-'
            var leftSpace = 40

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + leftSpace + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + leftSpace, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 32
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 6.6
            var text1 = '3. Demand Notice Serial No.: '
            var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
            var text3 = 'Date: '
            var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
            var text5 = '2. Security: '
            var text6 = dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-'
            var leftSpace = 35

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + leftSpace + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + leftSpace, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 33
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 6.6
            var text1 = '4. Account No. for acquisition connection: '
            var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
            var text3 = ' '
            var text4 = ' '
            var text5 = '3. Grid Share / Feeder Rehab. Charges:'
            var text6 = dnDets.amountOfGridSharing ? numberFormatting(dnDets.amountOfGridSharing).concat(' / ').concat(dnDets.amountOfFeederRehab ? numberFormatting(dnDets.amountOfFeederRehab) : "-") : '-'.concat(' / ').concat(dnDets.amountOfFeederRehab ? numberFormatting(dnDets.amountOfFeederRehab) : "-")
            var leftSpace = 10

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + leftSpace + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + leftSpace, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 34
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 6.6
            var text1 = '5. Approved bank name and address:'
            var text2 = dnDets.bankName ? dnDets.bankName : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 35
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament + lineHeightIncreament
            var lineSpace = 6.6
            var text1 = application.appliedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
            var text2 = ' '
            var text3 = ' '
            var text4 = ' '
            var text5 = ' '
            var text6 = 'Signature Bank Officer '
            var leftSpace = 20
            doc.text(text1, padding, line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
            //#endregion

            //#region Line 36
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 6.6
            var text1 = 'with date and stamp'
            var text2 = ' '
            var text3 = ' '
            var text4 = ' '
            var text5 = ' '
            var text6 = ' '
            var leftSpace = 10
            doc.setFontSize(6)
            doc.text(text1, padding, line2Height);
            //#endregion

            //#region Line 37
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament
            spaceLeft = 10
            var text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------'
            doc.text(text1, padding + spaceLeft, line2Height);
            //#endregion

            //#region Line 38
            lineHeightIncreament = 4
            var line2Height = line2Height + lineHeightIncreament
            doc.text('DUE Date: ' + convertDate(dnDets.dueDate), padding, line2Height, {
            });
            doc.text(`Applicant's Response`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 39
            lineHeightIncreament = 4
            var line2Height = line2Height + lineHeightIncreament
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department'a approved bank NBP Gulgasht Branch by receipt no. _______ on date ________.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                var lineText = lines[i].replace("[capitalCost]", numberFormatting(dnDets.capitalCostAmount));
                lineText = lineText.replace("[securityCost]", numberFormatting(dnDets.securityDepositeAmount));
                doc.text(lineText, padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 40
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfDays = '30'
            var text1 = `2. Since I/We did not provide funds to buy meter to the institution, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                doc.text(lines[i], padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 41
            doc.setFontSize(fontSize)
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
            var noOfDays = '30'
            var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period..?`
            var lines = doc.splitTextToSize(text1, maxWidth);
            // Iterate through each line and add it to the PDF
            for (var i = 0; i < lines.length; i++) {
                doc.text(lines[i], padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#region Line 42
            lineHeightIncreament = 5
            var line2Height = line2Height + lineHeightIncreament
            doc.text(`For Computer Center Use`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 43
            var line2Height = line2Height + lineHeightIncreament
            doc.text(`(Demand Notice Data)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 44
            var line2Height = line2Height + lineHeightIncreament
            var lineHeightIncreament = 5
            var padding = 10
            var lineSpace = 7.5
            var text1 = 'Demand Notice Serial No.: '
            var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
            var text3 = 'Application Id: '
            var text4 = applicationId ? applicationId : '-'
            var text5 = 'Application Form No.: '
            var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
            //#endregion

            //#region Line 45
            var line2Height = line2Height + lineHeightIncreament
            var lineHeightIncreament = 5
            var padding = 10
            var lineSpace = 7.5
            var text1 = 'Demand Notice Issuance Date: '
            var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
            var text3 = 'Amount to be paid: '
            var text4 = dnDets.capitalCostAmount ? numberFormatting(parseInt(dnDets.capitalCostAmount) + parseInt(dnDets.securityDepositeAmount) + dnDets.amountOfGridSharing + dnDets.amountOfFeederRehab) : '-'
            var text5 = ' '
            var text6 = ' '

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            //#endregion

            //#region Line 46
            doc.setFontSize(fontSize)
            var line2Height = line2Height + lineHeightIncreament + lineHeightIncreament / 2
            var lineSpace = 6.6
            var text1 = ' '
            var text2 = ' '
            var text3 = ' '
            var text4 = ' '
            var text5 = ' '
            var text6 = application.appliedLoad < 15 ? 'Signature SDO with date' : 'Signature XEN with date'
            var leftSpace = 110
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
            //#endregion

            //#region Line 47
            doc.setFontSize(6)
            lineHeightIncreament = 2
            var maxWidth = doc.internal.pageSize.getWidth() - (padding * 8)
            var text1 = 'NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. '
            var lineSpace = 6.6
            var lines = doc.splitTextToSize(text1, maxWidth);
            for (var i = 0; i < lines.length; i++) {
                doc.text(lines[i], padding, line2Height);
                line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
            }
            //#endregion

            //#endregion

            const totalPages = doc.internal.getNumberOfPages();

            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.addImage(getWaterMarkLogo(userCompany), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
            }

            const pdfBlob = doc.output('blob');
            const pdfDataUrl = URL.createObjectURL(pdfBlob);

            // Open the PDF in a new tab
            window.open(pdfDataUrl, '_blank');
        }
        catch (e) {
            console.log("Unable to generate Master Data Form!")
            console.log(e)
        }
        setViewBackdrop(false)
    }

    const downloadSCOPDF = async (applicationId) => {
        setViewBackdrop(true)
        try {

            let scoDets

            await callAsyncGetSCOAPI(applicationId)
                .then(response => {
                    scoDets = response
                });

            let dnDets
            await callAsyncDnDetailsAPI(applicationId)
                .then(response => {
                    dnDets = response
                });

            let application = netMeterApplications.find(item => item.applicationId === applicationId)
            let officeCode = application.subDivisionCode.toString()
            let officeName = subdivisionName(parseInt(officeCode), subDivisions)
            let authorizedByName = scoDets.authorizedByName ? scoDets.authorizedByName : '---'
            let authorizedByDesignation = 'Role'
            let dateToPrint = scoDets.dateOfAuthorization ? new Date(scoDets.dateOfAuthorization).toLocaleDateString() : '---'
            let imgData = printStamp(officeCode, officeName, authorizedByName, authorizedByDesignation, dateToPrint)

            const fontSize = 9
            //#region text
            const doc = new jsPDF({ compressPdf: true });
            // Add image to PDF
            doc.addImage(imgData, 'PNG', 145, 70, 55, 40); // Add image to PDF (x, y, width, height)
            //#region Line 1 
            var padding = 10
            var line2Height = 10
            var lineHeightIncreament = 6
            doc.setFontSize(fontSize);
            doc.text(companyName(applicationId.slice(0, 2)), doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 2
            var line2Height = line2Height + lineHeightIncreament
            doc.text('Service Connection Order (SCO)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 3
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '1. Sub Division: '
            var text2 = application.subDivisionCode ? application.subDivisionCode.toString().concat(' / ').concat(subdivisionName(application.subDivisionCode, subDivisions)) : '-'
            var text3 = 'SCO No.: '
            var text4 = scoDets.scoId ? scoDets.scoId : '-'
            var text5 = 'Creation Date: '
            var text6 = scoDets.dateOfAuthorization ? convertDate(scoDets.dateOfAuthorization) : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
            //#endregion

            //#region Line 4
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 2
            var text1 = '2. Application No.: '
            var text2 = application.applicationId ? application.applicationId : '-'
            var text3 = 'Date: '
            var text4 = application.creationDate ? convertDate(application.creationDate) : '-'
            var text5 = 'Tariff: '
            var text6 = dnDets.tariff ? dnDets.tariff : '-'
            var text7 = scoDets.fataPata ? scoDets.fataPata : '-'
            var text8 = scoDets.urbanRural ? scoDets.urbanRural : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
            doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 7), line2Height);
            doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 8), line2Height);
            //#endregion

            //#region Line 5
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '3. Account No.: '
            var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
            var text3 = 'Feeder No.: '
            var text4 = scoDets.feederNo ? scoDets.feederNo : '-'
            var text5 = 'Batch: '
            var text6 = scoDets.batch ? scoDets.batch : '-'
            var text7 = 'Sub Batch: '
            var text8 = scoDets.subBatch ? scoDets.subBatch : '-'


            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

            doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 6), line2Height);
            doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 7), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 6), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 6) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

            //#endregion

            //#region Line 6
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `4. Applicant's Name: `
            var text2 = application.applicantName ? application.applicantName : '-'
            var text3 = 'CNIC/NIC/NICOP: '
            var text4 = application.applicantCNIC ? application.applicantCNIC : '-'
            var leftSpace = 50

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 7
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `5. Address: `
            var text2 = application.premisesAddress ? application.premisesAddress : '-'
            var text3 = 'Mobile No.: '
            var text4 = application.applicantMobile ? application.applicantMobile : '-'
            var leftSpace = 50

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 8
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `6. Service Connection Cost DN No.: `
            var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
            var text3 = 'Issuance Date: '
            var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
            var leftSpace = 35

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 9
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `7. Security Deposit DN No.: `
            var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
            var text3 = 'Issuance Date: '
            var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
            var leftSpace = 47

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 10
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `8. Amount of Service Connection: `
            var text2 = dnDets.capitalCostAmount ? numberFormatting(dnDets.capitalCostAmount) : '-'
            var text3 = 'Payment Date: '
            var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
            var leftSpace = 52

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 11
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `9. Amount of Security Deposit: `
            var text2 = dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-'
            var text3 = 'Payment Date: '
            var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
            var leftSpace = 56.5

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 12
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '10. F. Govt / Autonomous and Local Bodies under Prov. Govt.: '
            var text2 = scoDets.fGovt ? scoDets.fGovt : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 13
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '11. Cantonment Board: '
            var text2 = scoDets.cantonmentBoard ? scoDets.cantonmentBoard : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 14
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '12. Prov. Govt / Autonomous and Local Bodies under Prov Govt.: '
            var text2 = scoDets.pGovt ? scoDets.pGovt : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 15
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '13. Local Bodies: '
            var text2 = scoDets.localBodies ? scoDets.localBodies : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 16
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `14. Authorized By (Name): `
            var text2 = userName ? userName : '-'
            var text3 = 'Stamp: ______________________'
            var leftSpace = 62

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            // doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            //#endregion

            //#region Line 17
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            // var text1 = 'Authorization Date: '
            var text1 = ' '
            var text2 = ' '
            // var text2 = scoDets.dateOfAuthorization ? convertDate(scoDets.dateOfAuthorization) : '-'
            var leftSpace = 122

            doc.text(text1, padding + leftSpace, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace + leftSpace, line2Height);
            // doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 18
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            // var text1 = 'Designation: __________________________'
            var text1 = '  '
            var leftSpace = 122

            doc.text(text1, padding + leftSpace, line2Height);
            //#endregion

            //#region Line 19
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            // var text1 = 'Stamp: ______________________________'
            var text1 = ' '
            var leftSpace = 122

            doc.text(text1, padding + leftSpace, line2Height);
            //#endregion

            //#region Line 20
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `15. Store Requisition No.: `
            var text2 = scoDets.storeRequisitionNo ? numberFormatting(scoDets.storeRequisitionNo) : '-'
            var text3 = 'Requisition Date: '
            var text4 = scoDets.storeRequisitionDate ? convertDate(scoDets.storeRequisitionDate) : '-'
            var leftSpace = 56.5

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 21
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '16. Nature as per Standard Classification Code Booklet: '
            var text2 = dnDets.tariff ? dnDets.tariff : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 22
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `17. Seasonal/Non-Seasonal: `
            var text2 = scoDets.seasonalFlag ? scoDets.seasonalFlag.toString() : '-'
            var text3 = 'Sanctioned Load: '
            var text4 = dnDets.sanctionLoad ? dnDets.sanctionLoad.toString() : '-'
            var leftSpace = 74

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 23
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `18. No. of meters: `
            var text2 = scoDets.noOfMeters ? scoDets.noOfMeters.toString() : '-'
            var text3 = 'No. of AC/Centrally Air Conditioned Code: '
            var text4 = scoDets.noOfACs ? scoDets.noOfACs.toString() : '-'
            var leftSpace = 57

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 24
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var leftSpace = 18
            var text1 = '19. No. of meter sets: '
            var text2 = scoDets.noOfMeterSets ? scoDets.noOfMeterSets.toString() : '-'
            var text3 = 'No. of sub sets: '
            var text4 = scoDets.noOfSubSets ? scoDets.noOfSubSets.toString() : '-'
            var text5 = 'No. of supply points: '
            var text6 = scoDets.noOfSupplyPoints ? scoDets.noOfSupplyPoints.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + (leftSpace * 2), line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + (leftSpace * 2), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + (leftSpace * 2), line2Height + 1);
            //#endregion

            //#region Line 25
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '20. Installed Transformer Capacity: '
            var text2 = scoDets.installedTransformerCapacity ? scoDets.installedTransformerCapacity.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 26
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '21. Meter Id: '
            var text2 = scoDets.meterId ? scoDets.meterId.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 27
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '22. Meter Number: '
            var text2 = scoDets.meterNo ? scoDets.meterNo.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 28
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '23. Location Code: '
            var text2 = scoDets.locationCode ? scoDets.locationCode.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 29
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '24. Meter Code: '
            var text2 = scoDets.meterCode ? scoDets.meterCode.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 30
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '25. Manufacturer Code: '
            var text2 = scoDets.manufacturerCode ? scoDets.manufacturerCode.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 31
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '26. Multiplying Factor:: '
            var text2 = scoDets.multiplyingFactor ? scoDets.multiplyingFactor.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 32
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '27. Meter Range: '
            var text2 = scoDets.meterRange ? scoDets.meterRange.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 33
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '28. Meter Reading: '
            var text2 = scoDets.meterReading ? scoDets.meterReading.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 34
            var line2Height = line2Height + lineHeightIncreament
            doc.text('Note: Where sets are more than one give information (18 to 25) of remaining set on reverse.', doc.internal.pageSize.getWidth() / 2, line2Height, {
                align: 'center',
            });
            //#endregion

            //#region Line 35
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = `29. Date of Connection: `
            var text2 = scoDets.dateOfConnection ? convertDate(scoDets.dateOfConnection) : '-'
            var text3 = 'Cp-79 item No.: '
            var text4 = scoDets.cp78ItemNo ? scoDets.cp78ItemNo.toString() : '-'
            var leftSpace = 56.5

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
            //#endregion

            //#region Line 36
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var leftSpace = 35
            var text1 = '30. Meter Rent: '
            var text2 = dnDets.meterRent ? numberFormatting(dnDets.meterRent) : '-'
            var text3 = 'Service Rent: '
            var text4 = dnDets.serviceRent ? numberFormatting(dnDets.serviceRent) : '-'
            var text5 = scoDets.tieUpNonTieUp ? scoDets.tieUpNonTieUp === 0 ? 'Non-Tie Up' : 'Tie Up' : '-'


            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

            doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
            doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

            doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
            //#endregion

            //#region Line 37
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '31. Signature of Consumer in Token of Installation of Connection: ____________________________________________________ '

            doc.text(text1, padding, line2Height);
            //#endregion

            //#region Line 38
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '32. Signature of Consumer in Token of Receipt of Meter Reading Card: ________________________________________________ '

            doc.text(text1, padding, line2Height);
            //#endregion

            //#region Line 39
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '33. Seal on the meter: '
            var text2 = scoDets.sealOnMeter ? scoDets.sealOnMeter : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 40
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '34. Seal on the box: '
            var text2 = scoDets.sealOnBox ? scoDets.sealOnBox : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 41
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '34-A. Security Slip / Price Bond No.: '
            var text2 = scoDets.securitySlipOrPriceBondNo ? scoDets.securitySlipOrPriceBondNo.toString() : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 42
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = '35. Connection Installed By: '
            var text2 = scoDets.connectionInstallerName ? scoDets.connectionInstallerName : '-'

            doc.text(text1, padding, line2Height);
            doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
            doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
            //#endregion

            //#region Line 43
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = 'Signature: __________________________'
            var leftSpace = 122

            doc.text(text1, padding + leftSpace, line2Height);
            //#endregion

            //#region Line 44
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = 'Designation: ________________________'
            var leftSpace = 122

            doc.text(text1, padding + leftSpace, line2Height);
            //#endregion

            //#region Line 45  
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = 'Stamp: ____________________________'
            var leftSpace = 122

            doc.text(text1, padding + leftSpace, line2Height);
            //#endregion

            //#region Line 46
            var line2Height = line2Height + lineHeightIncreament
            var lineSpace = 10
            var text1 = 'UserName: '

            doc.text(text1, padding, line2Height);
            doc.text(userName, padding + doc.getTextWidth(text1), line2Height);
            //#endregion

            //#endregion

            const totalPages = doc.internal.getNumberOfPages();

            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.addImage(getWaterMarkLogo(userCompany), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
            }


            const pdfBlob = doc.output('blob');
            const pdfDataUrl = URL.createObjectURL(pdfBlob);

            // Open the PDF in a new tab
            window.open(pdfDataUrl, '_blank');
        }
        catch (e) {
            console.log("Unable to generate Master Data Form!", e)
        }
        setViewBackdrop(false)
    }

    const downloadMasterData = async (applicationId) => {
        setViewBackdrop(true)
        try {

            let application = netMeterApplications.find(item => item.applicationId === applicationId)


            let dnDets, scoDets, masterDataFormDets;

            await callAsyncDnDetailsAPI(applicationId)
                .then(response => {
                    dnDets = response
                });

            await callAsyncGetSCOAPI(applicationId)
                .then(response => {
                    scoDets = response;
                });

            await callAsyncGetCP136API(applicationId)
                .then(response => {
                    masterDataFormDets = response;
                });

            //#region text
            const doc = new jsPDF({ compressPdf: true });
            doc.setFontSize(10);
            doc.text('MASTER DATA ADDITION / CHANGE FORM', doc.internal.pageSize.getWidth() / 2, 10, {
                align: 'center',
            });
            doc.text('(For General Consumer Only)', doc.internal.pageSize.getWidth() / 2, 15, {
                align: 'center',
            });
            doc.setFontSize(8);
            doc.text('Name & Address of Consumer', doc.internal.pageSize.getWidth() / 2, 100, {
                align: 'center',
            });
            doc.setFontSize(8);
            doc.text('Meter Information', doc.internal.pageSize.getWidth() / 2, 140, {
                align: 'center',
            });
            doc.setFontSize(8);
            doc.text('Reason: New Connection', 20, 180, {
            });
            //#endregion


            // Set default properties for the table
            const tableProps1 = {
                margin: { top: 20, right: 20, bottom: 20, left: 20 },
                cellHeight: 10,
                headerColor: '#000',
                rowColors: ['#EEE', '#FFF'],
                lineWidth: 0.1,
                lineColor: '#000', // Solid black border color
                headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                styles: {
                    fontSize: 7,
                    fontStyle: 'normal',
                },
            };

            // const header = [[{ colSpan: 3, content: 'Reference Number' }, { rowSpan: 2, content: 'Sub Batch' }, { rowSpan: 2, content: 'Tariff Code' }, { colSpan: 2, content: 'Application Registration' }, { colSpan: 2, content: 'Security Deposit' }]];

            const header1 = [
                [
                    { colSpan: 3, content: ['Reference Number'] },
                    { colSpan: 1, rowSpan: 2, content: ['Sub Batch'] },
                    { rowSpan: 2, content: ['Tariff Code'] },
                    { colSpan: 2, content: 'Application Registration' },
                    { colSpan: 2, content: 'Security Deposit' },
                ],
            ];

            const data1 = [
                ['Batch #', 'Sub Div.', 'Account Number', '', '', 'Number', 'Date', 'Number', 'Date'],
                [dnDets.batchNo ? dnDets.batchNo : "-", application.subDivisionCode ? application.subDivisionCode.toString() : '-', dnDets.consumerAccountNo ? dnDets.consumerAccountNo.toString() : '-', scoDets.subBatch ? scoDets.subBatch.toString() : '-', dnDets.tariff ? dnDets.tariff.toString().slice(0, 7) : '-', dnDets.tariff ? dnDets.tariff.toString().slice(0, 1).concat(application.applicationId.slice(4)) : '-', application.creationDate ? convertDate(application.creationDate) : '-', dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-', dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'],
            ];

            doc.autoTable({
                startY: 20,
                head: header1,
                body: data1,
                theme: 'grid',
                ...tableProps1,
            });

            // Set default properties for the table
            const tableProps2 = {
                margin: { top: 20, right: 20, bottom: 20, left: 20 },
                cellHeight: 10,
                headerColor: '#000',
                rowColors: ['#EEE', '#FFF'],
                lineWidth: 0.1,
                lineColor: '#000', // Solid black border color
                headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                styles: {
                    fontSize: 7,
                    fontStyle: 'normal',
                },
            };


            const header2 = [
                [
                    { rowSpan: 2, content: ['Date of Connection'] },
                    { rowSpan: 2, content: ['Sanctioned Load'] },
                    { colSpan: 8, content: ['Codes'] },
                    { colSpan: 2, content: ['Total Number of'] },
                ],
            ];

            const data2 = [
                ['', '', 'R/U', 'F/U', 'Seasonal', 'Transformer', 'Electricity Duty', 'Government Department', 'Standard Classification', 'Income Tax', 'KWh Meters', 'Air Cond'],
                [scoDets.dateOfConnection, scoDets.senctionLoad, scoDets.urbanRural, scoDets.fataPata, scoDets.seasonalFlag, scoDets.installedTransformerCapacity, masterDataFormDets.electricityDuty, masterDataFormDets.governmentDepartment, masterDataFormDets.standardClassificationCode, masterDataFormDets.incomeTax, scoDets.noOfMeters, scoDets.noOfACs],
            ];

            doc.autoTable({
                startY: 50,
                head: header2,
                body: data2,
                theme: 'grid',
                ...tableProps2,
            });

            // Set default properties for the tables
            const tableProps3 = {
                margin: { top: 20, right: 20, bottom: 20, left: 20 },
                cellWidth: 30,
                cellHeight: 10,
                headerColor: '#000',
                rowColors: ['#EEE', '#FFF'],
                lineWidth: 0.1,
                lineColor: '#000', // Solid black border color
                headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                styles: {
                    fontSize: 7,
                    fontStyle: 'normal',
                },
            };

            const header3 = [['Meter Rent', 'Service Rent', 'National Identity Card No.']];
            const data3 = [[dnDets.meterRent, dnDets.serviceRent, application.applicantCNIC]];

            doc.autoTable({
                head: header3,
                startY: 80,
                body: data3,
                theme: 'grid',
                tableWidth: 80,
                ...tableProps3,
            });

            // Set default properties for the tables
            const tableProps4 = {
                margin: { top: 20, right: 20, bottom: 20, left: 140 },
                align: 'right',
                cellWidth: 30,
                cellHeight: 10,
                headerColor: '#000',
                rowColors: ['#EEE', '#FFF'],
                lineWidth: 0.1,
                lineColor: '#000', // Solid black border color
                headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                styles: {
                    fontSize: 7,
                    fontStyle: 'normal',
                },
            };

            const header4 = [['Store Requisition No.', 'Date']];
            const data4 = [[scoDets.storeRequisitionNo, convertDate(scoDets.scoCreationDate)]];

            doc.autoTable({
                head: header4,
                startY: 80,
                body: data4,
                theme: 'grid',
                tableWidth: 50,
                ...tableProps4,
            });

            // Set default properties for the table
            const tableProps5 = {
                margin: { top: 20, right: 20, bottom: 20, left: 20 },
                cellHeight: 10,
                cellWidth: 5,
                headerColor: '#000',
                rowColors: ['#EEE', '#FFF'],
                lineWidth: 0.1,
                lineColor: '#000', // Solid black border color
                headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                styles: {
                    fontSize: 7,
                    fontStyle: 'normal',
                },
            };


            const header5 = [
                [
                    'Name',
                    { colSpan: 3, content: [application.applicantName] },
                ],
            ];

            const data5 = [
                ['Address', { colSpan: 3, content: [application.premisesAddress] }],
                ['Cell No.', application.applicantMobile, 'Email Address', application.applicantEmail],
            ];

            doc.autoTable({
                startY: 105,
                head: header5,
                body: data5,
                theme: 'grid',
                ...tableProps5,
            });

            // Set default properties for the table
            const tableProps6 = {
                margin: { top: 20, right: 20, bottom: 20, left: 20 },
                cellHeight: 10,
                cellWidth: [5, 10, 10, 10, 10, 10, 10],
                headerColor: '#000',
                rowColors: ['#EEE', '#FFF'],
                lineWidth: 0.1,
                lineColor: '#000', // Solid black border color
                headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                styles: {
                    fontSize: 7,
                    fontStyle: 'normal',
                },
            };


            const header6 = [
                [
                    'Meter Seq. No.',
                    'Feeder Code',
                    'Meter Number',
                    'Location Code',
                    'Manufacturer Code',
                    'Meter Code',
                    'Multiplying Factor',
                    'Meter Range',
                    'Initial Meter Reading',
                ],
            ];

            const data6 = [
                ['1', scoDets.feederNo, scoDets.meterNo, scoDets.locationCode, scoDets.manufacturerCode, scoDets.meterCode, scoDets.multiplyingFactor, scoDets.meterRange, scoDets.meterReading]
            ];

            doc.autoTable({
                startY: 145,
                head: header6,
                body: data6,
                theme: 'grid',
                ...tableProps6,
            });
            console.log('Saving File')

            const totalPages = doc.internal.getNumberOfPages();

            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.addImage(getWaterMarkLogo(userCompany), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
            }
            const pdfBlob = doc.output('blob');
            const pdfDataUrl = URL.createObjectURL(pdfBlob);

            // Open the PDF in a new tab
            window.open(pdfDataUrl, '_blank');
        }
        catch (e) {
            console.log("Unable to generate Master Data Form!", e)
            console.log(e)
        }
        setViewBackdrop(false)

    }

    const downloadEFile = async (applicationId) => {
        setViewBackdrop(true)
        try {
            let eFileDataLocal = []

            var formdata = new FormData();
            formdata.append("applicationId", applicationId);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "electricityNewConnection/getApplicationHist", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let applicationCurrentState = result.applicationCurrentState[0]
                        let applicationHistory = result.applicationHistory
                        if (applicationHistory === "No History Found") {
                            applicationHistory = []
                        }

                        applicationHistory = applicationHistory.filter((item) => { return item.lastModificationDate })

                        applicationHistory.push(applicationCurrentState)
                        let sortedApplicationHistory = applicationHistory.sort((a, b) => {
                            const dateA = new Date(a.lastModificationDate)
                            const dateB = new Date(b.lastModificationDate)
                            return dateB - dateA
                        });
                        eFileDataLocal = sortedApplicationHistory;
                    }
                }).catch(error => console.log('Error in Efile Api'))

            let dnDets, scoDets, masterDataFormDets, applicationDocs;

            let application = netMeterApplications.find(item => item.applicationId === applicationId)

            await callAsyncGetDocumentsAPI(applicationId)
                .then(response => {
                    applicationDocs = response;
                })

            const copyOfApplicantCNICFront = applicationDocs.copyOfApplicantCNICFront ? applicationDocs.copyOfApplicantCNICFront : ''
            const copyOfApplicantCNICBack = applicationDocs.copyOfApplicantCNICBack ? applicationDocs.copyOfApplicantCNICBack : ''
            const premisesDocument = applicationDocs.premisesDocument ? applicationDocs.premisesDocument : ''
            const scannedCopyOfNearByElectricityBill = applicationDocs.scannedCopyOfNearByElectricityBill ? applicationDocs.scannedCopyOfNearByElectricityBill : ''
            const copyOfOwnertCNIC = applicationDocs.copyOfOwnertCNIC ? applicationDocs.copyOfOwnertCNIC : ''
            const ownerNOC = applicationDocs.ownerNOC ? applicationDocs.ownerNOC : ''
            const resolutionFormDesc = applicationDocs.resolutionFormDesc ? applicationDocs.resolutionFormDesc : ''
            const certMemoDesc = applicationDocs.certMemoDesc ? applicationDocs.certMemoDesc : ''
            const certFormDesc = applicationDocs.certFormDesc ? applicationDocs.certFormDesc : ''


            if (application.applicationProgressId >= 4) {
                await callAsyncDnDetailsAPI(applicationId)
                    .then(response => {
                        dnDets = response
                    });
            }

            if (application.applicationProgressId >= 6) {
                await callAsyncGetSCOAPI(applicationId)
                    .then(response => {
                        scoDets = response;
                    });
            }

            if (application.applicationProgressId) {
                await callAsyncGetCP136API(applicationId)
                    .then(response => {
                        masterDataFormDets = response;
                    });
            }


            const doc = new jsPDF({ compressPdf: true });

            var pageWidth = doc.internal.pageSize.getWidth();
            var pageHeight = doc.internal.pageSize.getHeight();

            // Generate the barcode image using JsBarcode
            const barcodeCanvas = document.createElement('canvas');
            JsBarcode(barcodeCanvas, applicationId);

            // Convert the barcode image to data URL
            const barcodeDataURL = barcodeCanvas.toDataURL('image/png');
            var height = 10;
            var padding = 10;

            // Add the barcode image to the PDF document
            doc.addImage(barcodeDataURL, 'PNG', 164, height, 40, 20); // Adjust the position and size of the barcode image
            doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

            var increment = 15;
            height = height + increment
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 8;
            height = height + increment;
            doc.setFontSize(18);
            doc.text('E-Document', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            height = height + increment;
            doc.setFontSize(12);
            doc.setFont('helvetica', 'normal');
            var increment = 8;
            var height = height + increment
            var leftMargin = 50
            doc.text('Document Type: ', padding, height);
            doc.text('New Connection', padding + leftMargin, height);
            doc.text('Tracking Id:', padding + leftMargin + leftMargin, height);
            doc.text(applicationId, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Application Status: ', padding, height);
            doc.text(statusFunc(application.applicationProgressId, application.objectionStatus), padding + leftMargin, height);
            doc.text('Application Date:', padding + leftMargin + leftMargin, height);
            doc.text(convertDate(application.creationDate), padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Sub-Division: ', padding, height);
            doc.text(subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions), padding + leftMargin, height);
            doc.text('Connection Type:', padding + leftMargin + leftMargin, height);
            doc.text(application.connectionType, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Phase / Load: ', padding, height);
            doc.text(application.appliedLoad.toString(), padding + leftMargin, height);
            doc.text('Connection Date:', padding + leftMargin + leftMargin, height);
            doc.text('-', padding + leftMargin + leftMargin + leftMargin, height);

            increment = 20;
            height = height + increment
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 10; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            doc.setFillColor(199, 199, 199);
            // Draw the rectangle
            doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');

            doc.setFont('helvetica', 'bold');
            doc.text('Applicant Particulars', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 6;
            var height = height + increment
            // Get the page width and height

            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 30; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            // Draw the rectangle
            doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

            doc.setFont('helvetica', 'normal');
            increment = 8;
            var height = height + increment
            var leftMargin = 70
            var extraPadding = 5
            doc.text('Applicant Name:', padding + extraPadding, height);
            doc.text(application.applicantName, padding + leftMargin, height);

            increment = 6;
            var height = height + increment
            var leftMargin = 70
            doc.text('CNIC No.:', padding + extraPadding, height);
            doc.text(application.applicantCNIC, padding + leftMargin, height);

            var height = height + increment
            var leftMargin = 70
            doc.text('Present Address:', padding + extraPadding, height);
            doc.text(application.premisesAddress, padding + leftMargin, height);

            increment = 20;
            height = height + increment
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 10; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            doc.setFillColor(199, 199, 199);
            // Draw the rectangle
            doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
            doc.setFont('helvetica', 'bold');
            doc.text('Application Summary', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            doc.setFontSize(12)
            increment = 3.5;
            var height = height + increment
            // Get the page width and height
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 122.5; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            // Draw the rectangle
            doc.rect(rectX, height, rectWidth, rectHeight);

            // Set default properties for the table
            const summaryTableProps = {
                margin: { top: 20, right: 20, bottom: 20, left: 20 },
                cellHeight: 10,
                headerColor: '#000',
                rowColors: ['#EEE', '#FFF'],
                lineWidth: 1,
                lineColor: '#000', // Solid black border color
                headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0, halign: 'center', valign: 'middle', fontSize: 11, fontWeight: 'bold' },
                styles: {
                    fontSize: 11,
                    fontStyle: 'normal',
                    lineWidth: 0,
                    lineColor: [0, 0, 0],
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                },
                alternateRowStyles: {
                    fillColor: [235, 235, 235], // Grey color for alternate rows
                },
            };

            const summaryHeader = [
                [
                    'Sr.',
                    'Step',
                    'Processed By',
                    'Date',
                    'Time',
                    'Remarks',
                ],
            ];

            const summaryData = [];

            for (let i = 0; i < eFileDataLocal.length; i++) {
                const rowData = eFileDataLocal[i];
                if (rowData.applicationProgressId != 1) {
                    const stepNumber = i + 1;
                    const stepProgressId = stepName(rowData.applicationProgressId);
                    const lastModifiedBy = rowData.lastModifiedBy;
                    const lastModificationDate = convertDatewithTime(rowData.lastModificationDate).slice(0, 11);

                    const lastModificationTime = convertDatewithTime(rowData.lastModificationDate).slice(11);
                    const remarks = rowData.remarks;

                    const row = [
                        stepNumber.toString(),
                        stepProgressId,
                        lastModifiedBy,
                        lastModificationDate,
                        lastModificationTime,
                        remarks
                    ];

                    summaryData.push(row);
                }
            }

            doc.autoTable({
                startY: 140,
                head: summaryHeader,
                body: summaryData,
                theme: 'grid',
                ...summaryTableProps,
            });

            if (application.applicationProgressId >= 7) {
                doc.addPage()
                //#region Master Data Form
                //#region text
                doc.setFontSize(10);
                doc.text('MASTER DATA ADDITION / CHANGE FORM', doc.internal.pageSize.getWidth() / 2, 10, {
                    align: 'center',
                });
                doc.text('(For General Consumer Only)', doc.internal.pageSize.getWidth() / 2, 15, {
                    align: 'center',
                });
                doc.setFontSize(8);
                doc.text('Name & Address of Consumer', doc.internal.pageSize.getWidth() / 2, 100, {
                    align: 'center',
                });
                doc.setFontSize(8);
                doc.text('Meter Information', doc.internal.pageSize.getWidth() / 2, 140, {
                    align: 'center',
                });
                doc.setFontSize(8);
                doc.text('Reason: New Connection', 20, 180, {
                });
                //#endregion


                // Set default properties for the table
                const tableProps1 = {
                    margin: { top: 20, right: 20, bottom: 20, left: 20 },
                    cellHeight: 10,
                    headerColor: '#000',
                    rowColors: ['#EEE', '#FFF'],
                    lineWidth: 0.1,
                    lineColor: '#000', // Solid black border color
                    headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                    styles: {
                        fontSize: 7,
                        fontStyle: 'normal',
                    },
                };

                // const header = [[{ colSpan: 3, content: 'Reference Number' }, { rowSpan: 2, content: 'Sub Batch' }, { rowSpan: 2, content: 'Tariff Code' }, { colSpan: 2, content: 'Application Registration' }, { colSpan: 2, content: 'Security Deposit' }]];

                const header1 = [
                    [
                        { colSpan: 3, content: ['Reference Number'] },
                        { colSpan: 1, rowSpan: 2, content: ['Sub Batch'] },
                        { rowSpan: 2, content: ['Tariff Code'] },
                        { colSpan: 2, content: 'Application Registration' },
                        { colSpan: 2, content: 'Security Deposit' },
                    ],
                ];

                const data1 = [
                    ['Batch #', 'Sub Div.', 'Account Number', '', '', 'Number', 'Date', 'Number', 'Date'],
                    [dnDets.batchNo ? dnDets.batchNo : "-", application.subDivisionCode ? application.subDivisionCode.toString() : '-', dnDets.consumerAccountNo ? dnDets.consumerAccountNo.toString() : '-', scoDets.subBatch ? scoDets.subBatch.toString() : '-', dnDets.tariff ? dnDets.tariff.toString().slice(0, 7) : '-', dnDets.tariff ? dnDets.tariff.toString().slice(0, 1).concat(application.applicationId.slice(4)) : '-', application.creationDate ? convertDate(application.creationDate) : '-', dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-', dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'],
                ];

                doc.autoTable({
                    startY: 20,
                    head: header1,
                    body: data1,
                    theme: 'grid',
                    ...tableProps1,
                });

                // Set default properties for the table
                const tableProps2 = {
                    margin: { top: 20, right: 20, bottom: 20, left: 20 },
                    cellHeight: 10,
                    headerColor: '#000',
                    rowColors: ['#EEE', '#FFF'],
                    lineWidth: 0.1,
                    lineColor: '#000', // Solid black border color
                    headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                    styles: {
                        fontSize: 7,
                        fontStyle: 'normal',
                    },
                };


                const header2 = [
                    [
                        { rowSpan: 2, content: ['Date of Connection'] },
                        { rowSpan: 2, content: ['Sanctioned Load'] },
                        { colSpan: 8, content: ['Codes'] },
                        { colSpan: 2, content: ['Total Number of'] },
                    ],
                ];

                const data2 = [
                    ['', '', 'R/U', 'F/U', 'Seasonal', 'Transformer', 'Electricity Duty', 'Government Department', 'Standard Classification', 'Income Tax', 'KWh Meters', 'Air Cond'],
                    [scoDets.dateOfConnection, scoDets.senctionLoad, scoDets.urbanRural, scoDets.fataPata, scoDets.seasonalFlag, scoDets.installedTransformerCapacity, masterDataFormDets.electricityDuty, masterDataFormDets.governmentDepartment, masterDataFormDets.standardClassificationCode, masterDataFormDets.incomeTax, scoDets.noOfMeters, scoDets.noOfACs],
                ];

                doc.autoTable({
                    startY: 50,
                    head: header2,
                    body: data2,
                    theme: 'grid',
                    ...tableProps2,
                });

                // Set default properties for the tables
                const tableProps3 = {
                    margin: { top: 20, right: 20, bottom: 20, left: 20 },
                    cellWidth: 30,
                    cellHeight: 10,
                    headerColor: '#000',
                    rowColors: ['#EEE', '#FFF'],
                    lineWidth: 0.1,
                    lineColor: '#000', // Solid black border color
                    headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                    styles: {
                        fontSize: 7,
                        fontStyle: 'normal',
                    },
                };

                const header3 = [['Meter Rent', 'Service Rent', 'National Identity Card No.']];
                const data3 = [[dnDets.meterRent, dnDets.serviceRent, application.applicantCNIC]];

                doc.autoTable({
                    head: header3,
                    startY: 80,
                    body: data3,
                    theme: 'grid',
                    tableWidth: 80,
                    ...tableProps3,
                });

                // Set default properties for the tables
                const tableProps4 = {
                    margin: { top: 20, right: 20, bottom: 20, left: 140 },
                    align: 'right',
                    cellWidth: 30,
                    cellHeight: 10,
                    headerColor: '#000',
                    rowColors: ['#EEE', '#FFF'],
                    lineWidth: 0.1,
                    lineColor: '#000', // Solid black border color
                    headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                    styles: {
                        fontSize: 7,
                        fontStyle: 'normal',
                    },
                };

                const header4 = [['Store Requisition No.', 'Date']];
                const data4 = [[scoDets.storeRequisitionNo, convertDate(scoDets.scoCreationDate)]];

                doc.autoTable({
                    head: header4,
                    startY: 80,
                    body: data4,
                    theme: 'grid',
                    tableWidth: 50,
                    ...tableProps4,
                });

                // Set default properties for the table
                const tableProps5 = {
                    margin: { top: 20, right: 20, bottom: 20, left: 20 },
                    cellHeight: 10,
                    cellWidth: 5,
                    headerColor: '#000',
                    rowColors: ['#EEE', '#FFF'],
                    lineWidth: 0.1,
                    lineColor: '#000', // Solid black border color
                    headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                    styles: {
                        fontSize: 7,
                        fontStyle: 'normal',
                    },
                };


                const header5 = [
                    [
                        'Name',
                        { colSpan: 3, content: [application.applicantName] },
                    ],
                ];

                const data5 = [
                    ['Address', { colSpan: 3, content: [application.premisesAddress] }],
                    ['Cell No.', application.applicantMobile, 'Email Address', application.applicantEmail],
                ];

                doc.autoTable({
                    startY: 105,
                    head: header5,
                    body: data5,
                    theme: 'grid',
                    ...tableProps5,
                });

                // Set default properties for the table
                const tableProps6 = {
                    margin: { top: 20, right: 20, bottom: 20, left: 20 },
                    cellHeight: 10,
                    cellWidth: [5, 10, 10, 10, 10, 10, 10],
                    headerColor: '#000',
                    rowColors: ['#EEE', '#FFF'],
                    lineWidth: 0.1,
                    lineColor: '#000', // Solid black border color
                    headStyles: { fillColor: '#FFF', textColor: '#000', lineWidth: 0.1, halign: 'center', valign: 'middle', fontSize: 7 },
                    styles: {
                        fontSize: 7,
                        fontStyle: 'normal',
                    },
                };


                const header6 = [
                    [
                        'Meter Seq. No.',
                        'Feeder Code',
                        'Meter Number',
                        'Location Code',
                        'Manufacturer Code',
                        'Meter Code',
                        'Multiplying Factor',
                        'Meter Range',
                        'Initial Meter Reading',
                    ],
                ];

                const data6 = [
                    ['1', scoDets.feederNo, scoDets.meterNo, scoDets.locationCode, scoDets.manufacturerCode, scoDets.meterCode, scoDets.multiplyingFactor, scoDets.meterRange, scoDets.meterReading]
                ];

                doc.autoTable({
                    startY: 145,
                    head: header6,
                    body: data6,
                    theme: 'grid',
                    ...tableProps6,
                });

                //#endregion
            }

            if (application.applicationProgressId >= 6) {
                doc.addPage()
                doc.setFontSize(9)
                //#region SCO

                var fontSize = 8;

                //#region Line 1 
                var padding = 10
                var line2Height = 10
                var lineHeightIncreament = 6
                doc.setFontSize(fontSize);
                doc.text(companyName(applicationId.slice(0, 2)), doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 2
                var line2Height = line2Height + lineHeightIncreament
                doc.text('Service Connection Order (SCO)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 3
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '1. Sub Division: '
                var text2 = application.subDivisionCode ? application.subDivisionCode.toString().concat(' / ').concat(subdivisionName(application.subDivisionCode, subDivisions)) : '-'
                var text3 = 'SCO No.: '
                var text4 = scoDets.scoId ? scoDets.scoId : '-'
                var text5 = 'Creation Date: '
                var text6 = scoDets.dateOfAuthorization ? convertDate(scoDets.dateOfAuthorization) : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
                //#endregion

                //#region Line 4
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 2
                var text1 = '2. Application No.: '
                var text2 = application.applicationId ? application.applicationId : '-'
                var text3 = 'Date: '
                var text4 = application.creationDate ? convertDate(application.creationDate) : '-'
                var text5 = 'Tariff: '
                var text6 = dnDets.tariff ? dnDets.tariff : '-'
                var text7 = scoDets.fataPata ? scoDets.fataPata : '-'
                var text8 = scoDets.urbanRural ? scoDets.urbanRural : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
                doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 7), line2Height);
                doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 8), line2Height);
                //#endregion

                //#region Line 5
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '3. Account No.: '
                var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
                var text3 = 'Feeder No.: '
                var text4 = scoDets.feederNo ? scoDets.feederNo : '-'
                var text5 = 'Batch: '
                var text6 = scoDets.batch ? scoDets.batch : '-'
                var text7 = 'Sub Batch: '
                var text8 = scoDets.subBatch ? scoDets.subBatch : '-'


                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

                doc.text(text7, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + padding + (lineSpace * 6), line2Height);
                doc.text(text8, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 7), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 6), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + doc.getTextWidth(text6) + doc.getTextWidth(text7) + padding + (lineSpace * 6) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

                //#endregion

                //#region Line 6
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `4. Applicant's Name: `
                var text2 = application.applicantName ? application.applicantName : '-'
                var text3 = 'CNIC/NIC/NICOP: '
                var text4 = application.applicantCNIC ? application.applicantCNIC : '-'
                var leftSpace = 50

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 7
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `5. Address: `
                var text2 = application.premisesAddress ? application.premisesAddress : '-'
                var text3 = 'Mobile No.: '
                var text4 = application.applicantMobile ? application.applicantMobile : '-'
                var leftSpace = 50

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 8
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `6. Service Connection Cost DN No.: `
                var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
                var text3 = 'Issuance Date: '
                var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
                var leftSpace = 35

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 9
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `7. Security Deposit DN No.: `
                var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
                var text3 = 'Issuance Date: '
                var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
                var leftSpace = 47

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 10
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `8. Amount of Service Connection: `
                var text2 = dnDets.capitalCostAmount ? numberFormatting(dnDets.capitalCostAmount) : '-'
                var text3 = 'Payment Date: '
                var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
                var leftSpace = 52

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 11
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `9. Amount of Security Deposit: `
                var text2 = dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-'
                var text3 = 'Payment Date: '
                var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
                var leftSpace = 56.5

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 12
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '10. F. Govt / Autonomous and Local Bodies under Prov. Govt.: '
                var text2 = scoDets.fGovt ? scoDets.fGovt : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 13
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '11. Cantonment Board: '
                var text2 = scoDets.cantonmentBoard ? scoDets.cantonmentBoard : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 14
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '12. Prov. Govt / Autonomous and Local Bodies under Prov Govt.: '
                var text2 = scoDets.pGovt ? scoDets.pGovt : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 15
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '13. Local Bodies: '
                var text2 = scoDets.localBodies ? scoDets.localBodies : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 16
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `14. Authorized By (Name): `
                var text2 = userName ? userName : '-'
                var text3 = 'Signature: ______________________'
                var leftSpace = 62

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                //#endregion

                //#region Line 17
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = 'Authorization Date: '
                var text2 = scoDets.dateOfAuthorization ? convertDate(scoDets.dateOfAuthorization) : '-'
                var leftSpace = 122

                doc.text(text1, padding + leftSpace, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 18
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = 'Designation: __________________________'
                var leftSpace = 122

                doc.text(text1, padding + leftSpace, line2Height);
                //#endregion

                //#region Line 19
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = 'Stamp: ______________________________'
                var leftSpace = 122

                doc.text(text1, padding + leftSpace, line2Height);
                //#endregion

                //#region Line 20
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `15. Store Requisition No.: `
                var text2 = scoDets.storeRequisitionNo ? numberFormatting(scoDets.storeRequisitionNo) : '-'
                var text3 = 'Requisition Date: '
                var text4 = scoDets.storeRequisitionDate ? convertDate(scoDets.storeRequisitionDate) : '-'
                var leftSpace = 56.5

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 21
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '16. Nature as per Standard Classification Code Booklet: '
                var text2 = dnDets.tariff ? dnDets.tariff : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 22
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `17. Seasonal/Non-Seasonal: `
                var text2 = scoDets.seasonalFlag ? scoDets.seasonalFlag.toString() : '-'
                var text3 = 'Sanctioned Load: '
                var text4 = dnDets.sanctionLoad ? dnDets.sanctionLoad.toString() : '-'
                var leftSpace = 74

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 23
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `18. No. of meters: `
                var text2 = scoDets.noOfMeters ? scoDets.noOfMeters.toString() : '-'
                var text3 = 'No. of AC/Centrally Air Conditioned Code: '
                var text4 = scoDets.noOfACs ? scoDets.noOfACs.toString() : '-'
                var leftSpace = 57

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 24
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var leftSpace = 18
                var text1 = '19. No. of meter sets: '
                var text2 = scoDets.noOfMeterSets ? scoDets.noOfMeterSets.toString() : '-'
                var text3 = 'No. of sub sets: '
                var text4 = scoDets.noOfSubSets ? scoDets.noOfSubSets.toString() : '-'
                var text5 = 'No. of supply points: '
                var text6 = scoDets.noOfSupplyPoints ? scoDets.noOfSupplyPoints.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + (leftSpace * 2), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + (leftSpace * 2), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + (leftSpace * 2), line2Height + 1);
                //#endregion

                //#region Line 25
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '20. Installed Transformer Capacity: '
                var text2 = scoDets.installedTransformerCapacity ? scoDets.installedTransformerCapacity.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 26
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '21. Meter Id: '
                var text2 = scoDets.meterId ? scoDets.meterId.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 27
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '22. Meter Number: '
                var text2 = scoDets.meterNo ? scoDets.meterNo.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 28
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '23. Location Code: '
                var text2 = scoDets.locationCode ? scoDets.locationCode.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 29
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '24. Meter Code: '
                var text2 = scoDets.meterCode ? scoDets.meterCode.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 30
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '25. Manufacturer Code: '
                var text2 = scoDets.manufacturerCode ? scoDets.manufacturerCode.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 31
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '26. Multiplying Factor:: '
                var text2 = scoDets.multiplyingFactor ? scoDets.multiplyingFactor.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 32
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '27. Meter Range: '
                var text2 = scoDets.meterRange ? scoDets.meterRange.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 33
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '28. Meter Reading: '
                var text2 = scoDets.meterReading ? scoDets.meterReading.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 34
                var line2Height = line2Height + lineHeightIncreament
                doc.text('Note: Where sets are more than one give information (18 to 25) of remaining set on reverse.', doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 35
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = `29. Date of Connection: `
                var text2 = scoDets.dateOfConnection ? convertDate(scoDets.dateOfConnection) : '-'
                var text3 = 'Cp-79 item No.: '
                var text4 = scoDets.cp78ItemNo ? scoDets.cp78ItemNo.toString() : '-'
                var leftSpace = 56.5

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 36
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var leftSpace = 35
                var text1 = '30. Meter Rent: '
                var text2 = dnDets.meterRent ? numberFormatting(dnDets.meterRent) : '-'
                var text3 = 'Service Rent: '
                var text4 = dnDets.serviceRent ? numberFormatting(dnDets.serviceRent) : '-'
                var text5 = scoDets.tieUpNonTieUp ? scoDets.tieUpNonTieUp === 0 ? 'Non-Tie Up' : 'Tie Up' : '-'


                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (leftSpace * 2) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                //#endregion

                //#region Line 37
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '31. Signature of Consumer in Token of Installation of Connection: ____________________________________________________ '

                doc.text(text1, padding, line2Height);
                //#endregion

                //#region Line 38
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '32. Signature of Consumer in Token of Receipt of Meter Reading Card: ________________________________________________ '

                doc.text(text1, padding, line2Height);
                //#endregion

                //#region Line 39
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '33. Seal on the meter: '
                var text2 = scoDets.sealOnMeter ? scoDets.sealOnMeter : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 40
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '34. Seal on the box: '
                var text2 = scoDets.sealOnBox ? scoDets.sealOnBox : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 41
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '34-A. Security Slip / Price Bond No.: '
                var text2 = scoDets.securitySlipOrPriceBondNo ? scoDets.securitySlipOrPriceBondNo.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 42
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = '35. Connection Installed By: '
                var text2 = scoDets.connectionInstallerName ? scoDets.connectionInstallerName : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 43
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = 'Signature: __________________________'
                var leftSpace = 122

                doc.text(text1, padding + leftSpace, line2Height);
                //#endregion

                //#region Line 44
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = 'Designation: ________________________'
                var leftSpace = 122

                doc.text(text1, padding + leftSpace, line2Height);
                //#endregion

                //#region Line 18
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = 'Stamp: ____________________________'
                var leftSpace = 122

                doc.text(text1, padding + leftSpace, line2Height);
                //#endregion

                //#region Line 18
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 10
                var text1 = 'UserName: '

                doc.text(text1, padding, line2Height);
                doc.text(userName, padding + doc.getTextWidth(text1), line2Height);
                //#endregion


                //#endregion
            }

            if (application.applicationProgressId >= 5) {
                var fontSize = 8
                doc.setFontSize(fontSize);
                let paidDnImage = ''

                await callAsyncGetPaidDnImageAPI(applicationId)
                    .then(response => {
                        paidDnImage = response;
                    })


                //#region Paid Demand Notice Image
                if (paidDnImage != '') {
                    doc.addPage()
                    var pageWidth = doc.internal.pageSize.getWidth();
                    var pageHeight = doc.internal.pageSize.getHeight();
                    // Convert the barcode image to data URL
                    var height = 10;
                    var padding = 10;
                    // Add the barcode image to the PDF document
                    doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                    var increment = 15;
                    height = height + increment
                    doc.setFontSize(12);
                    doc.setFont('helvetica', 'bold');
                    doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                        align: 'center',
                    });

                    var increment = 10;
                    height = height + increment;
                    let extension = paidDnImage.slice(11, 15)
                    doc.text('Application Id: ', padding, height)
                    doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                    height = height + increment

                    var rectWidth = 195; // Width of the rectangle
                    var rectHeight = 10; // Height of the rectangle

                    // Calculate the coordinates for the rectangle
                    var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                    doc.setFillColor(199, 199, 199);
                    // Draw the rectangle
                    doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                    doc.setFont('helvetica', 'bold');
                    doc.text(`Paid Demand Notice Image`, doc.internal.pageSize.getWidth() / 2, height, {
                        align: 'center',
                    });
                    increment = 3.5;
                    var height = height + increment
                    // Get the page width and height
                    var rectWidth = 195; // Width of the rectangle
                    var rectHeight = 234; // Height of the rectangle

                    // Calculate the coordinates for the rectangle
                    var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                    // Draw the rectangle
                    doc.rect(rectX, height, rectWidth, rectHeight);
                    height = height + increment
                    let cardWidth = 190
                    let cardHeight = 228
                    var xPos = (pageWidth - cardWidth) / 2;
                    if (extension.startsWith('jp')) {
                        doc.addImage(paidDnImage, 'jpeg', xPos, height, cardWidth, cardHeight);
                    }
                    else if (extension.startsWith('pn')) {
                        doc.addImage(paidDnImage, 'png', xPos, height, cardWidth, cardHeight);
                    }
                }

                //#endregion
            }

            if (application.applicationProgressId >= 4) {
                doc.addPage()
                var fontSize = 8
                doc.setFontSize(fontSize);
                //#region Demand Notice

                //#region Line 1 
                var padding = 10
                var line2Height = 10
                var lineHeightIncreament = 5
                doc.text('DUE Date: ' + dnDets.dueDate ? convertDate(dnDets.dueDate) : '', padding, line2Height, {
                });
                doc.text(companyName(applicationId.slice(0, 2)).concat(application.appliedLoad < 15 ? '(' + applicationId.slice(0, 5) + "-" + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + ')' : '(' + applicationId.slice(0, 4) + '-' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ')'), doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 2
                var line2Height = line2Height + lineHeightIncreament
                doc.text('(Department of Electricity)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 3
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 12
                var text1 = 'Demand Notice Serial No.: '
                var text2 = dnDets.demandNoticeNo
                var text3 = 'Application Id: '
                var text4 = applicationId
                var text5 = 'Date: '
                var text6 = convertDate(dnDets.creationDate)

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
                //#endregion

                //#region Line 4
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 3.35
                var text1 = 'Demand Notice Issuance Date: '
                var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
                var text3 = 'Application Type: '
                var text4 = application.applicationType ? applicationName(application.applicationType) : '-'
                var text5 = 'New Connection, Reconnection etc.: '
                var text6 = application.applicationType ? applicationName(application.applicationType) : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
                //#endregion

                //#region Line 5
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 6.6
                var text1 = 'Account No. for acquisition connection: '
                var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
                var text3 = 'User Mobile No.: '
                var text4 = dnDets.applicantMobile ? dnDets.applicantMobile : '-'
                var text5 = 'Connection type: '
                var text6 = dnDets.connectionType ? dnDets.connectionType : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
                //#endregion

                //#region Line 6
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 7
                var text1 = '(under which the funds are to be deposited in the bank with the concerned officer of the institution)'
                var text2 = 'Industry / Factory:'
                var text3 = dnDets.industryFactoryType ? dnDets.industryFactoryType : '-'

                doc.setFontSize(6)
                doc.text(text1, padding, line2Height);
                doc.setFontSize(fontSize)
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + padding + (lineSpace), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + padding + (lineSpace * 2)) + (doc.getTextWidth(text3) + (lineSpace * 2)), line2Height + 1);

                //#endregion

                //#region Line 7
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 22.25
                var text1 = `Department's approved Bank name: `
                var text2 = dnDets.bankName ? dnDets.bankName : '-'
                var text3 = 'Applied Load(kW): '
                var text4 = application.appliedLoad ? application.appliedLoad.toString() : '|'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 8
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 22
                var text1 = `Department's Relevant Officer: `
                var text2 = application.appliedLoad ? application.appliedLoad < 15 ? subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) : divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) : '|'
                var text3 = 'Required Voltage: '
                var text4 = dnDets.voltage ? dnDets.voltage.toString() : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 9
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 16
                var text1 = `Coverage Area: `
                var text2 = dnDets.coverageAreaOfPremises ? dnDets.coverageAreaOfPremises : '|'
                var text3 = 'Alloted Tariff : '
                var text4 = dnDets.tariff ? dnDets.tariff : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 10
                var line2Height = line2Height + lineHeightIncreament

                doc.text('DEMAND NOTICE', doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 11
                var line2Height = line2Height + lineHeightIncreament

                doc.text('(Notification of Approval Application and Demand Under Guarantee)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 12
                var line2Height = line2Height + lineHeightIncreament

                doc.text(`Applicant's part`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 13
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 16
                var text1 = `Mr. / Mrs.`
                var text2 = application.applicantName ? application.applicantName.concat(' | ').concat(application.premisesAddress) : '|'
                var text3 = ``

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.setFontSize(6)
                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                //#endregion

                //#region Line 14
                lineHeightIncreament = 4
                var line2Height = line2Height + lineHeightIncreament
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the institution.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                for (var i = 0; i < lines.length; i++) {
                    doc.text(lines[i], padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 15
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfDays = '30'
                var text1 = `1. You should deposit the following amounts in the approved bank of the institution or with the concerned officer of the institution itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of their payment.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                for (var i = 0; i < lines.length; i++) {
                    var lineText = lines[i].replace("[word1]", noOfDays);
                    doc.text(lineText, padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 16
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfDays = '30'
                var text1 = `A. Expenditure service connection as per approved estimate [capitalCost] and Security [securityCost] PKR. (this amount is to be deposited with the concerned officer of the institution). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    var lineText = lines[i].replace("[capitalCost]", numberFormatting(dnDets.capitalCostAmount));
                    lineText = lineText.replace("[securityCost]", numberFormatting(dnDets.securityDepositeAmount));
                    doc.text(lineText, padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 17
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfDays = '30'
                var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    doc.text(lines[i], padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 18
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfDays = '30'
                var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    doc.text(lines[i], padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 19
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfDays = '30'
                var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    var lineText = lines[i].replace("[noOfDays]", noOfDays);
                    doc.text(lineText, padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 20
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var amount = '_____'
                var text1 = `3. Since you have not provided your purchased meter to the institution for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    var lineText = lines[i].replace("[amount]", amount);
                    doc.text(lineText, padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 21
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var amount = '_____'
                var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    var lineText = lines[i].replace("[amount]", amount);
                    doc.text(lineText, padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 22
                doc.text(`(Irrelevant should be cut down)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 23
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfMonth = '1'
                var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
                    doc.text(lineText, padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 24
                doc.setFontSize(fontSize)
                var text1 = `Regards`
                var spaceLeft = 100
                doc.text(text1, padding + spaceLeft, line2Height);
                //#endregion

                //#region Line 25
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var text1 = application.appliedLoad < 15 ? "Sub-Division Office " + applicationId.slice(0, 5) + '-' + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + 'SDO Wapda' : "Division Office " + applicationId.slice(0, 4) + ' - ' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ' XEN Wapda'
                doc.text(text1, padding + spaceLeft, line2Height);
                //#endregion

                //#region Line 26
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var text1 = 'Signature Bank Officer: '
                var text2 = application.appliedLoad < 15 ? 'Line Superintendent Office' + '(' + applicationId.slice(0, 5) + ' - ' + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + ') SDO Wapda' : 'Line Superintendent Office' + '(' + applicationId.slice(0, 4) + ' - ' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ') XEN Wapda'
                doc.text(text1, padding, line2Height);
                doc.text(text2, padding + spaceLeft, line2Height);
                //#endregion

                //#region Line 27
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                spaceLeft = 10
                var text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------'
                doc.text(text1, padding + spaceLeft, line2Height);
                //#endregion

                //#region Line 28
                lineHeightIncreament = 5
                var line2Height = line2Height + lineHeightIncreament
                doc.text('DUE Date: ' + dnDets.dueDate ? convertDate(dnDets.dueDate) : '', padding, line2Height, {
                });
                doc.text('For Bank Use Only', doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 29
                var line2Height = line2Height + lineHeightIncreament
                doc.text('(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)', doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 30
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 16
                var spaceLeft = 50

                var text1 = `1. Applicant's Name and Complete address `
                var text2 = application.applicantName ? application.applicantName.concat(' | ').concat(application.premisesAddress) : '|'
                var text3 = `Details of paid amount`

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.setFontSize(6)
                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2) + spaceLeft), line2Height);
                //#endregion

                //#region Line 31
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 6.6
                var text1 = '2. Application Id: '
                var text2 = application.applicationId ? application.applicationId : '-'
                var text3 = 'Date: '
                var text4 = application.creationDate ? convertDate(application.creationDate) : '-'
                var text5 = '1. Service Connection:'
                var text6 = dnDets.capitalCostAmount ? numberFormatting(dnDets.capitalCostAmount) : '-'
                var leftSpace = 40

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + leftSpace + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + leftSpace, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 32
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 6.6
                var text1 = '3. Demand Notice Serial No.: '
                var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
                var text3 = 'Date: '
                var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
                var text5 = '2. Security: '
                var text6 = dnDets.securityDepositeAmount ? numberFormatting(dnDets.securityDepositeAmount) : '-'
                var leftSpace = 35

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + leftSpace + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + leftSpace, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 33
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 6.6
                var text1 = '4. Account No. for acquisition connection: '
                var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
                var text3 = ' '
                var text4 = ' '
                var text5 = '3. Grid Share / Feeder Rehab. Charges:'
                var text6 = ' '
                var leftSpace = 10

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

                // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + leftSpace + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + leftSpace, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + leftSpace, line2Height + 1);
                //#endregion

                //#region Line 34
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 6.6
                var text1 = '5. Approved bank name and address:'
                var text2 = dnDets.bankName ? dnDets.bankName : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
                //#endregion

                //#region Line 35
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament + lineHeightIncreament
                var lineSpace = 6.6
                var text1 = application.appliedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
                var text2 = ' '
                var text3 = ' '
                var text4 = ' '
                var text5 = ' '
                var text6 = 'Signature Bank Officer '
                var leftSpace = 20
                doc.text(text1, padding, line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
                //#endregion

                //#region Line 36
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                var lineSpace = 6.6
                var text1 = 'with date and stamp'
                var text2 = ' '
                var text3 = ' '
                var text4 = ' '
                var text5 = ' '
                var text6 = ' '
                var leftSpace = 10
                doc.setFontSize(6)
                doc.text(text1, padding, line2Height);
                //#endregion

                //#region Line 37
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament
                spaceLeft = 10
                var text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------'
                doc.text(text1, padding + spaceLeft, line2Height);
                //#endregion

                //#region Line 38
                lineHeightIncreament = 4
                var line2Height = line2Height + lineHeightIncreament
                doc.text('DUE Date: ' + dnDets.dueDate ? convertDate(dnDets.dueDate) : '', padding, line2Height, {
                });
                doc.text(`Applicant's Response`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 39
                lineHeightIncreament = 4
                var line2Height = line2Height + lineHeightIncreament
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department'a approved bank NBP Gulgasht Branch by receipt no. _______ on date ________.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    var lineText = lines[i].replace("[capitalCost]", numberFormatting(dnDets.capitalCostAmount));
                    lineText = lineText.replace("[securityCost]", numberFormatting(dnDets.securityDepositeAmount));
                    doc.text(lineText, padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 40
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfDays = '30'
                var text1 = `2. Since I/We did not provide funds to buy meter to the institution, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    doc.text(lines[i], padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 41
                doc.setFontSize(fontSize)
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
                var noOfDays = '30'
                var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period..?`
                var lines = doc.splitTextToSize(text1, maxWidth);
                // Iterate through each line and add it to the PDF
                for (var i = 0; i < lines.length; i++) {
                    doc.text(lines[i], padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#region Line 42
                lineHeightIncreament = 5
                var line2Height = line2Height + lineHeightIncreament
                doc.text(`For Computer Center Use`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 43
                var line2Height = line2Height + lineHeightIncreament
                doc.text(`(Demand Notice Data)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
                    align: 'center',
                });
                //#endregion

                //#region Line 44
                var line2Height = line2Height + lineHeightIncreament
                var lineHeightIncreament = 5
                var padding = 10
                var lineSpace = 7.5
                var text1 = 'Demand Notice Serial No.: '
                var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
                var text3 = 'Application Id: '
                var text4 = applicationId ? applicationId : '-'
                var text5 = 'Application Form No.: '
                var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
                //#endregion

                //#region Line 45
                var line2Height = line2Height + lineHeightIncreament
                var lineHeightIncreament = 5
                var padding = 10
                var lineSpace = 7.5
                var text1 = 'Demand Notice Issuance Date: '
                var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
                var text3 = 'Amount to be paid: '
                var text4 = dnDets.capitalCostAmount ? numberFormatting(parseInt(dnDets.capitalCostAmount) + parseInt(dnDets.securityDepositeAmount)) : '-'
                var text5 = ' '
                var text6 = ' '

                doc.text(text1, padding, line2Height);
                doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
                doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


                doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
                doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
                doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

                //#endregion

                //#region Line 46
                doc.setFontSize(fontSize)
                var line2Height = line2Height + lineHeightIncreament + lineHeightIncreament / 2
                var lineSpace = 6.6
                var text1 = ' '
                var text2 = ' '
                var text3 = ' '
                var text4 = ' '
                var text5 = ' '
                var text6 = application.appliedLoad < 15 ? 'Signature SDO with date' : 'Signature XEN with date'
                var leftSpace = 110
                doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
                //#endregion

                //#region Line 47
                doc.setFontSize(6)
                lineHeightIncreament = 2
                var maxWidth = doc.internal.pageSize.getWidth() - (padding * 8)
                var text1 = 'NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. '
                var lineSpace = 6.6
                var lines = doc.splitTextToSize(text1, maxWidth);
                for (var i = 0; i < lines.length; i++) {
                    doc.text(lines[i], padding, line2Height);
                    line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
                }
                //#endregion

                //#endregion
            }

            doc.addPage()

            var pageWidth = doc.internal.pageSize.getWidth();
            var pageHeight = doc.internal.pageSize.getHeight();

            // Convert the barcode image to data URL
            var height = 10;
            var padding = 10;

            // Add the barcode image to the PDF document
            doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

            var increment = 15;
            height = height + increment
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 8;
            height = height + increment;
            doc.setFontSize(18);
            doc.text('E-Document', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            height = height + increment;
            doc.setFontSize(12);
            doc.setFont('helvetica', 'normal');
            var increment = 8;
            var height = height + increment
            var leftMargin = 50
            doc.text('Document Type: ', padding, height);
            doc.text('New Connection', padding + leftMargin, height);
            doc.text('Tracking Id:', padding + leftMargin + leftMargin, height);
            doc.text(applicationId, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Application Status: ', padding, height);
            doc.text(statusFunc(application.applicationProgressId, application.objectionStatus), padding + leftMargin, height);
            doc.text('Application Date:', padding + leftMargin + leftMargin, height);
            doc.text(convertDate(application.creationDate), padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Sub-Division: ', padding, height);
            doc.text(subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions), padding + leftMargin, height);
            doc.text('Connection Type:', padding + leftMargin + leftMargin, height);
            doc.text(application.connectionType, padding + leftMargin + leftMargin + leftMargin, height);

            var increment = 6;
            var height = height + increment;
            doc.text('Phase / Load: ', padding, height);
            doc.text(application.appliedLoad.toString(), padding + leftMargin, height);
            doc.text('Connection Date:', padding + leftMargin + leftMargin, height);
            doc.text('-', padding + leftMargin + leftMargin + leftMargin, height);

            increment = 20;
            height = height + increment
            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 10; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            doc.setFillColor(199, 199, 199);
            // Draw the rectangle
            doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');

            doc.setFont('helvetica', 'bold');
            doc.text('Premises Details', doc.internal.pageSize.getWidth() / 2, height, {
                align: 'center',
            });

            increment = 6;
            var height = height + increment
            // Get the page width and height

            var rectWidth = 195; // Width of the rectangle
            var rectHeight = 30; // Height of the rectangle

            // Calculate the coordinates for the rectangle
            var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
            // Draw the rectangle
            doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

            doc.setFont('helvetica', 'normal');
            increment = 8;
            var height = height + increment
            var leftMargin = 70
            var extraPadding = 5
            doc.text('No. of meter(s) already installed:', padding + extraPadding, height);
            doc.text(application.noOfMetersAlreadyInstalled.toString(), padding + leftMargin, height);

            increment = 6;
            var height = height + increment
            var leftMargin = 70
            doc.text('Present Address:', padding + extraPadding, height);
            doc.text(application.premisesAddress, padding + leftMargin, height);

            if (copyOfApplicantCNICFront != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment
                let extension = copyOfApplicantCNICFront.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                increment = 10;
                height = height + increment
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Applicant CNIC Image', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 200; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 120
                let cardHeight = 80
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(copyOfApplicantCNICFront, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(copyOfApplicantCNICFront, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (premisesDocument != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = premisesDocument.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Property Document', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(premisesDocument, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(premisesDocument, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (scannedCopyOfNearByElectricityBill != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = scannedCopyOfNearByElectricityBill.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('Near By Bill', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(scannedCopyOfNearByElectricityBill, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(scannedCopyOfNearByElectricityBill, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (copyOfOwnertCNIC != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = copyOfOwnertCNIC.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Copy of Owner's CNIC`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 120
                let cardHeight = 80
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(copyOfOwnertCNIC, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(copyOfOwnertCNIC, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (ownerNOC != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = ownerNOC.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text('NOC from Owner', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(ownerNOC, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(ownerNOC, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (resolutionFormDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = resolutionFormDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`BODs' Resolution Form`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(resolutionFormDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(resolutionFormDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (certMemoDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = certMemoDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Memorandum of Association`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(certMemoDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(certMemoDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }

            if (certFormDesc != '') {
                doc.addPage()
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();
                // Convert the barcode image to data URL
                var height = 10;
                var padding = 10;
                // Add the barcode image to the PDF document
                doc.addImage(mepcologo, 'PNG', 90, height, 30, 10); // Adjust the position and size of the barcode image

                var increment = 15;
                height = height + increment
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text('Multan Electric Power Company', doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });

                var increment = 10;
                height = height + increment;
                let extension = certFormDesc.slice(11, 15)
                doc.text('Application Id: ', padding, height)
                doc.text(applicationId, padding + doc.getTextWidth('Application Id: '), height)
                height = height + increment

                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 10; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                doc.setFillColor(199, 199, 199);
                // Draw the rectangle
                doc.rect(rectX, height - 6.5, rectWidth, rectHeight, 'DF');
                doc.setFont('helvetica', 'bold');
                doc.text(`Certified Form 29`, doc.internal.pageSize.getWidth() / 2, height, {
                    align: 'center',
                });
                increment = 3.5;
                var height = height + increment
                // Get the page width and height
                var rectWidth = 195; // Width of the rectangle
                var rectHeight = 234; // Height of the rectangle

                // Calculate the coordinates for the rectangle
                var rectX = (pageWidth - rectWidth) / 2; // X-coordinate of the rectangle
                // Draw the rectangle
                doc.rect(rectX, height, rectWidth, rectHeight);
                height = height + increment
                let cardWidth = 190
                let cardHeight = 228
                var xPos = (pageWidth - cardWidth) / 2;
                if (extension.startsWith('jp')) {
                    doc.addImage(certFormDesc, 'jpeg', xPos, height, cardWidth, cardHeight);
                }
                else if (extension.startsWith('pn')) {
                    doc.addImage(certFormDesc, 'png', xPos, height, cardWidth, cardHeight);
                }
            }



            const totalPages = doc.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.addImage(getWaterMarkLogo(userCompany), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
            }

            doc.setFontSize(8);

            // Loop through each page
            for (var i = 1; i <= totalPages; i++) {
                // Set the current page
                doc.setPage(i);

                // Get the page width and height
                var pageWidth = doc.internal.pageSize.getWidth();
                var pageHeight = doc.internal.pageSize.getHeight();

                // Set the position for the page number
                var pageNumberX = pageWidth - 20; // X-coordinate of the page number
                var pageNumberY = pageHeight - 10; // Y-coordinate of the page number

                // Add the page number
                doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() / 2, pageNumberY, {
                    align: 'center',
                });
            }
            const pdfBlob = doc.output('blob');
            const pdfDataUrl = URL.createObjectURL(pdfBlob);

            // Open the PDF in a new tab
            window.open(pdfDataUrl, '_blank');
        }
        catch (e) {
            console.log(e)
        }
        setViewBackdrop(false)
    }

    const ArearPaidBillDocument = (event) => {
        arearBillDocumentFormik.handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "paidBillArear." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                const image = new Image();
                image.src = URL.createObjectURL(renamedFile);

                image.onload = () => {
                    canvas.width = image.width;
                    canvas.height = image.height;
                    ctx.drawImage(image, 0, 0);
                    const waterMarkText = 'For MEPCO Use Only';
                    ctx.font = '24px Arial';
                    ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
                    ctx.fillText(waterMarkText, 10, canvas.height - 10);
                    const watermarkedBase64 = canvas.toDataURL();
                    setArearPaidBillDocument(renamedFile);
                    setArearPaidBillDocumentThumbnail(watermarkedBase64);
                }

            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const InstalledMeterImage = (event) => {
        if (event.target.files) {
            const newFileName = 'installedMeterImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, scoPart2Formik.handleChange, setInstalledMeterImage, setInstalledMeterImageError, setInstalledMeterImageThumbnail, newFileName);
        }
    }

    const handleInputChange = async (e, index) => {
        const { name, value } = e.target;

        const updatedDataArray = [...alreadyInstalledRefNos];

        let itemToUpdate = updatedDataArray[index]

        if (!itemToUpdate) {
            itemToUpdate = {
                refNo: '',
                actualFlag: null
            }
        }

        if (value.length === 14) {

            let apiResponse = await dBillAPI(token, value)
            if (apiResponse.status) {
                itemToUpdate.actualFlag = true
            } else {
                itemToUpdate.actualFlag = false
            }
        }

        const updatedItem = {
            ...updatedDataArray[index],
            refNo: value,
            actualFlag: itemToUpdate.actualFlag,
        };
        updatedDataArray[index] = updatedItem;
        setAlreadyInstalledRefNos(updatedDataArray);
    };

    const openDetailsPopUp = async (stepName) => {
        let id = dialogRowData.applicationId
        if (stepName === "Application Submitted" || stepName === "APPLICATION SUBMITTED") {
            setApplicationSubmittedPopUp(true)
        }
        else if (stepName === "Documents Verified" || stepName === "DOCUMENT VERIFICATION") {
            setDocumentsVerifiedSubPopUp(true)
        }
        else if (stepName === "Arrear Verified" || stepName === "ARREAR VERIFICATION") {
            setArrearVerifiedSubPopUp(true)
        }
        else if (stepName === "Field Surveyed" || stepName === "FIELD SURVEY") {
            await callAsyncFieldSurveyInformation(dialogRowData.applicationId)
            setFieldSurveyedSubPopUp(true)
        }
        else if (stepName === "Reference No. Allocated" || stepName === "REF. NO ALLOCATION") {
            await callAsyncDnDetailsAPI(dialogRowData.applicationId)
            setReferenceNoAllocatedSubPopUp(true)
        }
        else if (stepName === "DN Payment Submitted" || stepName === "DN PAYMENT SUBMISSION") {
            await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId)
            setDnPaymentSubmittedSubPopUp(true)
        }
        else if (stepName === "DN Payment Verified" || stepName === "DN PAYMENT VERIFICATION") {
            await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId)
            setDnPaymentVerifiedSubPopUp(true)
        }
        else if (stepName === "Service Connection Ordered" || stepName === "SERVICE CONN. ORDER") {
            await callAsyncGetSCOAPI(dialogRowData.applicationId)
            setServiceConnectionOrderedSubPopUp(true)
        }
        else if (stepName === "Meter Installed" || stepName === "METER INSTALLATION") {
            await callAsyncGetSCOAPI(dialogRowData.applicationId)
            setMeterInstalledSubPopUp(true)
        }
    }

    const FGovt = (event) => {
        if (scoPart1Formik.values.iv_fgovt) {
            scoPart1Formik.values.iv_fgovt = '';
            scoPart1Formik.handleChange(event);
        }
        else {
            scoPart1Formik.handleChange(event);
            scoPart1Formik.values.iv_fgovt = event.target.value;
        }
    }

    const Contanment = (event) => {
        if (scoPart1Formik.values.iv_cantonment_board) {
            scoPart1Formik.values.iv_cantonment_board = '';
            scoPart1Formik.handleChange(event);
        }
        else {
            scoPart1Formik.handleChange(event);
            scoPart1Formik.values.iv_cantonment_board = event.target.value;
        }
    }

    const LocalBodies = (event) => {
        if (scoPart1Formik.values.iv_local_bodies) {
            scoPart1Formik.values.iv_local_bodies = ''
            scoPart1Formik.handleChange(event);
        }
        else {
            scoPart1Formik.handleChange(event);
            scoPart1Formik.values.iv_local_bodies = event.target.value;

        }
    }

    const PGovt = (event) => {
        if (scoPart1Formik.values.iv_pgovt) {
            scoPart1Formik.values.iv_pgovt = '';
            scoPart1Formik.handleChange(event);
        }
        else {
            scoPart1Formik.values.iv_pgovt = event.target.value;
            scoPart1Formik.handleChange(event);
        }
    }

    const getTariffAndMeterType = async (appliedLoad, connectionType, seasonalNonSeasonal, tariffs) => {
        let phase = ''
        if (connectionType === "Industrial") {
            if (seasonalNonSeasonal == 1) {
                const seasonalTariff = tariffs.find(
                    (item) => item.tariffCode === "F"
                );
                // Check if seasonalTariff is found before setting the state
                if (seasonalTariff) {
                    setTariff(seasonalTariff.tariffDesc.split(" ")[0] || "");
                } else {
                    // Handle the case when the seasonal tariff is not found
                    setTariff("");
                    console.error("Seasonal tariff not found!");
                }
                if (appliedLoad <= 500) {
                    setPhase("MDI (LT)(CT)");
                    phase = "MDI (LT)(CT)"
                } else if (appliedLoad > 500) {
                    setPhase("MDI (HT)(CT/PT)");
                    phase = "MDI (HT)(CT/PT)"

                }
            } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
                let shortListedTariffsArray = tariffs.filter(
                    (item) => item.consumerType === connectionType
                );
                shortListedTariffsArray = shortListedTariffsArray.filter(
                    (item) =>
                        parseInt(item.from) <= appliedLoad &&
                        parseInt(item.to) > appliedLoad
                );
                let selectedTariff = shortListedTariffsArray[0]
                // Check if seasonalTariff is found before setting the state
                if (selectedTariff) {
                    setTariff(selectedTariff.tariffDesc.split(" ")[0] || "");
                } else {
                    // Handle the case when the seasonal tariff is not found
                    setTariff("");
                }
                if (appliedLoad <= 500) {
                    setPhase("MDI (LT)(CT)");
                    phase = "MDI (LT)(CT)"

                } else if (appliedLoad > 500) {
                    setPhase("MDI (HT)(CT/PT)");
                    phase = "MDI (HT)(CT/PT)"

                }
            }
        }
        else {
            if (appliedLoad && appliedLoad > 0 && tariffs) {

                let shortListedTariffsArray = tariffs.filter(
                    (item) => item.consumerType === connectionType
                );
                shortListedTariffsArray = shortListedTariffsArray.filter(
                    (item) =>
                        parseInt(item.from) <= appliedLoad &&
                        parseInt(item.to) > appliedLoad
                );
                setTariff(shortListedTariffsArray[0].tariffDesc.split(" ")[0]);
                if (parseInt(appliedLoad) < 5) {
                    setPhase("Single Phase");
                    phase = "Single Phase"
                } else if (appliedLoad >= 5 && appliedLoad < 20) {
                    setPhase("3 Phase");
                    phase = "3 Phase"
                } else if (appliedLoad >= 20 && appliedLoad < 500) {
                    setPhase("MDI (LT)(CT)");
                    phase = "MDI (LT)(CT)"
                } else if (appliedLoad >= 500) {
                    setPhase("MDI (HT)(CT/PT)");
                    phase = "MDI (HT)(CT/PT)"
                }
            } else {
                setPhase("");
                phase = "";
                setTariff("");
            }
        }
        return phase
    };

    const handleCloses = () => {
        setNewConnectionPopup(false);
    };

    const scoHandleClose = () => {
        setScoPopUp(false);
    };

    const cpHandleClose = () => {
        setCpPopUp(false);
    };

    const errorCloses = () => {
        setError('')
        setFieldSurveyError('')
    };

    //#endregion

    //#endregion

    //#region formiks

    const arearsFormik =
        useFormik({
            initialValues,
            validationSchema: Yup.object().shape({
                iv_property_reference_no: Yup.string().required("Enter the reference number to get arrear details.").min(14, "Enter 14 digit reference number.").max(14, "Enter 14 digit reference number."),
            }),
            onSubmit: async (values, { resetForm }) => {
                var formdata = new FormData();

                formdata.append("refNo", values.iv_property_reference_no);
                formdata.append("arrearAmount", arrearsDetailsRefno.arrearsAmount);
                formdata.append("meterStatus", arrearsDetailsRefno.meterStatus);
                formdata.append("tariff", arrearsDetailsRefno.tariffDesc);
                formdata.append("meterType", arrearsDetailsRefno.meterType);
                formdata.append("phase", arrearsDetailsRefno.phase);
                formdata.append("consumerName", arrearsDetailsRefno.consumerName);
                formdata.append("consumerPhoneNo", arrearsDetailsRefno.consumerNo);
                formdata.append("consumerEmail", arrearsDetailsRefno.consumerEmail);
                formdata.append("consumerAddress", arrearsDetailsRefno.consumerAddress);
                formdata.append("applicationNo", dialogRowData.applicationId);

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow'
                };

                await fetch(cfpBaseUrl + "comman/insertArrear", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            if (arrearsDetailsRefno.arrearsAmount !== '') {
                                callChangeObjectionStatus(1, 'Arrears exist against property', 'Arrears exist against property')
                                setArrearsEntryPopUpOpen(false)
                            }
                            else {
                                callChangeObjectionStatus(0, 'Arrear Payment Verified', 'Arrear Payment Verified')
                                callChangeProgressIdAPI(3, 'Arrears Verified', 'Arrears Verified', '', dialogRowData.applicationId)
                                resetForm()
                                setArrearsEntryPopUpOpen(false);
                                handleClose();
                            }
                        }
                        else {
                            console.log("Arrears objection submission failed!")
                        }
                    })
                    .catch(error => console.log('error', error));

            }
        });

    const appliedLoadFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_applied_load: Yup.number().min(dialogRowData.appliedLoad, 'New load can not be less than previous load.').max(1000, "Applied load can not be more than 1000kW.").required("Enter applied load."),
        }),
        onSubmit: async (values, { resetForm }) => {
            var formdata = new FormData();
            formdata.append("applicationId", dialogRowData.applicationId);
            formdata.append("appliedLoad", appliedLoadFormik.values.iv_applied_load);
            formdata.append("lastModifiedBy", userName);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "electricityNewConnection/updateAppliedLoad", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        let nCApplications = netMeterApplications
                        setNetMeterApplications(nCApplications);
                        callChangeObjectionStatus(2, "Field Objection Removed")
                        handleClose()
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error => {
                    console.log(error)
                });
        }
    });

    const fieldFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_coverage_area: Yup.mixed().required("Select the area from list.").oneOf(areaMarla, 'Please select a valid option'),
            // iv_coverage_area: Yup.string().required("Enter property coverage area."),
            iv_no_of_meters_already_installed: Yup.number().min(dialogRowData.noOfMetersAlreadyInstalled, `No. can't < consumer's applied no.`),
            iv_distance: Yup.string().required("Select option for the property distance."),
            iv_estimated_distance: Yup.number().when('iv_distance', {
                is: (iv_distance) => (iv_distance == 0),
                then: Yup.number().min(41, 'Minimum 41M.').required('Enter est. distance.'),
                otherwise: Yup.number().optional()
            }),
            iv_sketch_diagram: Yup.mixed().when('iv_distance', {
                is: (iv_distance) => (iv_distance == 0),
                then: Yup.mixed().optional('Upload the sketch diagram.'),
                otherwise: Yup.mixed().optional()
            }),
            iv_existing_meters_ref_nos_array: Yup.mixed().optional()
        }),
        onSubmit: async (values, { resetForm }) => {

            let formdata = new FormData();
            formdata.append("applicationId", dialogRowData.applicationId);
            formdata.append("isLTLWI40Flag", values.iv_distance);
            formdata.append("estDistanceInMeter", values.iv_estimated_distance);
            formdata.append("sketchDiagram", sketchDiagramThumbnail ? sketchDiagramThumbnail : '');
            formdata.append("areaMarla", values.iv_coverage_area);
            formdata.append("noOfMeterInstalled", values.iv_no_of_meters_already_installed);
            formdata.append("surveyedBy", userName);
            if (alreadyInstalledRefNos.length !== 0) {
                alreadyInstalledRefNos.map((item) => (formdata.append("installedMeterRefNo", item.refNo)))
            } else {
                formdata.append("installedMeterRefNo", '')
            }


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "demandNotice/fieldSurvey", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        if (values.iv_distance == 0 && sketchDiagramThumbnail) {
                            callChangeProgressIdAPI(4, 'Field Survey Saved', 'Field Surveyed', '', dialogRowData.applicationId)
                        }
                        else if (values.iv_distance == 1) {
                            callChangeProgressIdAPI(4, 'Field Survey Saved', 'Field Surveyed', '', dialogRowData.applicationId)
                        }
                        else {
                        }
                    }
                    else {
                        setFieldSurveyError(result.message)
                    }
                })
                .catch(error => console.log('error', error));
        }
    });

    const refNoAllocationFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_grid_sharing_cost: Yup.number().when('gridFlag', {
                is: () => (gridFlag === true),
                then: Yup.number().required("Enter grid sharing cost."),
                otherwise: Yup.number().optional()
            }),
            iv_feeder_rehab_charges: Yup.number().when('feederRehabFlag', {
                is: () => (feederRehabFlag === true),
                then: Yup.number().required("Enter feeder rehabilitation charges."),
                otherwise: Yup.number().optional()
            }),
            iv_feeder_no: Yup.mixed().required('Select feeder!'),
            iv_sub_batch: Yup.mixed().required("Select sub batch."),
            iv_batch: Yup.mixed().required("Select batch."),
            iv_reference_to_allot: Yup.string().required("Enter reference no. to allot.").min(12, `Reference no. can't be < 12 digits.`).max(12, `Reference no. can't > 12 digits.`).matches(/^[0-9]+$/, "Enter reference no. as 01234567891234"),
            // iv_meter_rent: Yup.number().optional("Enter Meter rent."),
            // iv_service_rent: Yup.number().optional("Enter service rent."),
            iv_bank_name: Yup.string().optional("Enter bank name for demand notice payment."),
            iv_industry_factory_type: Yup.string().when('connectionType', {
                is: () => ((dialogRowData.connectionType === "Industrial" && industryFlag === true) || (dialogRowData.connectionType === "industrial" && industryFlag === true)),
                then: Yup.string().required('Please enter industry / factory type.'),
                otherwise: Yup.string().optional()
            }),
            iv_connection_account_no: Yup.string().optional("Enter Account no. to allot the connection.").min(14, 'Account number can not be less than 14 digits.').max(14, 'Account number can not be more than 14 digits.').matches(/^[0-9]+$/, "Enter 14 digit account number as 01234567891234"),
            iv_items_array: Yup.mixed().optional()
        }),
        onSubmit: async (values, { resetForm }) => {
            //#region If Distance < 40
            if (fieldFormik.values.iv_distance === 1) {
                var formdata = new FormData();
                formdata.append("applicationId", dialogRowData.applicationId);
                formdata.append("consumerAccountNo", values.iv_reference_to_allot.slice(5,));
                formdata.append("batchNo", values.iv_batch);
                formdata.append("feederNo", values.iv_feeder_no);
                formdata.append("subBatch", values.iv_sub_batch);
                formdata.append("tariff", tariff);
                formdata.append("bankName", bankName);
                formdata.append("industryFactoryType", values.iv_industry_factory_type);
                formdata.append("connectionAccountNo", values.iv_batch.concat(values.iv_reference_to_allot));
                formdata.append("meterRent", values.iv_meter_rent);
                formdata.append("serviceRent", values.iv_service_rent);
                formdata.append("sanctionLoad", dialogRowData.appliedLoad);
                formdata.append("filledBy", userName);
                formdata.append("filledFlag", 1);
                formdata.append("amountOfGridSharing", values.iv_grid_sharing_cost);
                formdata.append("amountOfFeederRehab", values.iv_feeder_rehab_charges);

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow'
                };

                await fetch(cfpBaseUrl + "demandNotice/refNosAllocation", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            if (!dnDetails.filledFlag) { //In case of filling
                                scoPart1Formik.handleSubmit();
                                resetForm();
                                setGridFlag(false);
                                setFeederRehabFlag(false);
                                setReferenceNumberToAllot('');
                                setFieldVerifyAlert(false);
                                setBankName()
                                setOpen(false);
                            }
                            else if (dnDetails && dnDetails.filledFlag && dnDetails.filledFlag === 1) { //In case of approval
                                if (dialogRowData.objectionStatus === 2) {
                                    callResetObjectionStatus(dialogRowData.applicationId)
                                }
                                setNewConnectionPopup(true)
                                callApproveFieldAPI(dialogRowData.applicationId);
                                setGridFlag(false);
                                setFeederRehabFlag(false);
                                resetForm();
                                setReferenceNumberToAllot('');
                                setFieldVerifyAlert(false);
                                setBankName();
                                setOpen(false);
                            }
                        }
                        else {
                            console.log(result.message)
                        }
                    })
                    .catch(error => console.log('error', error));
            }
            //#endregion

            //#region If Distance > 40
            else if (fieldFormik.values.iv_distance == 0) {

                let arrayOfItems = []
                itemsArray.forEach((item) => {
                    let itemObject = {}
                    itemObject.itemCode = item.itemCode
                    itemObject.Id = item.Id.toString()
                    itemObject.qty = item.qty
                    arrayOfItems.push(itemObject)
                })

                var formdata = new FormData();

                formdata.append("applicationId", dialogRowData.applicationId);
                formdata.append("consumerAccountNo", values.iv_reference_to_allot.slice(5,));
                formdata.append("batchNo", values.iv_batch);
                formdata.append("tariff", tariff);
                formdata.append("feederNo", values.iv_feeder_no);
                formdata.append("subBatch", values.iv_sub_batch);
                formdata.append("bankName", bankName);
                formdata.append("industryFactoryType", values.iv_industry_factory_type);
                formdata.append("connectionAccountNo", values.iv_batch.concat(values.iv_reference_to_allot));
                formdata.append("meterRent", values.iv_meter_rent);
                formdata.append("serviceRent", values.iv_service_rent);
                formdata.append("sanctionLoad", dialogRowData.appliedLoad);
                formdata.append("filledBy", userName);
                formdata.append("filledFlag", 1);
                formdata.append("amountOfGridSharing", values.iv_grid_sharing_cost);
                formdata.append("amountOfFeederRehab", values.iv_feeder_rehab_charges);

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);


                let requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow'
                };

                await fetch(cfpBaseUrl + "demandNotice/refNosAllocation", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            scoPart1Formik.handleSubmit();
                            if (!dnDetails.filledFlag) { //In case of filling
                                //#region Boq InsertAPI
                                var myHeaders = new Headers();
                                myHeaders.append("Content-Type", "application/json");
                                myHeaders.append("Authorization", token);
                                var raw = JSON.stringify({
                                    "applicationId": dialogRowData.applicationId,
                                    "array": arrayOfItems
                                });
                                var requestOptions = {
                                    method: 'POST',
                                    headers: myHeaders,
                                    body: raw,
                                    redirect: 'follow'
                                };

                                fetch(cfpBaseUrl + "demandNotice/insertBOQ", requestOptions)
                                    .then(response => response.json())
                                    .then(result => {
                                        if (result.status === "200") {
                                            setItemsArray([])
                                            setItemsAmount()
                                            setStoreCharges()
                                            setTransportationCharges()
                                            setInstallationCharges()
                                            setGridFlag(false);
                                            setFeederRehabFlag(false);
                                            resetForm();
                                            setReferenceNumberToAllot('');
                                            setFieldVerifyAlert(false);
                                            setShowBoqForm(false);
                                            setBankName()
                                            setTotalCharges()
                                            setOpen(false);
                                        }
                                        else {
                                            console.log(result.message)
                                        }
                                    })
                                    .catch(error => {
                                        console.log('Error in Boq Submission!', error)
                                    });
                                //#endregion
                            }
                            else if (dnDetails && dnDetails.filledFlag && dnDetails.filledFlag === 1) { //In case of approval
                                //#region Boq UpdateAPI
                                let myHeaders = new Headers();
                                myHeaders.append("Content-Type", "application/json");
                                myHeaders.append("Authorization", token);
                                let raw = JSON.stringify({
                                    "token": token,
                                    "applicationId": dialogRowData.applicationId,
                                    "array": arrayOfItems
                                });

                                let requestOptions = {
                                    method: 'PUT',
                                    headers: myHeaders,
                                    body: raw,
                                    redirect: 'follow'
                                };

                                fetch(cfpBaseUrl + "demandNotice/updateBoq", requestOptions)
                                    .then(response => response.json())
                                    .then(result => {
                                        if (result.status === "200") {
                                            setItemsArray([])
                                            setItemsAmount()
                                            setStoreCharges()
                                            setTransportationCharges()
                                            setInstallationCharges()
                                            setGridFlag(false);
                                            setFeederRehabFlag(false);
                                            resetForm();
                                            setReferenceNumberToAllot('');
                                            setFieldVerifyAlert(false);
                                            setShowBoqForm(false);
                                            setBankName();
                                            setTotalCharges();
                                            callApproveFieldAPI(dialogRowData.applicationId);
                                            setOpen(false);
                                        }
                                        else {
                                            console.log("Error in BOQ")
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error)
                                    });
                                //#endregion
                            }
                        }
                        else {
                            console.log(result.message)
                        }
                    })
                    .catch(error => {
                        console.log('Error in Field Verification!', error)
                    });
            }
            //#endregion
        }
    });

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_objection_Type: Yup.string().required("Enter reason for rejection."),
            // iv_objection_Descripton: Yup.string().optional("Enter reason for rejection."),
        }),
        onSubmit: async (values, { resetForm }) => {
            callChangeObjectionStatus(1, values.iv_objection_Type, values.iv_objection_Type)
            resetForm();
        }
    })

    const dnPymentReceiptFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_payment_date: Yup.date().max(new Date(), 'Payment date must be in the past!').required('Payment date is required!'),
            iv_receipt_image: Yup.mixed().required('Upload paid demand notice receipt image.')
        }),
        onSubmit: async (values, { resetForm }) => {

            var formdata = new FormData();

            formdata.append("applicationNo", dialogRowData.applicationId);
            formdata.append("demandNoticeNo", dnDetails.demandNoticeNo);
            formdata.append("uploadedBy", userName);
            formdata.append("paidDNImage", dnReceiptImageThumbnail);
            formdata.append("paymentMethod", "1");
            formdata.append("paymentDate", values.iv_payment_date);
            // setShowDNPayment(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "demandNotice/insertPaidDNImage", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        callChangeProgressIdAPI(6, 'Demand Notice Paid', 'Demand Notice Paid')
                        resetForm()
                        setDnReceiptImage()
                        setDnReceiptImageThumbnail()
                        setShowDNPayment(true)
                        setScoPopUp(true)
                    }
                }
                )
                .catch(error => console.log('error', error));
        }
    })

    const fieldItemFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_fieldItemId: Yup.mixed().required("Select the item from list."),
            iv_fieldItemQty: Yup.number().required('Enter qty.'),
            iv_fieldItemRate: Yup.string().optional(),
            iv_fieldItemUnit: Yup.string().optional(),
            iv_fieldItemAmount: Yup.string().optional(),
        }),
        onSubmit: (values, { resetForm }) => {
            let itemToBeAdded = {}
            let arrayOfItems = itemsArray;
            itemToBeAdded.Id = values.iv_fieldItemId;
            let alreadyPresent = arrayOfItems.find(item => item.code === itemToBeAdded.Id)
            if (alreadyPresent) {
                const index = arrayOfItems.findIndex(item => item.code === itemToBeAdded.Id);
                arrayOfItems[index].qty = (parseInt(arrayOfItems[index].qty) + parseInt(values.iv_fieldItemQty)).toString();
                arrayOfItems[index].amount = parseInt(arrayOfItems[index].qty) * parseInt(arrayOfItems[index].rate);
            }
            else {
                let it = allMaterialList.find(item => item.Id === itemToBeAdded.Id)
                if (it) {
                    itemToBeAdded.name = it.ItemName
                    itemToBeAdded.Id = it.Id
                    itemToBeAdded.itemCode = it.ItemCode
                }
                itemToBeAdded.qty = values.iv_fieldItemQty;
                itemToBeAdded.rate = values.iv_fieldItemRate;
                itemToBeAdded.unit = values.iv_fieldItemUnit;
                itemToBeAdded.amount = parseInt(values.iv_fieldItemQty) * parseInt(values.iv_fieldItemRate);
                arrayOfItems.push(itemToBeAdded);
            }
            // console.log(itemToBeAdded)
            // console.log(itemToBeAdded, 'Item to be added!')
            let totalAmountofItems = calculateTotalAmountOfItems(arrayOfItems)
            let store_charges = totalAmountofItems * .12
            let transportation_charges = totalAmountofItems * .08
            let installation_charges = totalAmountofItems * .26
            let total_charges = totalAmountofItems + store_charges + transportation_charges + installation_charges
            fieldItemFormik.values.iv_items_array = arrayOfItems;
            setItemsAmount(totalAmountofItems)
            setStoreCharges(store_charges)
            setTransportationCharges(transportation_charges)
            setInstallationCharges(installation_charges)
            setTotalCharges(total_charges)
            setItemsArray(arrayOfItems);
            resetForm()
        }
    })

    const scoPart1Formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_fata_pata: Yup.mixed().optional('Select FATA / PATA!'),
            iv_rural_urban: Yup.mixed().required('Select Urban / Rural!'),
            iv_fgovt: Yup.string().optional('Select Federal Govt / Autonomous and Local Bodies under Prov. Govt'),
            iv_cantonment_board: Yup.string().optional('Select Cantonment Board'),
            iv_pgovt: Yup.string().optional('Select Provincial Govt / Autonomous and Local Bodies under Prov. Govt'),
            iv_local_bodies: Yup.string().optional('Select Local Bodies'),
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true)
            var formdata = new FormData();

            formdata.append("applicationId", dialogRowData.applicationId);
            formdata.append("scoId", scoDetails.scoId);
            formdata.append("urbanRural", values.iv_rural_urban);
            formdata.append("fataPata", values.iv_fata_pata);
            formdata.append("feederNo", refNoAllocationFormik.values.iv_feeder_no);
            formdata.append("batch", refNoAllocationFormik.values.iv_batch);
            formdata.append("subBatch", refNoAllocationFormik.values.iv_sub_batch);
            formdata.append("fGovt", values.iv_fgovt);
            formdata.append("cantonmentBoard", values.iv_cantonment_board);
            formdata.append("pGovt", values.iv_pgovt);
            formdata.append("localBodies", values.iv_local_bodies);
            formdata.append("scoP1FilledBy", userName);
            formdata.append("consumerAccountNo", refNoAllocationFormik.values.iv_reference_to_allot.slice(5,));
            formdata.append("scoP1FillFlag", 1);

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "sco/scoDataInsertP1", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        if (scoDetails.scoP1FillFlag === null || scoDetails.scoP1FillFlag === 0 || scoDetails.scoP1FillFlag === "") {
                            resetForm()
                            setOpen(false)
                        }
                        else {
                            resetForm()
                            callSCOApprovePart1API(scoDetails.scoId)
                            callChangeProgressIdAPI(8, "SCO Issued", "SCO Issued")
                            setOpen(false)
                        }
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error =>
                    console.log(error)
                );
            setViewBackdrop(false)
        }
    })

    const scoPart2Formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_store_requisition_no: Yup.string().required('Enter store requisition no.').min(6, 'SRN should be 6 digits.').max(6, 'SRN should be 6 digits.').matches(/^[0-9]+$/, "SRN should be number only."),
            iv_store_requisition_date: Yup.date().max(new Date(), 'Requisition date must be in the past.').required('Enter requisition date.'),
            iv_sanctioned_load: Yup.number().max(1000, "Sanctioned load can not be more than 1000kW.").required("Enter sanctioned load."),
            iv_seasonal_flag: Yup.mixed().when('phase', {
                is: () => phase != 'Single Phase' || phase != '3 Phase',
                then: Yup.mixed().required('Select seasonal / non seasonal value.'),
                otherwise: Yup.mixed().optional()
            }),
            iv_installed_transformer_capacity: Yup.string().optional(),
            iv_meter_serial_no: Yup.string().required('Enter meter number.').min(7, 'Meter no. should be 7 digits.').max(10, 'Meter no. should be 10 digits.').matches(/^[0-9]+$/, "Meter no. should be number only."),
            iv_meter_reading: Yup.string().when('phase', {
                is: () => phase === 'Single Phase',
                then: Yup.string().max(9, "Meter reading can not be more than 999999999.").min(1, 'Meter reading can not be less than 1.').required("Enter meter reading.").matches(/^[0-9]+$/, "Enter meter reading in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_meter_reading_peak_kwh: Yup.string().when('phase', {
                is: () => phase != "Single Phase",
                then: Yup.string().max(9, "Peak reading can not be more than 999999999.").min(1, 'Peak reading can not be less than 1.').required("Enter peak reading.").matches(/^[0-9]+$/, "Enter peak reading in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_meter_reading_off_peak_kwh: Yup.string().when('phase', {
                is: () => phase != "Single Phase",
                then: Yup.string().max(9, "Off Peak reading can not be more than 999999999.").min(1, 'Off Peak reading can not be less than 1.').required("Enter off peak reading.").matches(/^[0-9]+$/, "Enter off peak reading in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_meter_reading_peak_kvarh: Yup.string().when('phase', {
                is: () => (phase != "Single Phase" && phase != "3 Phase"),
                then: Yup.string().max(9, "Peak (kvarh) reading can not be more than 999999999.").min(1, 'Peak (kvarh) reading can not be less than 1.').required("Enter peak (kvarh) reading.").matches(/^[0-9]+$/, "Enter peak (kvarh) reading in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_meter_reading_off_peak_kvarh: Yup.string().when('phase', {
                is: () => (phase != "Single Phase" && phase != "3 Phase"),
                then: Yup.string().max(9, "Off Peak (kvarh) reading can not be more than 999999999.").min(1, 'Off Peak (kvarh) reading can not be less than 1.').required("Enter off peak (kvarh) reading.").matches(/^[0-9]+$/, "Enter off peak (kvarh) reading in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_date_of_connection: Yup.date().max(new Date(), 'Connection date must be in the past.').required('Enter connection date.'),
            iv_connection_installer_name: Yup.string().required('Enter installed by name.').max(30, 'Name should be less than 30 characters.'),
            iv_installed_meter_image: Yup.string().optional(),
            iv_meter_type: Yup.mixed().required('Select meter type!'),
            iv_ct: Yup.string().when('phase', {
                is: () => (phase != "Single Phase" && phase != "3 Phase"),
                then: Yup.string().max(5, "CT can not be more than 99999.").min(1, 'CT can not be less than 1.').required("Enter CT.").matches(/^[0-9]+$/, "Enter CT in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_pt: Yup.string().when('phase', {
                is: () => (phase != "Single Phase" && phase != "3 Phase"),
                then: Yup.string().max(5, "PT can not be more than 99999.").min(1, 'PT can not be less than 1.').required("Enter PT.").matches(/^[0-9]+$/, "Enter PT in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_mdi: Yup.string().when('phase', {
                is: () => (phase != "Single Phase" && phase != "3 Phase"),
                then: Yup.string().max(5, "MDI can not be more than 99999.").min(1, 'MDI can not be less than 1.').required("Enter MDI.").matches(/^[0-9]+$/, "Enter MDI in numbers."),
                otherwise: Yup.string().optional()
            }),
            iv_no_of_mdi_resets: Yup.string().when('phase', {
                is: () => (phase != "Single Phase" && phase != "3 Phase"),
                then: Yup.string().max(5, "No. of MDI reset can not be more than 99999.").min(1, 'No. of MDI reset can not be less than 1.').required("Enter No. of MDI reset.").matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
                otherwise: Yup.string().optional()
            }),
        }),
        onSubmit: async (values, { resetForm }) => {

            var formdata = new FormData();
            formdata.append("scoId", scoDetails.scoId);
            formdata.append("storeRequisitionNo", values.iv_store_requisition_no);
            formdata.append("storeRequisitionDate", values.iv_store_requisition_date);
            formdata.append("senctionLoad", values.iv_sanctioned_load);
            formdata.append("meterNo", values.iv_meter_serial_no);
            formdata.append("meterType", values.iv_meter_type);
            formdata.append("seasonalFlag", values.iv_seasonal_flag);
            formdata.append("connectionInstallerName", values.iv_connection_installer_name);
            formdata.append("dateOfConnection", values.iv_date_of_connection);
            formdata.append("installedTransformerCapacity", values.iv_installed_transformer_capacity);
            formdata.append("installedMeterImage", installedMeterImageThumbnail);
            if (phase === "Single Phase") {
                formdata.append("meterReading", values.iv_meter_reading);
            } else {
                formdata.append("meterReading", '');
            }
            if (phase === "3 Phase") {
                formdata.append("threePhasePeak", values.iv_meter_reading_peak_kwh);
                formdata.append("threePhaseOffPeak", values.iv_meter_reading_off_peak_kwh);
            } else {
                formdata.append("threePhasePeak", '');
                formdata.append("threePhaseOffPeak", '');
            }
            if (phase != "Single Phase" && phase != "3 Phase") {
                formdata.append("threePhasePeakKWH", values.iv_meter_reading_peak_kwh);
                formdata.append("threePhaseOffPeakKWH", values.iv_meter_reading_off_peak_kwh);
                formdata.append("threePhasePeakKVARH", values.iv_meter_reading_peak_kvarh);
                formdata.append("threePhaseOffPeakKVARH", values.iv_meter_reading_off_peak_kvarh);
                formdata.append("cT", values.iv_ct);
                formdata.append("pT", values.iv_pt);
                formdata.append("mdi", values.iv_mdi);
                formdata.append("noOfMDIreset", values.iv_no_of_mdi_resets);
            } else {
                formdata.append("threePhasePeakKWH", '');
                formdata.append("threePhaseOffPeakKWH", '');
                formdata.append("threePhasePeakKVARH", '');
                formdata.append("threePhaseOffPeakKVARH", '');
                formdata.append("cT", '');
                formdata.append("pT", '');
                formdata.append("mdi", '');
                formdata.append("noOfMDIreset", '');
            }

            formdata.append("scoP2FilledBy", userName);
            formdata.append("scoP2FillFlag", 1);

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "sco/scoDataInsertP2", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        if (scoDetails.scoP2FillFlag === null || scoDetails.scoP2FillFlag === 0) {
                            resetForm()
                            setOpen(false)
                        }
                        else {
                            resetForm()
                            callSCOApprovePart2API(scoDetails.scoId)
                            setScoPopUp(true)
                            setOpen(false)
                        }
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error =>
                    console.log(error)
                );
        }
    })

    const masterDataFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_govt_dept: Yup.mixed().required('Select Govt Dept.'),
            iv_ed_code: Yup.mixed().required('Select Electricity Duty code.'),
            iv_standard_classification_code: Yup.mixed().required('Select Std. classification code.'),
            iv_income_tax: Yup.mixed().required('Select Income tax value.'),
            iv_authority: Yup.mixed().optional('Select Authority.')
        }),
        onSubmit: async (values, { resetForm }) => {

            var formdata = new FormData();
            formdata.append("applicationId", dialogRowData.applicationId);
            formdata.append("electricityDuty", masterDataFormik.values.iv_ed_code);
            formdata.append("governmentDepartment", masterDataFormik.values.iv_govt_dept);
            formdata.append("standardClassificationCode", masterDataFormik.values.iv_standard_classification_code);
            formdata.append("incomeTax", masterDataFormik.values.iv_income_tax);
            formdata.append("reason", "New Connection");
            formdata.append("authority", "SDO");
            formdata.append("filledBy", userName);
            formdata.append("filledByFlag", 1);


            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "cpForm136/cpForm136DataInsertion", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        if (masterDataFormDetails.filledByFlag === null || masterDataFormDetails.filledByFlag === 0) {
                            // console.log(result.message)
                            resetForm()
                            setOpen(false)
                        }
                        else {
                            resetForm()
                            callApproveCP136API(dialogRowData.applicationId)
                            setCpPopUp(true)
                            setOpen(false)
                        }
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error => console.log(error));
        }
    })

    const arearBillDocumentFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_arear_paid_bill_document: Yup.mixed().required('Upload arrears paid bill document!'),
            iv_arear_paid_bill_date: Yup.string().required('Enter date on which arrears are paid!')
        }),
        onSubmit: async (values, { resetForm }) => {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", token);

            var raw = JSON.stringify({
                "applicationId": dialogRowData.applicationId,
                "paidBillDate": values.iv_arear_paid_bill_date,
                "paidBillImage": arearPaidBillDocumentThumbnail,
                "token": token
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            await fetch(cfpBaseUrl + "comman/updateENCArearPaidBillImage", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "200") {
                        callChangeObjectionStatus(0, 'Arrears Objection Removed', 'Arrears Paid by consumer');
                        callChangeProgressIdAPI(3, 'Arrears Verified', 'Arrears Verified', '', dialogRowData.applicationId)
                        resetForm()
                        handleClose()
                    }
                    else {
                        console.log(result.message)
                    }
                })
                .catch(error => console.log(error));
        }
    })
    //#endregion

    //#region useEffects

    useEffect(() => {
        if (duration) {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth();
            let dateTill = new Date();
            dateTill.setDate(1);
            const monthUpto = currentMonth - duration
            dateTill.setMonth(monthUpto);
            dateTill.setHours(0, 0, 0, 0);
            setDateFrom(dateTill.toISOString())
            setDateTo(new Date().toISOString())
        }
    }, [duration])

    useEffect(() => {
        if (arearsFormik.values.iv_property_reference_no.length === 14 && arearsFormik.values.iv_property_reference_no.length) {
            referenceApi();
        }
        else {
            let emptyArearObject = {
                arrearsAmount: '',
                meterStatus: '',
                tariffDesc: '',
                meterType: '',
                phase: '',
                consumerName: '',
                consumerNo: "",
                consumerAddress: '',
                consumerEmail: '',
            }
            setArrearsDetailsRefno(emptyArearObject);
            setNoArrears('');
            return
        }
    }, [arearsFormik.values.iv_property_reference_no])

    useEffect(() => {
        callTariffList()
        callMaterials()
        const getAllNetMeterApplications = async () => {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            let currentDate = new Date()

            let year = currentDate.getFullYear();
            let month = currentDate.getMonth() + 1;
            let day = currentDate.getDate();

            let formattedCurrentDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;

            let previousMonthDate = new Date(year, month - 1, day);

            if (month === 1) {
                previousMonthDate.setFullYear(year - 1);
            }

            previousMonthDate.setMonth(previousMonthDate.getMonth() - 1);

            let prevMonthYear = previousMonthDate.getFullYear();
            let prevMonthMonth = previousMonthDate.getMonth() + 1;
            let prevMonthDay = previousMonthDate.getDate();

            let formattedPreviousMonthDate = `${prevMonthYear}-${prevMonthMonth.toString().padStart(2, '0')}-${prevMonthDay.toString().padStart(2, '0')}`;

            const formdata = new FormData();
            formdata.append("divisionCode", "");
            formdata.append("startDate", formattedPreviousMonthDate);
            formdata.append("endDate", formattedCurrentDate);

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "netMetering/getAllNetMeteringApplication", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === '200') {
                        if (result.data) {
                            setNetMeterApplications(result.data)
                        }
                    }
                })
                .catch((error) => console.error(error));
        }
        getAllNetMeterApplications()
    }, [])

    useEffect(() => {
        if (netMeterApplications) {
            apiToDataGridConversion()
        }
    }, [netMeterApplications]);

    useEffect(() => {
        if (referenceNumberToAllot) {
            if (referenceNumberToAllot.length === 7) {
                refNoAllocationFormik.values.iv_reference_to_allot = partialValue + referenceNumberToAllot
            }
            else {
                refNoAllocationFormik.values.iv_reference_to_allot = partialValue
            }
        }
    }, [referenceNumberToAllot])

    useEffect(() => {
        const checkRefNo = async () => {
            if (refNoAllocationFormik.values.iv_batch && refNoAllocationFormik.values.iv_reference_to_allot) {
                let refNo = refNoAllocationFormik.values.iv_batch.concat(refNoAllocationFormik.values.iv_reference_to_allot);
                if (refNo.length === 14) {
                    setViewBackdrop(true);
                    let apiResponse = await dBillAPI(token, refNo)
                    if (apiResponse.status) {
                        setRefNoAlreadyAllocatedError("Reference No. already allocated!")
                    } else if (apiResponse.status == false) {
                        setRefNoAlreadyAllocatedError('No Data Found against this Reference Number.')
                    } else {
                        setRefNoAlreadyAllocatedError('')
                    }
                    setViewBackdrop(false);
                }
            }
        };
        checkRefNo();
    }, [refNoAllocationFormik.values.iv_batch, refNoAllocationFormik.values.iv_reference_to_allot]);

    useEffect(() => {
        setPartialValue(dialogRowData.subDivisionCode)
    }, [dialogRowData])

    useEffect(() => {
        if (fieldItemFormik.values.iv_fieldItemId) {
            let item = allMaterialList.find(item => item.Id === fieldItemFormik.values.iv_fieldItemId)
            fieldItemFormik.values.iv_fieldItemRate = item.Rate
            fieldItemFormik.values.iv_fieldItemUnit = item.Unit
        }
    }, [fieldItemFormik.values.iv_fieldItemId])

    useEffect(() => {

        if (foundId && foundId !== '') {
            setFoundInNc(foundId)
        }
    }, [foundId])

    useEffect(() => {
        if (foundInNc) {
            let allApps = JSON.parse(window.localStorage.getItem('new-connection-applications'));

            if (allApps) {
                setNetMeterApplications(allApps)
            }
        }
    }, [foundInNc])

    useLayoutEffect(() => {
        if (netMeterApplications.length >= 1) {
            if (foundInNc && foundInNc !== '') {
                handleRowClick(foundInNc)
            }
        }
    }, [netMeterApplications])

    //#endregion

    const tblColumns = [
        { field: "applicationId", type: 'text', headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'date', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "dGInstalledCapacity", headerName: 'Installed Capacity', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicantCNIC", headerName: 'Applicant CNIC.', sortable: false, filterable: false, align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicationProgressId", sortable: false, filterable: false, headerName: 'Description', align: 'left', headerStyle: tableStyle.headerStyle, cellClassName: 'super-app-theme--cell', headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '12px' } },
        {
            field: "applicationStatusId",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            headerName: "Status",
            sortable: false, filterable: false,
            type: 'singleSelect',
            flex: 1,
            align: 'center',
            valueOptions: ['Pending', 'In Process', 'Approved', 'Completed', 'Objection'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return (
                    <div className={getClassName(btnText)} >{btnText}</div>
                )
            }
        },
        {
            headerName: "e-File",
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '15px' },
            field: 'buttons',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onViewEfile = async (e, applicationId) => {
                    e.stopPropagation();
                    await downloadEFile(applicationId);
                };

                const buttonStyle = { backgroundColor: 'white', border: '1px solid #006ad1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly', borderRadius: '3px', marginRight: '5px', cursor: 'pointer' }

                return (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            {/* {
                                params.applicationProgressId === "Demand Note Payment" &&
                                <button onClick={(e) => { e.stopPropagation(); downloadDNPDF(params.applicationId) }} style={buttonStyle} ><PrintIcon sx={{ color: '#006ad1' }} /> <p>DN</p></button>
                            }
                            {
                                (params.applicationProgressId === "Service Connection Order" || params.applicationProgressId === "Meter Installation") &&
                                <button onClick={(e) => { e.stopPropagation(); downloadSCOPDF(params.applicationId) }} style={buttonStyle} ><PrintIcon sx={{ color: '#006ad1' }} /> <p>SCO</p></button>
                            }
                            {
                                params.applicationProgressId === "Completed" &&
                                <button onClick={(e) => { e.stopPropagation(); downloadMasterData(params.applicationId) }} style={buttonStyle} ><PrintIcon sx={{ color: '#006ad1' }} /> <p>CP136</p></button>
                            } */}
                            <div style={{ backgroundColor: '#006ad1', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30px', height: '30px', cursor: 'pointer', margin: 0, padding: 0 }}
                            // onClick={(e) => onViewEfile(e, params.applicationId)}
                            >
                                <img src={download} alt="E File" style={{ width: '65%' }} />
                            </div>

                        </div>
                    </>
                )
            }
        }
    ]


    return (
        <>
            {/* Applications Table */}
            <Box className='form-box'>
                <h3 className='page-title'>Net Metering</h3>
                <Box className='application-table' >
                    <div className='div-datagrid' >
                        <BasicTable
                            columns={tblColumns}
                            data={netMeterApplicationsToDataGrid}
                            handleRowClick={(params) => handleRowClick(params.applicationId)}
                            sx={tableStyle}
                            rowHeight={37.5}
                            pageSize={15}
                            rowsPerPageOptions={[15, 30, 60]}
                            rowsPageOption={false}
                            getRowStyle={(params) => {
                                return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                            }}
                        />
                    </div>
                </Box>
            </Box>
        </>
    )
}

export default ShiftingToNetMeterTable